import React, { useState, useEffect, useRef, useCallback, act } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Chart } from "chart.js";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import CurrencyDropdown from "../../Components/CustomDropdown/customCurrencyDropdown.js";
import { useDispatch, useSelector } from "react-redux";
import DropdownTest from "../../Pages/Create-Investment/ndrop";
import { useNavigate, useLocation } from "react-router-dom";
import { format, parse } from "date-fns";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import { setPortfolioInvestmentId } from "../../Redux/store/portfolioInvestmentId";
import { svgLogoBase64 } from "../../Constants/config";
import "react-toastify/dist/ReactToastify.css";
import {
  changeRequestDotTrue,
  changeRequestDotFalse,
} from "../../Redux/store/requestDots";
import {
  changeDeletedAccountTrue,
  AddClientIdAccountTrue,
  UpdateUAStatusTrue,
  changeUpdatedAccountTrue,
} from "../../Redux/store/selectedAccountDeleted";
import { changeArchivedAccountTrue } from "../../Redux/store/selectedAccountArchieved";
import {
  changeCardTrue,
  changeCardFalse,
} from "../../Redux/store/selectedCard";
import Tooltip from "../CustomToolTip/tooltip";
import "react-datepicker/dist/react-datepicker.css";
import "swiper/css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { currentAppUrl } from "../../Constants/config";
import { resetSelectedUsers } from "../../Redux/store/selectedUserSlice";
import { resetDocumentId } from "../../Redux/store/documentSlice"; // Predefined quick filters
import { setInvestmentId } from "../../Redux/store/investmentId.js";
import {
  setInvestmentIDRedux,
  setTabSelfRedux,
} from "../../Redux/store/inspecie-transfer";
import { Clipboard, ClipboardCheck } from "lucide-react"; // using lucide-react icons
import { setCardCurrencyName } from "../../Redux/store/userSlice";
import CustomDropdownWithFetch from "../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import { useRoutingNumberValidation } from "../bank-validations/use-routing-number-validation.js";

const quickFilters = [
  { label: "This Week", value: "this_week" },
  { label: "Last Week", value: "last_week" },
  { label: "This Month", value: "this_month" },
  { label: "This Year", value: "this_year" },
  { label: "Last Year", value: "last_year" },
  { label: "Custom", value: "custom" },
  { label: "All Time", value: "" },
];
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

const CustomCardSlider = ({
  componentName,
  cardData,
  defaultCard,
  ondefaultCard,
}) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [RTGSAllowed, setRTGSAllowed] = useState(true);
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const [transitError, setTransitError] = useState("");
  const [filter, setFilter] = useState("transaction");
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [totalPendingExternalBank, setTotalPendingExternalBank] = useState(0);
  const [finalConvertedAmount, setFinalConvertedAmount] = useState(0);
  const [finalConvertedRate, setFinalConvertedRate] = useState(0);

  const [showRecords, setShowRecords] = useState(10);
  const [totalPagesInvestmentList, settotalPagesInvestmentList] = useState(0);
  const [totalCountInvestmentList, settotalCountInvestmentList] = useState(10);
  const [showRecordsPortfolio, setShowRecordsPortfolio] = useState(10);
  const [isDownloadOpen, setIsDownloadOpen] = useState(null);
  const [totalCount, settotalCount] = useState(0);
  const [totalPendingRequest, setTotalPendingRequest] = useState(0);
  const [fromCustomerAccountData, setFromCustomerAccountData] = useState([]);
  const [toCustomerAccountData, setToCustomerAccountData] = useState([]);
  const [externalbankTable, setExternalbankTable] = useState([]);
  const [showRecordsExternalBank, setShowRecordsExternalBank] = useState(10);
  const [currentPageExternalBank, setCurrentPageExternalBank] = useState(1);
  const [totalPagesExternalBank, setTotalPagesExternalBank] = useState(0);
  const [totalCountExternalBank, setTotalCountExternalBank] = useState(0);
  const [searchAccount, setSearchAccount] = useState("");
  const [selectedAccounts, setSelectedAccounts] = useState(["ALL"]);
  const accountRef = useRef();
  const statusRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dotMenuOpened = useSelector((state) => state.request.requestDot);
  const navigate = useNavigate();
  const [totalPages, settotalPages] = useState(0);
  const [totalPagesPortfolio, setTotalPagesPortfolio] = useState(0);
  const [totalCountPortfolio, setTotalCountPortfolio] = useState(0);
  const [AllAccount, setAllAccounts] = useState([]);
  const [transactionAmount, setTransactionAmount] = useState(0);
  const [transactionTypeValue, setTransactionTypeValue] = useState("debit");
  const [transactionTab, setTransactionTab] = useState("addTransaction");
  const [accountBalance, setAccountBalance] = useState(0);
  const [accountDescription, setAccountDescription] = useState("");
  const [lastEdited, setLastEdited] = useState("transaction"); // "transaction" | "final"
  const [summaryDetailsPayID, setSummaryDetailsPayID] = useState(false);
  const [commentsPayID, setCommentsPayID] = useState("");
  const [transactionAmountPayID, setTransactionAmountPayID] = useState(0);
  const [isFocusedPayID, setIsFocusedPayID] = useState(false);
  const { routingNumber, routingError, handleRoutingChange, setRoutingNumber } =
    useRoutingNumberValidation();
  const [
    preSelectedCustomerNameCashAccount,
    setPreSelectedCustomerNameCashAccount,
  ] = useState({});
  const [
    preSelectedCustomerNameCashAccountTo,
    setPreSelectedCustomerNameCashAccountTo,
  ] = useState({});
  const [fromCustomerName, setFromCustomerName] = useState("");
  const [fromCustomerLabel, setFromCustomerLabel] = useState("");
  const [error, setError] = useState("");
  const [customerAccountId, setCustomerAccountId] = useState("");

  const [preSelectedFromuserAccount, setpreSelectedFromuserAccount] = useState(
    {}
  );
  const [usdRateCashAccount, setUsdRateCashAccount] = useState("");
  const [currencyRateCashAccount, setCurrencyRateCashAccount] = useState("");
  const [fromCurrencyCashAccount, setFromCurrencyCashAccount] = useState(null);
  const [fromAccountIdCashAccount, setFromAccountIdCashAccount] =
    useState(null);
  const [fromAccountIdCashAccountLabel, setFromAccountIdCashAccountLabel] =
    useState("");
  const [nabCurrencyCashAccount, setNabCurrencyCashAccount] = useState();
  const [toCustomerName, setToCustomerName] = useState("");
  const [preSelectedTouserAccount, setpreSelectedTouserAccount] = useState({});
  const [toCustomerNameLabel, setToCustomerNameLabel] = useState("");
  const [toCurrencyCashAccount, setToCurrencyCashAccount] = useState(null);
  const [toAccountIdCashAccount, setToAccountIdCashAccount] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("1M");
  const [toAccountIdCashAccountLabel, setToAccountIdCashAccountLabel] =
    useState("");
  const [isOpenRemarksPopup, setisOpenRemarksPopup] = useState(false);
  const [isClientPopupOpen, setIsClientPopupOpen] = useState(null);
  const [isPayIDPopupOpen, setIsPayIDPopupOpen] = useState(null);
  const [payId, setPayId] = useState("");

  const [isClientPopupOpenUA, setIsClientPopupOpenUA] = useState(null);
  const [bdClientId, setBdClientId] = useState("");
  const [filterText, setFilterText] = useState("created_at");
  const [isLoading, setIsLoading] = useState(true);
  const buttonRefs = useRef({});
  const buttonDownloadRefs = useRef({});
  const [thirdPartyFilterTab, setThirdPartyFilterTab] = useState("allThp");

  const statusButtonRefs = useRef({});
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageInvestmentList, setCurrentPageInvestmentList] = useState(1);
  const [currentPagePortfolio, setCurrentPagePortfolio] = useState(1);
  const [stockPrices, setStockprices] = useState([]);
  const [rawData, setrawData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const DateCalendarRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryInvestmentList, setSearchQueryInvestmentList] =
    useState("");
  const [searchQueryPortfolio, setSearchQueryPortfolio] = useState("");
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const [isOpenEditCashAccount, setisOpenEditCashAccount] = useState(false);
  const [isOpenEditCashAccountBank, setIsOpenEditCashAccountBank] =
    useState(false);
  const [isOpenStock, setisOpenStock] = useState(false);
  const [isOpenAccount, setisOpenAccount] = useState(false);

  const [transactionTableData, setTransactionTableData] = useState(null);
  const dropdownRef = useRef();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isOpenStatus, setisOpenStatus] = useState(false);
  const [status, setStatus] = useState("");
  const inputRef = useRef(null);
  const inputRefFinal = useRef(null);
  const inputRefAccountFee = useRef(null);
  const inputRefAccountFeeBuffer = useRef(null);
  const inputRefCashAccount = useRef(null);
  const inputRefAccountBalance = useRef(null);
  const [currentBank, setcurrentBank] = useState({});
  const [portfolioAccounttableData, setPortfolioAccounttableData] = useState(
    []
  );
  const [currentMandateID, setCurrentMandateID] = useState({});
  const [billerCode, setBillerCode] = useState("");
  const [billerRefnumber, setBillerRefnumber] = useState("");

  const inputRefMandateAmount = useRef(null);
  const [showRecordsMandate, setShowRecordsMandate] = useState(10);
  const [currentPageMandate, setCurrentPageMandate] = useState(1);
  const [totalPagesMandate, setTotalPagesMandate] = useState(0);
  const [totalCountMandate, setTotalCountMandate] = useState(0);
  const [mandateTable, setMandateTable] = useState([]);
  const [copied, setCopied] = useState(false);
  const inputRefPayID = useRef(null);
  const [userPayId, setUserPayID] = useState("");
  const clearAllFieldsPayId = () => {
    setUserPayID("");
    setCreationDate("");
    setTransactionAmountPayID(0);
    setCommentsPayID("");
    setSummaryDetailsPayID(false);
  };
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      showToast("Pay ID copied!", "success");
      setTimeout(() => setCopied(false), 2000); // reset after 2 sec
    });
  };
  const handleChangeAmountPayID = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setTransactionAmountPayID(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefPayID.current) {
          inputRefPayID.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const bankType = [
    { value: 1, label: "External Bank" },
    { value: 2, label: "Third Party Bank" },
  ];

  const [preselectedBankType, setpreselectedBankType] = useState({
    value: 1,
    label: "External Bank",
  });
  const [bankTypeValue, setBankTypeValue] = useState(1);
  const [bankTypeLabel, setBankTypeLabel] = useState("External Bank");

  const [tableData, setTableData] = useState([]);
  const AllRiskProfile = [];
  AllRiskProfile.push({
    value: "",
    label: "ALL",
  });
  AllRiskProfile.push({
    value: "medium",
    label: "Medium",
  });
  AllRiskProfile.push({
    value: "high",
    label: "High",
  });
  AllRiskProfile.push({
    value: "low",
    label: "Low",
  });
  const [balanceData, setBalancesData] = useState(0);
  const [totalWithdrawData, setTotalWithdraw] = useState(0);
  const [totalDepositData, setTotalDepositData] = useState(0);
  const [graphData, setGraphdata] = useState([]);
  const [chartInstance, setChartInstance] = useState(null);
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(false);
  const chartRef = useRef(null);
  const DownloadRef = useRef();
  const DownloadRefPortfolio = useRef();
  const DownloadAccountRef = useRef();
  const [selectAll, setSelectAll] = useState(false);
  const [isOpenReport, setIsOpenReport] = useState(false);
  const [isOpenDownloadReport, setIsOpenDownloadReport] = useState(false);
  const [isOpenDownloadReportPortfolio, setIsOpenDownloadReportPortfolio] =
    useState(false);
  const [selected, setSelected] = useState("Download Report");
  const [bufferAmount, setBufferAmount] = useState(0);
  const [selectedRisk, setSelectedRisk] = useState("");
  const [customerNameDataTo, setCustomerNameDataTo] = useState([]);
  const [customerNameDataFrom, setCustomerNameDataFrom] = useState([]);
  const [pdfData, setPdfData] = useState([]);
  const [pdfDataPortfolio, setPdfDataPortfolio] = useState([]);
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden
  const [isHiddenTablePortfolio, setIsHiddenTablePortfolio] = useState(false); // Initially hidden
  const [isHiddenTableAccount, setIsHiddenTableAccount] = useState(false); // Initially hidden
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const getCurrentMonthYear = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const today = new Date();
    const month = months[today.getMonth()]; // Get month name
    const year = today.getFullYear(); // Get current year
    return `${month}, ${year}`; // Format as "Jan, 2025"
  };
  const [hinNumber, setHinNumber] = useState("");
  const [isfetchExist, setIsFetchExist] = useState(false);
  const [file, setFile] = useState(null);
  const [manualEntryVisible, setManualEntryVisible] = useState(false);
  const [manualStockCode, setManualStockCode] = useState("");
  const [manualQuantity, setManualQuantity] = useState("");
  const [manualStockName, setManualStockName] = useState("");
  const [manualStockList, setManualStockList] = useState([]);
  const [isFetchStrategyCheck, setIsFetchStrategyCheck] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editCode, setEditCode] = useState("");
  const [editQuantity, setEditQuantity] = useState("");
  const [editPurchasedDate, setEditPurchasedDate] = useState("");
  const [manualPurchasedDate, setManualPurchasedDate] = useState("");
  const [hinClientId, sethinClientId] = useState("");
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [summaryDetails, setSummaryDetails] = useState(false);
  const [hinOverallClientId, setHinOverallClientId] = useState("");
  const [accountFee, setAccountFee] = useState("");
  const [accountFeeError, setAccountFeeError] = useState("");
  const [isFocusedAccountBalance, setIsFocusedAccountBalance] = useState(false);
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);

  const [selectedCurrency, setSelectedCurrency] = useState(cardCurrencyName);

  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedcardCurrency, setpreselectedcardCurrency] = useState({
    value: cardCurrencyName.value,
    label: cardCurrencyName.label,
  });
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const [countryCode, setCountryCode] = useState("AU");
  const [activeCard, setActiveCard] = useState(null); // State to track which card is active
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const StatusRef = useRef();
  const [swiftError, setSwiftError] = useState("");
  const unallocatedHeaders = [
    { label: "Code", key: "stock_asx" },
    { label: "Name", key: "email_address" },
    { label: "Quantity", key: "quantity" },
    { label: "Purchased Date", key: "purchase_date" },
    { label: "Status", key: "purchase_date" },
  ];
  const [unAllocatedList, setunAllocatedList] = useState([]);
  const transactionTypeSecond = [
    { value: "rtgs", label: "RTGS" },
    { value: "international", label: "International" },
    { value: "normal", label: "Overnight" },
  ];
  const [
    preselectedTransactionTypeSecond,
    setPreselectedTransactionTypeSecond,
  ] = useState({ value: "rtgs", label: "RTGS" });
  const [nabFees, setNabFees] = useState("");
  const [isCheckedSecond, setIsCheckedSecond] = useState(false);
  const [transactionTypeValueSecond, setTransactionTypeValueSecond] =
    useState("rtgs");
  const [preselectedRecurringType, setPreselectedRecurringType] = useState({
    value: "daily",
    label: "Daily",
  });
  const [transactionTypeNameSecond, setTransactionTypeNameSecond] =
    useState("rtgs");
  const [recStartDate, setRecStartDate] = useState("");
  const [recEndDate, setRecEndDate] = useState("");
  const [recurringTypeValue, setRecurringTypeValue] = useState("never");
  const [recurringTypeLabel, setRecurringTypeLabel] = useState("Never");
  const getCurrentDate = () => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // Adjust for timezone
    return today.toISOString().split("T")[0]; // Get YYYY-MM-DD format
  };
  const [bankAccountData, setBankAccountData] = useState([]);
  const [thirdPartyBankAccountData, setThirdPartyBankAccountData] = useState(
    []
  );

  const [allBanks, setAllBanks] = useState([]);
  const [customerOptionsTo, setCustomerOptionsTo] = useState([]);
  const [customerOptionsFrom, setCustomerOptionsFrom] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedFinal, setIsFocusedFinal] = useState(false);

  const [isFocusedAccountFee, setIsFocusedAccountFee] = useState(false);
  const [isFocusedAccountFeeBuffer, setIsFocusedFeeBuffer] = useState(false);

  const [transactionTypeName, setTransactionTypeName] = useState("Debit");
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [toAccountName, setToAccountName] = useState("");
  const [newAccountName, setNewAccountName] = useState("");
  const [newBankAccountName, setNewBankAccountName] = useState("");

  const [toCurrency, setToCurrency] = useState("");
  const [toAccountNumber, setToAccountNumber] = useState("");
  const [toBank, setToBank] = useState("");
  const [toBsb, setToBsb] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [bsbError, setBsbError] = useState("");
  const [transitNumber, setTransitNumber] = useState("");
  const [iban, setIban] = useState("");
  const [institutionNumber, setinstitutionNumber] = useState("");
  const europeanCountryCodes = new Set([
    "AL",
    "AD",
    "AM",
    "AT",
    "AZ",
    "BY",
    "BE",
    "BA",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "GE",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "KZ",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "MD",
    "MC",
    "ME",
    "NL",
    "MK",
    "NO",
    "PL",
    "PT",
    "RO",
    "RU",
    "SM",
    "RS",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "UA",
    "GB",
    "VA",
  ]);
  const [isModalOpenAccountEdit, setIsModalOpenAccountEdit] = useState(false);
  const [acccountName, setAccountName] = useState("");
  const [accountCurrency, setAccountCurrency] = useState("");
  const [isOpenProcessPayment, setIsOpenProcessPayment] = useState(false);
  const [mandateAmount, setMandateAmount] = useState(0);
  const [mandateID, setMandateID] = useState("");

  const [selectedStatusMandate, setSelectedStatusMandate] = useState(null);
  const [isMandateAvailable, setIsMandateAvailable] = useState(false);
  const [isFocusedMandateAmount, setIsFocusedMandateAmount] = useState(false);
  const [currentAccount, setcurrentAccount] = useState({});
  const [isOpenAddMandate, setIsOpenAddMandate] = useState(false);
  const [isStatusOpenMandate, setIsStatusOpenMandate] = useState(false);
  const [preSelectedFilterMandate, setpreSelectedFilterMandate] = useState({
    value: 10,
    label: "10",
  });
  const [mandateTerm, setMandateTerm] = useState("variable");
  const [mandateFrequency, setMandateFrequency] = useState("adhoc");
  const [preselectedMandateTerm, setpreselectedMandateTerm] = useState({
    value: "variable",
    label: "Variable",
  });
  const mandateTermsData = [
    { value: "variable", label: "Variable" },
    { value: "fixed", label: "Fixed" },
  ];
  const mandateFrequencyData = [
    { value: "adhoc", label: "Adhoc" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "fortnightly", label: "Fortnightly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "halfyearly", label: "Half Year" },
    { value: "yearly", label: "Yearly" },
  ];
  const [preselectedMandateFrequency, setpreselectedMandateFrequency] =
    useState({ value: "adhoc", label: "Adhoc" });
  const togglePopupProcessPayment = () => {
    setIsOpenProcessPayment(!isOpenProcessPayment);
  };
  const togglePopupAddMandate = () => {
    setIsOpenAddMandate(!isOpenAddMandate);
  };
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const handleSelectMandateTerm = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setMandateTerm(selectedOption.value);
  };
  const handleSelectMandateFrequency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setMandateFrequency(selectedOption.value);
  };
  const handleshowRecordMandates = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsMandate(parseInt(selectedOption.value));
    setCurrentPageMandate(1);
  };
  // Step 2: Function to check if a code is European
  function isEuropeanCountry(code) {
    return europeanCountryCodes.has(code.toUpperCase());
  }
  const mandateHeaders = [
    { label: "#", key: "" },
    { label: "ID", key: "" },
    { label: "Amount", key: "" },
    { label: "Frequncy", key: "" },
    { label: "Type", key: "" },
    { label: "Status", key: "" },
    { label: "Action", key: "" },
  ];
  const recurringTypes = [
    { value: "never", label: "Never" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];
  const Allfavourites = [
    { value: "all", label: "ALL" },
    { value: "fav", label: "Favorite" },
    { value: "non-fav", label: "Non-Favorite" },
  ];
  const AllStatusFilters = [
    { value: null, label: "ALL" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
    { value: "pending", label: "Pending" },
  ];
  const AllStatusFiltersMandate = [
    { value: null, label: "ALL" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "InActive" },
  ];
  const AllStatusExternal = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];
  const externalAccountHeaders = [
    { label: "Date", key: "" },
    { label: "Account Name", key: "" },
    { label: "Account Number/IBAN", key: "" },
    { label: "Account BSB", key: "" },
    { label: "Bank Name", key: "" },
    { label: "Other Details", key: "" },
    { label: "Bank Address", key: "" },
    { label: "Country Code", key: "" },
    { label: "Status", key: "" },
    { label: "Action", key: "" },
  ];
  const [selectedFavourite, setSelectedFavourite] = useState("all");
  const handleSelectfavourite = async (option) => {
    setSelectedFavourite(option.value);
    setIsfavouriteOpen(false);
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleChangeMandateAmount = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setMandateAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefMandateAmount.current) {
          inputRefMandateAmount.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const formatDateForFilterNew = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`; // Format as yyyy-dd-mm
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const handleSelectCardCurrency = (selectedOption) => {
    setSelectedCurrency(selectedOption.label);
    dispatch(setCardCurrencyName(selectedOption));
    setpreselectedcardCurrency(selectedOption);
  };
  const handleChangeBankType = (selectedOption) => {
    setpreselectedBankType(selectedOption);
    setBankTypeValue(selectedOption.value);
    setBankTypeLabel(selectedOption.label);
    if (transactionTypeValue == "credit") {
      setFromAccountNumber("");
      setFromCurrencyCashAccount("");
    } else {
      setToAccountNumber("");
      setToCurrencyCashAccount("");
    }
    if (
      transactionTypeValue == "debit" &&
      transactionTypeValueSecond == "international"
    ) {
      setUsdRateCashAccountTo(0);
      setFinalConvertedAmount(0);
    }
  };
  const handleChangeAmountBalance = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setAccountBalance(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountBalance.current) {
          inputRefAccountBalance.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const handleChangeAmount = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setTransactionAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setLastEdited("transaction");
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  };
  const handleChangeAmountFinal = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setFinalConvertedAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setLastEdited("final");
      setTimeout(() => {
        if (inputRefFinal.current) {
          inputRefFinal.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const handleChangeAmountFee = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setminimumInvestment(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountFee.current) {
          inputRefAccountFee.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const handleChangeAmountFeeBuffer = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setBufferAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountFeeBuffer.current) {
          inputRefAccountFeeBuffer.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const addBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = "";
    if (transactionTab === "addBank") {
      apiUrl = `${BASE_URL}/v1/account/external-bank/add`;
      bodyData = {
        bank_name: toBank,
        account_number: toAccountNumber.replace(/\s+/g, ""),
        account_bsb: toBsb,
        account_name: toAccountName,
        currency_id: toCurrency,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_line3: addressLine3,
        country_code: countryCode,
        user_id: activeCard.customerId,
        swift_code: swiftCode,
        routing_number: routingNumber,
        institution_number: institutionNumber,
        transit_number: transitNumber,
        iban: iban.replace(/\s+/g, ""),
      };
    } else {
      apiUrl = `${BASE_URL}/v1/account/external-bank/add/external`;
      bodyData = {
        bank_name: toBank,
        account_number: toAccountNumber,
        account_bsb: toBsb,
        account_name: toAccountName,
        currency_id: toCurrency,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_line3: addressLine3,
        country_code: countryCode,
        swift_code: swiftCode,
        routing_number: routingNumber,
        institution_number: institutionNumber,
        transit_number: transitNumber,
        iban: iban.replace(/\s+/g, ""),
        user_id: activeCard.customerId,
      };
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addBank();
        if (response.status == 201) {
          setisOpenEditCashAccount(false);
          setisOpenEdit(false);
          setIsOpenEditCashAccountBank(false);
          if (componentName == "dashboard") {
            getAllBanksDataAdmin();
          }
          toastMessage = {
            message:
              "Bank added successfully. Please check your authenticator app to verify the request and proceed",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      activeCard,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
      componentName,
    ] // Dependencies
  );
  const addMandate = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = "";
    apiUrl = `${BASE_URL}/v1/payment-mandate/create`;
    bodyData = {
      user_id: activeCard.customerId,
      max_amount: Number(mandateAmount),
      currency_id: 2,
      terms_type: mandateTerm,
      frequency: mandateFrequency,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddMandate = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addMandate();
        if (response.status == 201) {
          togglePopupAddMandate();
          setMandateID(response.data.mandate_id);
          setIsMandateAvailable(true);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [mandateAmount, activeCard, mandateTerm, mandateFrequency] // Dependencies
  );
  const processMandate = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = "";
    apiUrl = `${BASE_URL}/v1/payment-mandate/payment-swipe`;
    bodyData = {
      mandate_id: currentMandateID.mandate_id,
      amount: Number(mandateAmount),
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleProcessMandate = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await processMandate();
        if (response.status == 200) {
          togglePopupProcessPayment();

          toastMessage = { message: response.message, type: "success" };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [mandateAmount, currentMandateID] // Dependencies
  );
  const addCashAccount = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/account/sub-account`;
    let bodyData = {
      name: newAccountName,
      balance: accountBalance,
      account_id: customerAccountId == "" ? null : customerAccountId,
      fee: minimumInvestment,
      fee_buffer: bufferAmount,
      currency_id: toCurrency,
      user_id: activeCard.customerId,
      description: accountDescription,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddCashAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addCashAccount();
        if (response.status == 201) {
          setisOpenAccount(false);
          dispatch(changeUpdatedAccountTrue());
          toastMessage = {
            message: "Account Created Successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newAccountName,
      accountBalance,
      minimumInvestment,
      bufferAmount,
      accountDescription,
      toCurrency,
      activeCard,
      customerAccountId,
    ] // Dependencies
  );
  const handleRecurringType = (selectedOption) => {
    setRecurringTypeValue(selectedOption.value);
    setRecurringTypeLabel(selectedOption.label);
  };
  const handleTransactionTypeSecond = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setTransactionTypeValueSecond(selectedOption.value);
    setTransactionTypeNameSecond(selectedOption.label);
    setPreselectedTransactionTypeSecond(selectedOption);

    if (transactionTypeValue == "debit" && selectedOption.value == "rtgs") {
      setNabFees(domesticPayment);
    }
    if (
      transactionTypeValue == "debit" &&
      selectedOption.value == "international"
    ) {
      setNabFees(internationalPayment);
    }
    if (transactionTypeValue == "debit" && selectedOption.value == "normal") {
      setNabFees(directDebit);
    }
  };
  const toggleTableSelection = (customer) => {
    setSelectedCustomers((prev) => {
      const isSelected = prev.some((c) => c.id === customer.id);
      let updated;

      if (isSelected) {
        updated = prev.filter((c) => c.id !== customer.id); // Deselect
      } else {
        updated = [...prev, customer]; // Select
      }

      // Automatically update "Select All" checkbox state
      setSelectAll(updated.length === unAllocatedList.length);

      return updated;
    });
  };
  const getSettingsData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(`/v1/settings/all`);
      if (response.status == 200) {
        const directCreditFee = response.data.find(
          (item) => item.name === "DIRECT_CREDIT_FEE"
        );
        setDirectCredit(parseFloat(directCreditFee.value).toFixed(2) || "");
        const directdebitFee = response.data.find(
          (item) => item.name === "DIRECT_DEBIT_FEE"
        );
        setDirectDebit(parseFloat(directdebitFee.value).toFixed(2) || "");
        const domesticPaymenth = response.data.find(
          (item) => item.name === "DOMESTIC_PAYMENT_RTGS_FEE"
        );
        setDomesticPayment(parseFloat(domesticPaymenth.value).toFixed(2) || "");

        const internationalPaymenth = response.data.find(
          (item) => item.name === "INTERNATIONAL_PAYMENT_WITHOUT_CONVERSION"
        );
        setInternationalPayment(
          parseFloat(internationalPaymenth.value).toFixed(2) || ""
        );
        setNabFees(parseFloat(domesticPaymenth.value).toFixed(2) || "");
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const toggleSelectAll = () => {
    if (selectAll) {
      // Deselect all
      setSelectedCustomers([]);
    } else {
      // Select only customers with pending status
      const pendingCustomers = unAllocatedList.filter(
        (customer) => customer.status === "PENDING"
      );
      setSelectedCustomers(pendingCustomers);
    }
    setSelectAll(!selectAll); // Toggle select all state
  };
  const handleAddManualStock = () => {
    if (!manualStockCode || !manualQuantity || !manualPurchasedDate) return;

    const newStock = {
      code: manualStockCode.toUpperCase(),
      stock_name: manualStockName || "Custom Stock",
      quantity: parseInt(manualQuantity),
      purcahsed_date: manualPurchasedDate,
    };

    setManualStockList([...manualStockList, newStock]);
    setManualStockCode("");
    setManualQuantity("");
    setManualStockName("");
    setManualPurchasedDate("");
    setIsFetchStrategyCheck(false);
  };
  const handleUpdateSave = (index) => {
    const updatedList = [...manualStockList];
    updatedList[index] = {
      ...updatedList[index],
      code: editCode.toUpperCase(),
      quantity: Number(editQuantity),
      purcahsed_date: editPurchasedDate,
    };
    setManualStockList(updatedList);
    setEditIndex(null);
    setIsFetchStrategyCheck(false);
  };
  const handleDeleteManualStock = (indexToDelete) => {
    const updatedList = manualStockList.filter(
      (_, index) => index !== indexToDelete
    );
    setManualStockList(updatedList);
    setIsFetchStrategyCheck(false);
  };
  const handleSelectStatus = async (option) => {
    setSelectedStatus(option.value);
    setIsStatusOpen(false);
    setCurrentPageExternalBank(1);
  };
  const handleSelectStatusMandate = async (option) => {
    setSelectedStatusMandate(option.value);
    setIsStatusOpenMandate(false);
    setCurrentPageMandate(1);
  };
  const handleEdit = (index) => {
    const item = manualStockList[index];
    setEditCode(item.code);
    setEditQuantity(item.quantity);
    setEditPurchasedDate(item.purcahsed_date || "");
    setEditIndex(index);
  };
  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }

  const toggleDownloadDropdown = (accountId) => {
    setIsDownloadOpen((prevId) => (prevId === accountId ? null : accountId));
  };
  const toggleClientPop = (accountId) => {
    sethinClientId("");
    setIsClientPopupOpen((prevId) => (prevId === accountId ? null : accountId));
  };
  const togglePayIDPop = (accountId) => {
    setPayId("");
    setIsPayIDPopupOpen((prevId) => (prevId === accountId ? null : accountId));
  };
  const toggleClientPopupUA = () => {
    setHinOverallClientId("");
    setIsClientPopupOpenUA(!isClientPopupOpenUA);
  };
  const chartData = {
    labels: graphData.map((point) => point.month), // Labels for each month
    datasets: [
      {
        label: "Account Balance",
        data: graphData.map((point) => point.balance), // Values for each month
        backgroundColor: "#8DAAE8", // Bar color
        borderColor: "#8DAAE8",
        borderWidth: 2,
        borderRadius: 5, // Rounds the edges of the bars
        hoverBackgroundColor: "#8DAAE8",
        hoverBorderColor: "black",
      },
    ],
  };
  useEffect(() => {
    setActiveCard(defaultCard); // Set the default card on initial render
  }, [defaultCard]);
  useEffect(() => {
    // Ensure the graphData and chartRef are available before proceeding
    if (graphData.length > 0 && chartRef.current) {
      if (!chartInstance) {
        // Create a new chart instance only if it doesn't exist
        const newChartInstance = new Chart(chartRef.current, {
          type: "bar", // Chart type
          data: chartData,
          options: chartOptions,
        });
        setChartInstance(newChartInstance); // Save the instance
      } else {
        // Update the existing chart instance
        chartInstance.data = chartData; // Update the data
        chartInstance.update(); // Re-render the chart
      }
    }

    // Cleanup function to destroy the chart instance
    return () => {
      if (chartInstance) {
        chartInstance.destroy();
        setChartInstance(null); // Reset the instance
      }
    };
  }, [graphData]);

  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [preSelectedFilterInvestmentList, setpreSelectedFilterInvestmentList] =
    useState({
      value: 10,
      label: "10",
    });
  const [preSelectedFilterUnallocated, setpreSelectedFilterUnallocated] =
    useState({
      value: 10,
      label: "10",
    });
  const [currentPageUnallocated, setCurrentPageUnallocated] = useState(1);
  const [showRecordsUnallocated, setShowRecordsUnallocated] = useState(10);
  const [showRecordsInvestmentList, setShowRecordsInvestmentList] =
    useState(10);
  const [totalCountUnallocated, setTotalCountUnallocated] = useState(0);
  const [totalPagesUnallocated, setTotalPagesUnallocated] = useState(0);
  const [directCredit, setDirectCredit] = useState("");
  const [directDebit, setDirectDebit] = useState("");
  const [domesticPayment, setDomesticPayment] = useState("");
  const [internationalPayment, setInternationalPayment] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [sortkey, setSortKey] = useState("minimum_investment");
  const [isHidden, setIsHidden] = useState(false);
  const DownloadDocRef = useRef();
  const riskRef = useRef();
  const [isModalOpenBankEdit, setIsModalOpenBankEdit] = useState(false);
  const [currencyRateCashAccountTo, setCurrencyRateCashAccountTo] =
    useState("");
  const [usdRateCashAccountTo, setUsdRateCashAccountTo] = useState("");

  const handleSelect = async (option) => {
    setSelectedRisk(option.value);
    setIsOpenRisk(false);
  };
  const handleScroll = () => {
    console.log("In scroll, I am scroll event listener.");

    if (isDropdownOpen !== null) {
      setIsDropdownOpen(null);
    }
  };

  const handleChangeIban = (e) => {
    const value = e.target.value.toUpperCase(); // IBANs are uppercase
    setIban(value);
  };

  function setCountryCodeEdit(countryCode) {
    const match = countryCodeData.find((c) => c.value === countryCode);
    if (match) {
      setpreselectedCountryCode({
        value: match.value,
        label: match.label,
      });
    } else {
      // Optional: set a default if no match found
      setpreselectedCountryCode({
        value: "",
        label: "",
      });
    }
  }
  const editBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/account/external-bank/update/${currentBank}`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber.replace(/\s+/g, ""),
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban.replace(/\s+/g, ""),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editBank();
        if (response.status == 200) {
          setcurrentBank(null);
          setIsModalOpenBankEdit(false);
          getAllBanksDataAdmin();

          toastMessage = {
            message: "Bank edited successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      currentBank,
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      activeCard,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const handleEditClickBank = (e, rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode("AU");
      setCountryCodeEdit("AU");
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: "AUD",
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }

    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const formatNumber = (value) => {
    if (!value) return "";
    // Remove non-numeric characters except dot
    const number = value.replace(/,/g, "");
    return Number(number).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Handle user input
  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setNabTransactionAmount(rawValue); // Store raw value without commas

      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  };
  const handleChangeCashAccountAmount = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setNabTransactionAmountCashAccount(rawValue); // Store raw value without commas

      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefCashAccount.current) {
          inputRefCashAccount.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const AllStatus = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
    { label: "All", value: "" },
  ];
  const AllStatusAdvisor = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
    { label: "Pending", value: "pending" },
    { label: "All", value: "" },
  ];
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );
      const isOutsideStatus = !Object.values(statusButtonRefs.current).some(
        (ref) => ref?.contains(event.target)
      );
      const isOutsideDownload = !Object.values(buttonDownloadRefs.current).some(
        (ref) => ref?.contains(event.target)
      );

      if (isOutside) {
        setActiveDropdownId(null); // Close dropdown if clicked outside
      }
      if (isOutsideStatus) {
        setIsMenuOpen(null); // Close dropdown if clicked outside
      }
      if (DownloadRef.current && !DownloadRef.current.contains(event.target)) {
        setIsOpenDownloadReport(false);
      }
      if (isOutsideDownload) {
        setIsDownloadOpen(null);
      }
      if (
        DownloadDocRef.current &&
        !DownloadDocRef.current.contains(event.target)
      ) {
        setIsOpenReport(false);
      }
      if (
        DownloadDocRef.current &&
        !DownloadDocRef.current.contains(event.target)
      ) {
        setIsOpenReport(false);
      }
      if (riskRef.current && !riskRef.current.contains(event.target)) {
        setIsOpenRisk(false);
      }
      if (
        favouriteRef.current &&
        !favouriteRef.current.contains(event.target)
      ) {
        setIsfavouriteOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);
  const downloadPDF = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReportInvestment();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `My Investment List-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setIsOpenReport(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          const response = await GetAPIcalls(
            selectedRisk == ""
              ? `/v1/user/${activeCard.customerId}/my-investment/list?sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
              : `/v1/user/${activeCard.customerId}/my-investment/list?risk_rating=${selectedRisk}&sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
          );
          if (response.status == 200) {
            if (response.data.data.length > 0) {
              setPdfData(response.data.data);
              setIsHidden(true);
            } else {
              setPdfData([]);
              setIsHidden(false);
              setIsOpenReport(false);
              setLoading(false);
              showToast("No data available to generate the report.", "error");
            }
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          setIsOpenReport(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [
      selectedRisk,
      sortkey,
      selectedFavourite,
      currentPage,
      searchQuery,
      sortConfig,
      activeCard,
    ] // Dependencies
  );
  const handleAccountListChange = (option) => {
    setSelectedAccounts((prev) => {
      if (option.value === "ALL") {
        // If "ALL" is selected, replace the array with only "ALL"
        return prev.includes("ALL") ? [] : ["ALL"];
      } else {
        // If a regular option is selected
        const updatedAccounts = prev.includes(option.value)
          ? prev.filter((item) => item !== option.value) // Remove if already selected
          : [...prev.filter((item) => item !== "ALL"), option.value]; // Add and remove "ALL" if necessary
        return updatedAccounts;
      }
    });
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const handleBlur = () => {
    // getAll();
  };
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenRisk, setIsOpenRisk] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(null); // Tooltip state
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const toggleDropdownAccount = (accountId) => {
    setActiveDropdownId((prevId) => (prevId === accountId ? null : accountId));
  };
  const reportOptions = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];
  const options = ["Archive", "Delete"];
  const DeleteAccount = async (accountId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/dashboard/customer/sub-account/${accountId}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const UpdateHinNumber = async (accountId) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/account/bell-direct/client-id`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      user_id: activeCard.customerId,
      sub_account_id: accountId,
      bd_client_id: hinClientId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const UpdateHinNumberOverall = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/external-stocks/add-client-id`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      user_id: Number(activeCard.customerId),
      bd_client_id: hinOverallClientId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const UpdateStockStaus = async (action) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/external-stocks/bulk-action`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const output = {
      actions: selectedCustomers.map((item) => ({
        submission_id: item.id,
        action: action,
        notes: `${action} after review`,
        bd_client_id: bdClientId,
        // Uncomment if bd_client_id is needed:
      })),
    };

    const bodyData = output;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdateAccept = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateStockStaus(action);
        if (response.status == 200) {
          getAllUserUnallocatedAccounts();
          setSelectedCustomers([]);
          dispatch(UpdateUAStatusTrue());
          toastMessage = {
            message:
              action == "approve"
                ? "Approval completed successfully"
                : "Request rejected successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [selectedCustomers, bdClientId] // Dependencies
  );
  const handleOptionClick = async (option, accountId) => {
    if (option == "Delete") {
      try {
        const response = await DeleteAccount(accountId);
        if (response.status == 200) {
          dispatch(changeDeletedAccountTrue());
          // getAllUserTransactions();
          // getAllUserAccounts();
        } else {
          showToast(response.message, "error");
        }
      } catch (err) {
        showToast(err.message, "error");
      }
    }
    if (option == "Archive") {
      try {
        const response = await ArchivingAccount(accountId);
        if (response.status == 200) {
          dispatch(changeArchivedAccountTrue());
          getAllUserTransactions();
          getAllUserAccounts();
          // dispatch(changeCardFalse());
        } else {
          showToast(response.message, "error");
        }
      } catch (err) {
        showToast(err.message, "error");
      }
    }
    setActiveDropdownId(null);
  };
  const getAccountBalancesData = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/dashboard/account-balances?currency=${cardCurrencyName.label}`
          : `/v1/dashboard/account-balances?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setGraphdata(response.data.monthly_balances);
        setBalancesData(response.data);
        if (chartInstance) {
          chartInstance.destroy();
          setChartInstance(null); // Reset the instance
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      if (err.status === 400) {
      }
      setGraphdata([]);
      setBalancesData([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getTotalWithdrawData = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/dashboard/total-withdrawals?currency=${cardCurrencyName.label}`
          : `/v1/dashboard/total-withdrawals?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setTotalWithdraw(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setTotalWithdraw([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      setTotalWithdraw([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getTotalDepositData = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/dashboard/total-deposits?currency=${cardCurrencyName.label}`
          : `/v1/dashboard/total-deposits?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setTotalDepositData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setTotalDepositData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      setTotalDepositData([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const resetAllFiltersCashAccount = () => {
    setPreselectedTransactionType({
      value: "debit",
      label: "Debit",
    });
    setTransactionTypeValue("debit");
    setPreselectedTransactionTypeSecond({ value: "rtgs", label: "RTGS" });
    setTransactionTypeValueSecond("rtgs");
    setTransactionTypeNameSecond("rtgs");
    setNabFees(domesticPayment);
    setIsCheckedSecond(false);
    setPreselectedRecurringType({
      value: "never",
      label: "Never",
    });
    setRecurringTypeValue("never");
    setRecurringTypeLabel("Never");
    setRecStartDate("");
    setRecEndDate("");
    setCommentsCashAccount("");
    setCreationDate("");
    setTransactionAmount(0);
    setPreSelectedCustomerNameCashAccount({});
    setFromCustomerName("");
    setpreSelectedFromuserAccount({});
    handleFromAccountHolderNumber({});
    setUsdRateCashAccountTo("");
    setFinalConvertedAmount(0);
    setUsdRateCashAccount("");
    setFromCurrencyCashAccount("");
    setUsdRateCashAccountTo("");
    setFinalConvertedAmount(0);
    setNabCurrencyCashAccount("");
    setFromAccountIdCashAccount(null);
    setFromCustomerAccountData([]);
    setUsdRateCashAccount("");
    setCurrencyRateCashAccount("");
    setFromAccountNumber("");
    setPreSelectedCustomerNameCashAccountTo({});
    setToCustomerName("");
    setpreSelectedTouserAccount({});
    handleToAccountHolderNumber({});
    setToCurrencyCashAccount("");
    setToAccountIdCashAccount(null);
    setToCustomerAccountData([]);
    setToAccountNumber("");
    setSummaryDetails(false);
    setpreselectedBankType({
      value: 1,
      label: "External Bank",
    });
    setBankTypeValue(1);
    setBankTypeLabel("External Bank");
    setBillerCode("");
    setBillerRefnumber("");
  };
  const resetAllThpFilters = () => {
    setShowRecordsExternalBank(10);
    setCurrentPageExternalBank(1);
  };
  const resetAllFiltersCustomers = () => {
    setPreselectedTransactionType({
      value: "debit",
      label: "Debit",
    });
    setTransactionTypeValue("debit");
    setPreselectedTransactionTypeSecond({ value: "rtgs", label: "RTGS" });
    setTransactionTypeValueSecond("rtgs");
    setTransactionTypeNameSecond("rtgs");
    setNabFees(domesticPayment);
    setIsCheckedSecond(false);
    setPreselectedRecurringType({
      value: "never",
      label: "Never",
    });
    setRecurringTypeValue("never");
    setRecurringTypeLabel("Never");
    setRecStartDate("");
    setRecEndDate("");
    setCommentsCashAccount("");
    setCreationDate("");
    setTransactionAmount(0);
    setPreSelectedCustomerNameCashAccount({});
    setpreSelectedFromuserAccount({});
    handleFromAccountHolderNumber({});
    setFromCurrencyCashAccount("");
    setUsdRateCashAccountTo("");
    setFinalConvertedAmount(0);
    setNabCurrencyCashAccount("");
    setFromAccountIdCashAccount(null);
    setFromCustomerAccountData([]);
    setUsdRateCashAccount("");
    setCurrencyRateCashAccount("");
    setFromAccountNumber("");
    setPreSelectedCustomerNameCashAccountTo({});
    setpreSelectedTouserAccount({});
    handleToAccountHolderNumber({});
    setToCurrencyCashAccount("");
    setToAccountIdCashAccount(null);
    setToCustomerAccountData([]);
    setToAccountNumber("");
    setSummaryDetails(false);
    setFromCustomerName(activeCard.customerId);
    setToCustomerName(activeCard.customerId);
    setpreselectedBankType({
      value: 1,
      label: "External Bank",
    });
    setBankTypeValue(1);
    setBankTypeLabel("External Bank");
  };
  const resetAllFilters = () => {
    setSearchAccount("");
    setSelectedAccounts(["ALL"]);
    setSearchQuery("");
    setSelectedDates([]);
    setSelectedRange("Select Date Range");
    setQuickFilter("");
    setTransactionStatus("");
    setCurrentPage(1);
    setShowRecords(10);
    setExpandedRow(null);
    setSearchQueryPortfolio("");
    setCurrentPagePortfolio(1);
    setShowRecordsPortfolio(10);
    setpreSelectedFilter({ value: 10, label: "10" });
  };
  const handleBsbChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setToBsb(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError("BSB is required");
    } else if (numericValue.length !== 6) {
      setBsbError("BSB must be 6 digits");
    } else {
      setBsbError("");
    }
  };
  const handleTransitChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setTransitNumber(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError("Transit number is required");
    } else if (numericValue.length !== 5) {
      setTransitError("Transit number must be 5 digits");
    } else {
      setTransitError("");
    }
  };
  const togglePopupAddTransaction = () => {
    resetAllFiltersCustomers();
    clearAllFieldsBank();
    setTransactionTab("addTransaction");
    setisOpenEdit(!isOpenEdit);
  };
  const clearAllFieldsBank = () => {
    setToAccountName("");
    setpreselectedCurrency({ value: 2, label: "AUD" });
    setpreselectedCountryCode({ value: "AU", label: "Australia" });
    setAddressLine1("");
    setToAccountNumber("");
    setToBank("");
    setAddressLine2("");
    setToBsb("");
    setCountryCode("AU");
    setToCurrency(2);
    setAddressLine3("");
    setSwiftCode("");
    setRoutingNumber("");
    setTransitNumber("");
    setIban("");
    setinstitutionNumber("");
  };
  const clearCashAccountFields = () => {
    setNewAccountName("");
    setpreselectedCurrency({ value: 2, label: "AUD" });
    setAccountDescription("");
    setAccountBalance(0);
    setminimumInvestment(0);
    setBufferAmount(0);
    setToCurrency(2);
  };
  const togglePopupAddTransactionCashAccount = () => {
    resetAllFiltersCashAccount();
    clearAllFieldsBank();
    setTransactionTab("addTransaction");
    setisOpenEditCashAccount(!isOpenEditCashAccount);
  };
  const togglePopupAddBankCashAccount = () => {
    clearAllFieldsBank();
    setIsOpenEditCashAccountBank(!isOpenEditCashAccountBank);
  };
  const togglePopupAddStocks = () => setisOpenStock(!isOpenStock);
  const togglePopupAddAccount = () => {
    clearCashAccountFields();
    setisOpenAccount(!isOpenAccount);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setisOpenStatus(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  useEffect(() => {
    if (selectedDates.length === 2) {
      const formattedRange = `${formatDate(
        selectedDates[0].toLocaleDateString()
      )} — ${formatDate(selectedDates[1].toLocaleDateString())}`;
      setSelectedRange(formattedRange);
    }
  }, [selectedDates]);

  useEffect(() => {
    if (
      lastEdited === "transaction" &&
      usdRateCashAccount > 0 &&
      usdRateCashAccountTo > 0
    ) {
      const rate = usdRateCashAccount / usdRateCashAccountTo;
      setFinalConvertedAmount((transactionAmount * rate).toFixed(2));
    }
  }, [usdRateCashAccount, usdRateCashAccountTo, transactionAmount, lastEdited]);
  useEffect(() => {
    if (usdRateCashAccount > 0 && usdRateCashAccountTo > 0) {
      setFinalConvertedRate(
        (usdRateCashAccount / usdRateCashAccountTo).toFixed(2)
      );
    }
  }, [usdRateCashAccount, usdRateCashAccountTo]);
  useEffect(() => {
    if (
      lastEdited === "final" &&
      usdRateCashAccount > 0 &&
      usdRateCashAccountTo > 0
    ) {
      const reverseRate = usdRateCashAccountTo / usdRateCashAccount;
      setTransactionAmount((finalConvertedAmount * reverseRate).toFixed(2));
    }
  }, [usdRateCashAccount, usdRateCashAccountTo, finalConvertedAmount]);
  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;
    setCurrentPage(1);

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
  };
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };

  const ArchivingAccount = async (accountId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/dashboard/customer/sub-account/archieve/${accountId}`;
    const bodyData = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const UpdateRequestStatusCall = async (optionValue, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/transaction/${rowId}`;
    const bodyData = {
      status: optionValue,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };

  function formatDateTransaction(inputDateString) {
    const cleanedDate = inputDateString.replace(/ [A-Z]{3,4}$/, ""); // Removes " AEDT"

    // Parse and format
    const parsedDate = parse(cleanedDate, "dd/MM/yyyy hh:mm:ss a", new Date());
    return format(parsedDate, "dd/MM/yyyy | HH:mm:ss");
  }
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setpreSelectedFilterUnallocated(selectedOption);
    setShowRecordsUnallocated(parseInt(selectedOption.value));
    setCurrentPageUnallocated(1);
  };
  const handleFilterChangeInvestmentList = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsInvestmentList(parseInt(selectedOption.value));
    setCurrentPageInvestmentList(1);
  };
  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleshowRecordPortfolios = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsPortfolio(parseInt(selectedOption.value));
    setCurrentPagePortfolio(1);
  };
  const handleshowRecordBank = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsExternalBank(parseInt(selectedOption.value));
    setCurrentPageExternalBank(1);
  };
  const headers = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Running Balance", key: "" },
    { label: "Transaction Status", key: "" },
    { label: "", key: "" },
  ];
  const headersDashboard = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Running Balance", key: "" },
    { label: "Transaction Status", key: "" },
    { label: "Gateway Status", key: "" },
    { label: "", key: "" },
  ];
  const headersDashboardPortfolio = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Running Balance", key: "" },
    { label: "Transaction Status", key: "" },
    { label: "", key: "" },
  ];

  const withOutheadersRequestDashboard = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Request Status", key: "" },
    { label: "Gateway Status", key: "" },
    { label: "", key: "" },
    { label: "", key: "" },
  ];
  const withOutheadersRequest = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Request Status", key: "" },
    { label: "", key: "" },
    { label: "", key: "" },
  ];
  const toggleRowDetails = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const [SettlementAccountData, preSelectedPlatformAccount] = useState({
    value: 1,
    label: "test1",
  });
  const [preselectedcashAccount, setpreselectedcashAccount] = useState({});
  const [comments, setComments] = useState("");
  const [commentsCashAccount, setCommentsCashAccount] = useState("");

  const [transactionStatusRemarks, setTransactionStatusRemarks] = useState("");
  const [customerNameData, setCustomerNameData] = useState([]);
  const [nabTransactionType, setNabTransactionType] = useState("");
  const [creationDateNab, setCreationDateNab] = useState("");
  const [nabTransactionAmount, setNabTransactionAmount] = useState(0);
  const [branchIdentifierData, setBranchIdentifierData] = useState([]);
  const [fromBranchIdentifier, setFromBranchIdentifier] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [fromCurrency, setFromCurrency] = useState("");
  const [fromBank, setFromBank] = useState("");
  const [fromAccountName, setFromAccountName] = useState("");
  const [fromBsb, setFromBsb] = useState("");
  const [fromBranchAddress, setFromBranchAddress] = useState("");
  const [fromAccountNumber, setFromAccountNumber] = useState("");
  const [fromAccountId, setFromAccountId] = useState(null);
  const [nabTransactionAmountCashAccount, setNabTransactionAmountCashAccount] =
    useState(0);
  const [preSelecteduserAccount, setpreSelecteduserAccount] = useState({});
  const [transactionStatus, setTransactionStatus] = useState("");
  const [preselectedTransactionType, setPreselectedTransactionType] = useState({
    value: "debit",
    label: "Debit",
  });
  const [transactionRemarksId, setTransactionRemarksId] = useState(null);
  const [transactionRemarksStatus, setTransactionRemarksStatus] =
    useState(null);
  const [IsfavouriteOpen, setIsfavouriteOpen] = useState(false);
  const favouriteRef = useRef();

  const [creationDate, setCreationDate] = useState("");

  const transactionType = [
    { value: "debit", label: "Debit" },
    { value: "credit", label: "Credit" },
    { value: "transfer", label: "Transfer" },
  ];
  const transactionTypeMore = [
    { value: "debit", label: "Debit" },
    { value: "credit", label: "Credit" },
    { value: "transfer", label: "Transfer" },
    { value: "billPayment", label: "Bill Payment" },
  ];
  const handleTransactionType = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setTransactionTypeValue(selectedOption.value);
    setTransactionTypeName(selectedOption.label);
    setPreselectedTransactionType(selectedOption);
    setFromCustomerLabel("");
    setPreSelectedCustomerNameCashAccount({});
    setpreSelectedFromuserAccount({});
    handleFromAccountHolderNumber({});
    setFromCurrencyCashAccount("");
    setUsdRateCashAccountTo("");
    setFinalConvertedAmount(0);
    setNabCurrencyCashAccount("");
    setFromAccountIdCashAccount(null);
    setFromAccountNumber("");
    setPreSelectedCustomerNameCashAccountTo({});
    setpreSelectedTouserAccount({});
    handleToAccountHolderNumber({});
    setToCurrencyCashAccount("");
    setToAccountIdCashAccount(null);
    setToCustomerAccountData([]);
    setToAccountNumber("");
    setBillerCode("");
    setBillerRefnumber("");
    if (componentName == "dashboard") {
      setFromCustomerName("");
      setToCustomerName("");
    } else {
      setFromCustomerName(activeCard.customerId);
      setToCustomerName(activeCard.customerId);
    }

    if (selectedOption.value == "credit") {
      setNabFees(directCredit);
    }
    if (selectedOption.value == "debit") {
      setNabFees(domesticPayment);
    }

    //testing
    if (selectedOption.value === "debit") {
      setCustomerOptionsTo(customerNameDataTo);
    } else {
      setCustomerOptionsTo(customerNameDataFrom);
    }
    if (
      selectedOption.value === "debit" ||
      selectedOption.value === "transfer" ||
      selectedOption.value === "billPayment"
    ) {
      setCustomerOptionsFrom(customerNameDataFrom);
    } else {
      setCustomerOptionsFrom(customerNameDataTo);
    }
  };
  const handleFromAccountHolderNumber = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setFromAccountIdCashAccount(selectedOption.value);
    setFromAccountIdCashAccountLabel(selectedOption.label);

    setNabCurrencyCashAccount(selectedOption.currencyId);
    setFromCurrencyCashAccount(selectedOption.currencyName);
    setUsdRateCashAccount(selectedOption.usd_rate);
    setCurrencyRateCashAccount(selectedOption.account_currency_rate);
    setFromAccountNumber(selectedOption.accountNumber);
    setpreSelectedFromuserAccount(selectedOption);
  };
  const handleToAccountHolderNumber = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToAccountIdCashAccount(selectedOption.value);
    setToAccountIdCashAccountLabel(selectedOption.label);
    setpreSelectedTouserAccount(selectedOption);
    setToCurrencyCashAccount(selectedOption.currencyName);
    setToAccountNumber(selectedOption.accountNumber);
    setCurrencyRateCashAccountTo(selectedOption.account_currency_rate);
    setUsdRateCashAccountTo(selectedOption.usd_rate);
  };
  const handleStatusChange = useCallback(
    debounce(async (e, option, rowId) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await UpdateRequestStatusCall(option, rowId);
        if (response.status == 200) {
          setStatus(rowId + option);
          togglePopupEditRemarks(false);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [transactionRemarksStatus, transactionRemarksId] // Dependencies
  );
  const handleStatusChangeCustomer = async (e, option, rowId) => {
    e.preventDefault();
    let toastMessage = null;
    try {
      const response = await UpdateRequestStatusCall(option, rowId);
      if (response.status == 200) {
        setStatus(rowId + option);
        togglePopupEditRemarks(false);
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleSelectCustomerNameCashAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    if (selectedOption.value == null) {
      setFromCustomerName("-1");
    } else {
      setFromCustomerName(selectedOption.value);
    }
    setFromCustomerLabel(selectedOption.label);
    setPreSelectedCustomerNameCashAccount(selectedOption);
    setpreSelectedFromuserAccount({});
    handleFromAccountHolderNumber({});
    setUsdRateCashAccountTo("");
    setFinalConvertedAmount(0);
    setUsdRateCashAccount("");
    setFromCurrencyCashAccount("");
    setNabCurrencyCashAccount("");
    setFromAccountIdCashAccount(null);
    setFromAccountNumber("");
  };
  const handleSelectCustomerNameCashAccountTo = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    if (selectedOption.value == null) {
      setToCustomerName("-1");
    } else {
      setToCustomerName(selectedOption.value);
    }
    setToCustomerNameLabel(selectedOption.label);
    setPreSelectedCustomerNameCashAccountTo(selectedOption);
    setpreSelectedTouserAccount({});
    handleToAccountHolderNumber({});
    setToCurrencyCashAccount("");
    setToAccountNumber("");

    setToAccountIdCashAccount(null);
  };
  const portfolioAccountheaders = [
    { label: "Investment ID", key: "investment ID" },
    { label: "Investment Product Name", key: "productName" },
    { label: "Balance", key: "accountBalance" },
    { label: "", key: "" },
  ];
  const handleSort = (key) => {
    setFilterText(key);
  };

  const handleCardClick = (card) => {
    if (card.id == "1" || card.id == "2") {
      setActiveCard(card);
      ondefaultCard(card);
      setSelectedFilter("1M");
      setFilter("transaction");
      resetAllFilters();
    }
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      localStorage.removeItem("jwtToken");
      navigate("/login");
      showToast("Session expired. Please log in again.", "error");
    }
    if (card.id == "3" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/securities?bTok=${token}`;
    }
    if (card.id == "4" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/fum?bTok=${token}`;
    }
    if (card.id == "5" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/custodian?bTok=${token}`;
    }
    if (card.id == "6" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/my-investment?bTok=${token}`;
    }
    if (card.id == "7" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/crypto?bTok=${token}`;
    }
    if (card.id == "8" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/property?bTok=${token}`;
    }
    if (card.id == "9" && componentName == "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/account-report/commodities?bTok=${token}`;
    }

    //Customer
    if (card.id == "3" && componentName != "dashboard") {
      // window.location.href = 'https://www.google.com'
      let x = `${currentAppUrl}/customer-account/securities/68?bTok=${token}`;
      window.location.href = `${currentAppUrl}/customer-account/securities/${activeCard.customerId}?bTok=${token}`;
    }
    if (card.id == "4" && componentName != "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/customer-account/fum/${activeCard.customerId}?bTok=${token}`;
    }
    if (card.id == "5" && componentName != "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/customer-account/custodian/${activeCard.customerId}?bTok=${token}`;
    }
    if (card.id == "6" && componentName != "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/customer-account/commodities/${activeCard.customerId}?bTok=${token}`;
    }
    if (card.id == "7" && componentName != "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/customer-account/crypto/${activeCard.customerId}?bTok=${token}`;
    }
    if (card.id == "8" && componentName != "dashboard") {
      // window.location.href = 'https://www.google.com'
      window.location.href = `${currentAppUrl}/customer-account/my-investment/${activeCard.customerId}?bTok=${token}`;
    }
  };
  const labelsLine = rawData
    ? rawData.map((item) => {
        const date = new Date(item.date); // Parse the date
        return date; // Return Date object (Chart.js can parse Date objects)
      })
    : [];

  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        backgroundColor:
          activeCard && activeCard.id == "1" ? "#8DAAE8" : "#996EE7",
        borderColor: "#4A90E2",
        borderWidth: 1,
        titleColor: "#000000",
        bodyColor: "white",
        displayColors: false,
        callbacks: {
          title: (tooltipItems) => {
            const timestamp = tooltipItems[0].parsed.x; // <-- reliable timestamp
            const date = new Date(timestamp);
            if (selectedFilter === "1M" || selectedFilter === "3M") {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });
              const year = date.getFullYear();
              return `${day} ${month} ${year}`;
            } else {
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              return `${month}/${year}`;
            }
          },
          label: (tooltipItem) => {
            // Format the label as $<value>
            return `$${tooltipItem.raw
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        type: "time", // Ensure the x-axis uses time scale
        time: {
          unit:
            selectedFilter === "1M" ||
            selectedFilter === "3M" ||
            selectedFilter === "6M"
              ? "day"
              : "month",
          tooltipFormat:
            selectedFilter === "1M" ||
            selectedFilter === "3M" ||
            selectedFilter === "6M"
              ? "MMM d (EEE)"
              : "MMM yyyy",
        },
        grid: { drawOnChartArea: false, drawTicks: false },
        ticks: {
          display: true,
          color: "black",

          callback: function (value) {
            const date = new Date(value);

            if (
              selectedFilter === "1M" ||
              selectedFilter === "3M" ||
              selectedFilter === "6M"
            ) {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });

              return [day, month];
            } else {
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              }); // e.g., Jan
              const year = date.getFullYear();
              return [month, year];
            }
          },
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: "black" },
        afterFit: function (scale) {
          scale.height = 60; // Adjust the height to ensure space for two lines
        },
      },
      y: {
        grid: {
          drawOnChartArea: true, // Show grid lines on the chart area
          drawTicks: false, // Optionally hide ticks on grid lines
          color: "rgba(0, 0, 0, 0.1)", // Set the color of the grid lines (light gray)
          lineWidth: 1, // Set the line width of the grid lines
        },
        ticks: {
          callback: (value) => `${value.toFixed(2)}`,
          color: "black",
          padding: 10, // Add spacing for Y-axis labels
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        offset: true, // Add extra space between the border and the graph
        border: { display: false },
      },
    },
  };
  const dataLine = {
    labels: labelsLine,
    datasets: [
      {
        label: "Price",
        data: stockPrices,
        borderColor: activeCard && activeCard.id == "1" ? "#8DAAE8" : "#996EE7",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(
            0,
            activeCard && activeCard.id == "1"
              ? "rgba(74, 144, 226, 0.1)"
              : "rgba(153, 110, 231, 0.1)"
          ); // Light blue at the top
          gradient.addColorStop(1, "white"); // White at the bottom

          return gradient;
        },
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor:
          activeCard && activeCard.id == "1" ? "#8DAAE8" : "#996EE7",
      },
    ],
  };
  useEffect(() => {
    if (activeCard == null) {
      dispatch(changeCardFalse({}));
    } else {
      dispatch(changeCardTrue(activeCard.id));
    }
  }, [activeCard]);
  // useEffect(() => {
  //   if (isOpenEdit == true && activeCard != null) {
  //     getAllUserAccountsPopup();
  //   }
  // }, [isOpenEdit]);
  useEffect(() => {
    if (isMenuOpen == null) {
      dispatch(changeRequestDotFalse());
    } else {
      dispatch(changeRequestDotTrue());
    }
  }, [isMenuOpen]);
  useEffect(() => {
    if (
      transactionTypeValue == "debit" &&
      transactionTypeValueSecond == "rtgs"
    ) {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentTime = currentHour + currentMinute / 60;

      const startTime = 9; // 9:00 AM
      const endTime = 15; // 3:00 PM

      if (currentTime >= startTime && currentTime <= endTime) {
        setRTGSAllowed(true);
      } else {
        setRTGSAllowed(false);
      }
    }
  }, [transactionTypeValue, transactionTypeValueSecond]);
  const swiperRef = useRef(null); // Reference to Swiper instance

  const handleNextClick = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext(); // Go to next slide
    }
  };
  const togglePopupEditRemarks = () => {
    setisOpenRemarksPopup(!isOpenRemarksPopup);
    setTransactionStatusRemarks("");
  };
  const data = {
    accountBalance: {
      title: "Account Balance",
      date: "Nov, 2023",
      activeAccounts: "8",
      activePercent: "80%",
      portfolio: "$827,234,289.60",
      graphData: [
        { month: "Jan", value: 20 },
        { month: "Feb", value: 80 },
        { month: "Mar", value: 60 },
        { month: "Apr", value: 90 },
        { month: "May", value: 90 },
        { month: "Jun", value: 90 },
        { month: "Jul", value: 20 },
        { month: "Aug", value: 30 },
        { month: "Sep", value: 50 },
        { month: "Oct", value: 30 },
        { month: "Nov", value: 20 },
        { month: "Dec", value: 50 },
      ],
    },
    totalDeposit: {
      title: "Total Deposit",
      date: "Nov, 2023",
      currentAmount: "$827,234,289.60",
      previousAmount: "$0.00",
      previousDate: "Aug, 2023",
    },
    totalWithdrawal: {
      title: "Total Withdrawal",
      date: "Nov, 2023",
      currentAmount: "$827,234,289.60",
      previousAmount: "$0.00",
      previousDate: "Aug, 2023",
    },
  };

  const chartOptions = {
    responsive: true,

    plugins: {
      legend: {
        display: false, // Remove the legend
      },
      tooltip: {
        enabled: true, // Disable the default tooltip

        backgroundColor: "black",
        borderColor: "black",
        borderWidth: 1,
        titleColor: "#8DAAE8",
        bodyColor: "white",
        position: "average", // Tooltip positioned at the nearest point

        displayColors: false, // Remove the color box next to the tooltip text

        callbacks: {
          title: (tooltipItems) => {
            const monthAbbr = tooltipItems[0].label;
            const date = new Date(`${monthAbbr} 1, 2025`);
            const options = { month: "long" };
            const fullMonthName = date.toLocaleString("en-US", options);
            return `${fullMonthName} Portfolio Balance`;
          },
          label: (tooltipItem) => {
            // Format the label as $<value>
            return `        $${tooltipItem.raw.toFixed(2)}    `;
          },
        },
        padding: 10, // Padding inside the tooltip for spacing
      },
    },
    scales: {
      y: {
        grid: {
          drawOnChartArea: true,
          color: "rgba(0, 0, 0, 0.08)", // Set grid line color
          lineWidth: 1, // Set grid line thickness
          drawTicks: false,
        },
        ticks: {
          display: false, // Hide tick marks on the Y-axis
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        border: { display: false },
        max: Math.max(...graphData.map((point) => point.balance)) * 1.1, // Dynamic scaling of Y-axis
      },
      x: {
        grid: {
          display: false, // Remove grid lines on the X-axis
        },
        ticks: {
          display: true,
          color: "black",
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
  };

  const lineGraphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hides the legend
      },
      tooltip: {
        enabled: false, // Disables tooltips on hover
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Removes x-axis grid lines
          drawBorder: false, // Disables the axis border
          drawTicks: false, // Disables axis ticks
        },
        ticks: {
          display: false, // Hides x-axis labels
        },
        border: { display: false },
      },
      y: {
        grid: {
          display: false, // Removes y-axis grid lines
          drawBorder: false, // Disables the axis border
          drawTicks: false, // Disables axis ticks
        },
        ticks: {
          display: false, // Hides y-axis labels
        },
        border: { display: false },
      },
    },
    elements: {
      point: {
        radius: 0, // Removes data points
      },
    },
  };

  const handleAddTransacionCashAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addTransactionCashAccount();
        if (response.status == 200) {
          const isDashboard = componentName === "dashboard";
          const shouldSetFilter = filter !== "request";

          if (shouldSetFilter) {
            setFilter("request");
          } else {
            isDashboard
              ? getAllDashboardTransactions()
              : getAllUserTransactions();
          }
          setCustomerOptionsFrom([]);
          setCustomerOptionsTo([]);
          isDashboard
            ? togglePopupAddTransactionCashAccount()
            : setisOpenEdit(false);
          if (!isDashboard && transactionTypeValue == "transfer") {
            dispatch(changeUpdatedAccountTrue());
          }
          toastMessage = {
            message: "Transaction created successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      fromCustomerName,
      toCustomerName,
      fromAccountIdCashAccount,
      toAccountIdCashAccount,
      nabCurrencyCashAccount,
      nabTransactionAmountCashAccount,
      commentsCashAccount,
      usdRateCashAccount,
      currencyRateCashAccount,
      transactionAmount,
      transactionTypeValue,
      creationDate,
      transactionTypeValueSecond,
      finalConvertedRate,
      finalConvertedAmount,
      billerCode,
      billerRefnumber,
    ] // Dependencies
  );
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GetInvestmentList = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    // const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    let x = selectedAccounts;
    if (selectedDates.length == 2) {
      apiUrl = `${BASE_URL}/v1/transaction/customer/${
        activeCard.customerId
      }?page=${currentPage}&search=${searchQuery}&status=${
        filter == "request"
          ? "pending,approved_web"
          : "approved,approved_by_admin,failed,cancelled,completed"
      }&account_type=${
        activeCard.id == "1" ? "cash_account" : "private_wealth_account"
      }&size=${showRecords}&start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl = `${BASE_URL}/v1/transaction/customer/${
        activeCard.customerId
      }?page=${currentPage}&status=${
        filter == "request"
          ? "pending,approved_web"
          : "approved,approved_by_admin,failed,cancelled,completed"
      }&account_type=${
        activeCard.id == "1" ? "cash_account" : "private_wealth_account"
      }&search=${searchQuery}&size=${showRecords}&account_ids=${
        selectedAccounts[0] == "ALL" ? [] : selectedAccounts
      }`;
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const GetGraphData = async (accountType) => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    const apiUrl =
      loggedInUserRole == "advisor"
        ? `${BASE_URL}/v1/advisor/dashboard/customer/sub-account/graph/${activeCard.customerId}`
        : `${BASE_URL}/v1/dashboard/customer/sub-account/graph/${activeCard.customerId}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      period: selectedFilter.toUpperCase(),
      sub_account_type: accountType,
      currency: cardCurrencyName.label,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const GetGraphDataDashboard = async (accountType) => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    const apiUrl =
      loggedInUserRole == "advisor"
        ? `${BASE_URL}/v1/advisor/dashboard/customer/sub-account/graph`
        : `${BASE_URL}/v1/dashboard/customer/sub-account/graph`;

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      period: selectedFilter.toUpperCase(),
      sub_account_type: accountType,
      currency: cardCurrencyName.label,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getBankAccountData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/external-bank/list?user_id=${
          transactionTypeValue == "debit"
            ? // ?
              //   56
              // : 56
              Number(toCustomerName)
            : Number(fromCustomerName)
        }&status=approved`
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.banks.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.account_name,
            accountNumber: profile.account_number,
            currencyId: profile.currency.id,
            bankName: profile.bank_name,
            usd_rate: profile.currency.rate,
            currencyName: profile.currency.name,
          });
        });
        setBankAccountData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setBankAccountData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getThirdPartyBankAccountData = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/account/external-bank/list/external?user_id=${
              transactionTypeValue == "debit"
                ? // ?
                  //   56
                  // : 56
                  Number(toCustomerName)
                : Number(fromCustomerName)
            }&status=approved&limit=100`
          : `/v1/account/external-bank/list/external?user_id=${
              transactionTypeValue == "debit"
                ? // ?
                  //   56
                  // : 56
                  Number(toCustomerName)
                : Number(fromCustomerName)
            }&status=approved&limit=100`
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.bank_accounts.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.account_name,
            accountNumber: profile.account_number,
            currencyId: profile.currency.id,
            usd_rate: profile.currency.rate,
            bankName: profile.bank_name,
            currencyName: profile.currency.name,
          });
        });
        setThirdPartyBankAccountData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setThirdPartyBankAccountData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllBanksData = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/account/external-bank/list/external?user_id=all&status=approved&limit=100`
          : `/v1/account/external-bank/list/external?user_id=all&status=approved&limit=100`
      );

      if (
        response.status == 200 &&
        response.data &&
        response.data.bank_accounts.length > 0
      ) {
        const AccountData = [];
        response.data.bank_accounts.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.account_name,
            accountNumber: profile.account_number,
            currencyId: profile.currency.id,
            bankName: profile.bank_name,
            usd_rate: profile.currency.rate,
            currencyName: profile.currency.name,
          });
        });
        setAllBanks(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAllBanks([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllBanksDataAdmin = async () => {
    try {
      setIsLoading(true);
      const basePath =
        loggedInUserRole === "advisor"
          ? "/v1/advisor/account/external-bank/list/external"
          : "/v1/account/external-bank/list/external";

      const params = new URLSearchParams({
        user_id: "all",
        limit: showRecordsExternalBank,
        page: currentPageExternalBank,
      });

      // determine status logic
      let statusToUse = null;

      if (thirdPartyFilterTab === "allThp") {
        statusToUse = selectedStatus; // can be null
      } else {
        statusToUse = "pending";
      }

      if (statusToUse) {
        params.append("status", statusToUse);
      }

      const response = await GetAPIcalls(`${basePath}?${params.toString()}`);
      if (
        response.status == 200 &&
        response.data &&
        response.data.bank_accounts.length > 0
      ) {
        setExternalbankTable(response.data.bank_accounts);
        setTotalPagesExternalBank(response.data.total_pages);
        setCurrentPageExternalBank(response.data.page);
        setTotalCountExternalBank(response.data.total_count);
        setTotalPendingExternalBank(response.data.pending_count);
      } else {
        setExternalbankTable([]);
        setTotalPagesExternalBank(0);
        setCurrentPageExternalBank(1);
        setTotalCountExternalBank(0);
      }
    } catch (err) {
      setExternalbankTable([]);
      setTotalPagesExternalBank(0);
      setCurrentPageExternalBank(1);
      setTotalCountExternalBank(0);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getAllUserMandates = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        selectedStatusMandate == null
          ? `/v1/payment-mandate/user/${activeCard.customerId}?page_size=${showRecordsMandate}&page=${currentPageMandate}`
          : `/v1/payment-mandate/user/${activeCard.customerId}?page_size=${showRecordsMandate}&status=${selectedStatusMandate}&page=${currentPageMandate}`
      );
      if (
        response.status == 200 &&
        response.data != {} &&
        response.data.mandates &&
        response.data.mandates.length > 0
      ) {
        setMandateTable(response.data.mandates);
        setTotalPagesMandate(response.data.total_pages);
        setCurrentPageMandate(response.data.current_page);
        setTotalCountMandate(response.data.total_count);
      } else {
        setMandateTable([]);
        setTotalPagesMandate(0);
        setCurrentPageMandate(1);
        setTotalCountMandate(0);
      }
    } catch (err) {
      setExternalbankTable([]);
      setTotalPagesExternalBank(0);
      setCurrentPageExternalBank(1);
      setTotalCountExternalBank(0);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const addTransactionCashAccount = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/transaction/admin/create`;
    let bodyData = {};
    if (transactionTypeValue == "transfer") {
      bodyData = {
        from_user_id: fromCustomerName,
        to_user_id: toCustomerName,
        from_sub_account_id: fromAccountIdCashAccount,
        to_sub_account_id: toAccountIdCashAccount,
        currency_id: nabCurrencyCashAccount,
        amount: Number(transactionAmount),
        description: commentsCashAccount,
        transaction_mode: transactionTypeValue,
        date: creationDate,
        exchange_rate: finalConvertedRate,
      };
    }
    if (transactionTypeValue == "credit") {
      bodyData = {
        to_user_id: toCustomerName,
        from_bank_account_id: fromAccountIdCashAccount,
        to_sub_account_id: toAccountIdCashAccount,
        currency_id: nabCurrencyCashAccount,
        amount: Number(transactionAmount),
        description: commentsCashAccount,
        transaction_mode: "deposit",
        transaction_type: "credit",
        date: creationDate,
      };
    }
    if (transactionTypeValue == "debit") {
      bodyData = {
        from_user_id: fromCustomerName,
        from_sub_account_id: fromAccountIdCashAccount,
        to_bank_account_id: toAccountIdCashAccount,
        currency_id: nabCurrencyCashAccount,
        amount: Number(transactionAmount),
        description: commentsCashAccount,
        transaction_type: "debit",
        transaction_mode:
          transactionTypeValueSecond == "rtgs"
            ? "withdrawal_rtgs"
            : transactionTypeValueSecond == "international"
            ? "withdrawal_international"
            : "withdrawal",
        date: creationDate,
        exchange_rate:
          transactionTypeValueSecond == "international"
            ? finalConvertedRate
            : 0,
      };
    }
    if (transactionTypeValue == "billPayment") {
      bodyData = {
        from_user_id: fromCustomerName,
        from_sub_account_id: fromAccountIdCashAccount,
        currency_id: nabCurrencyCashAccount,
        amount: Number(transactionAmount),
        description: commentsCashAccount,
        transaction_mode: "bpay",
        date: creationDate,
        transaction_type: "debit",
        biller_code: billerCode,
        reference_number: billerRefnumber,
      };
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllUserTransactions = async () => {
    try {
      const response = await GetInvestmentList();

      if (response.status == 200) {
        setTransactionTableData(response.data.transactions);
        // setCurrentPage(response.data.page);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total_count);
        setTotalPendingRequest(response.data.pending_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const GetUnallocatedList = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    let apiUrl = `${BASE_URL}/v1/external-stocks/submissions/${activeCard.customerId}?page=${currentPageUnallocated}&size=${showRecordsUnallocated}`;

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllUserUnallocatedAccounts = async () => {
    try {
      const response = await GetUnallocatedList();

      if (response.status == 200) {
        setunAllocatedList(response.data.submissions);
        setBdClientId(
          response.data.bd_client_id != null ? response.data.bd_client_id : ""
        );
        setTotalPagesUnallocated(response.data.total_pages);
        setTotalCountUnallocated(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const GetDashboardPortfolios = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    // const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl =
        loggedInUserRole == "advisor"
          ? `${BASE_URL}/v1/advisor/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`
          : `${BASE_URL}/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl =
        loggedInUserRole == "advisor"
          ? `${BASE_URL}/v1/advisor/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}`
          : `${BASE_URL}/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=${showRecordsPortfolio}`;
    }
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      showToast(error.message, "error");
    }
  };
  const getAllPortfolioTransactions = async () => {
    try {
      const response = await GetDashboardPortfolios();

      if (response.status == 200) {
        if (response.data == null) {
          setTransactionTableData([]);
          setTotalPagesPortfolio(0);
          setTotalCountPortfolio(0);
        } else {
          setTransactionTableData(response.data.transactions);
          setTotalPagesPortfolio(response.data.total_pages);
          setTotalCountPortfolio(response.data.total_count);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          setTransactionTableData([]);
          setTotalPagesPortfolio(0);
          setTotalCountPortfolio(0);
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setTransactionTableData([]);
      setTotalPagesPortfolio(0);
      setTotalCountPortfolio(0);
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const GetDashboardRequest = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    // const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    if (filter == "request") {
      if (selectedDates.length == 2) {
        apiUrl = `${BASE_URL}/v1/transaction?page=${currentPage}&search=${searchQuery}&status=pending,approved_web&account_type=${
          activeCard.id == "1" ? "cash_account" : "private_wealth_account"
        }&size=${showRecords}&start_date=${formatDateForFilter(
          selectedDates[0]
        )}&end_date=${formatDateForFilter(selectedDates[1])}`;
      } else {
        apiUrl = `${BASE_URL}/v1/transaction?page=${currentPage}&status=pending,approved_web&account_type=${
          activeCard.id == "1" ? "cash_account" : "private_wealth_account"
        }&search=${searchQuery}&size=${showRecords}&account_ids=${
          selectedAccounts[0] == "ALL" ? [] : selectedAccounts
        }`;
      }
    } else {
      if (selectedDates.length == 2) {
        apiUrl =
          loggedInUserRole == "advisor"
            ? `${BASE_URL}/v1/advisor/transaction?page=${currentPage}&search=${searchQuery}&status=${
                transactionStatus == "" ? "" : transactionStatus
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&size=${showRecords}&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`
            : `${BASE_URL}/v1/transaction?page=${currentPage}&search=${searchQuery}&status=${
                transactionStatus == ""
                  ? "approved,failed,rejected,completed,deleted"
                  : transactionStatus
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&size=${showRecords}&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`;
      } else {
        apiUrl =
          loggedInUserRole == "advisor"
            ? `${BASE_URL}/v1/advisor/transaction?page=${currentPage}&status=${
                transactionStatus == "" ? "" : transactionStatus
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&search=${searchQuery}&size=${showRecords}&account_ids=${
                selectedAccounts[0] == "ALL" ? [] : selectedAccounts
              }`
            : `${BASE_URL}/v1/transaction?page=${currentPage}&status=${
                transactionStatus == ""
                  ? "approved,failed,rejected,completed,deleted"
                  : transactionStatus
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&search=${searchQuery}&size=${showRecords}&account_ids=${
                selectedAccounts[0] == "ALL" ? [] : selectedAccounts
              }`;
      }
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const getAllDashboardTransactions = async () => {
    try {
      const response = await GetDashboardRequest();

      if (response.status == 200) {
        setTransactionTableData(response.data.transactions);
        // setCurrentPage(response.data.page);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total_count);
        setTotalPendingRequest(response.data.pending_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };

  const getAllTransactionGraphdata = async (accountType) => {
    try {
      const response = await GetGraphData(accountType);

      if (response.status == 200) {
        if (
          response.data.daily_transactions &&
          response.data.daily_transactions.length > 0
        ) {
          setrawData(response.data.daily_transactions);
          const stockPrices = response.data.daily_transactions.map(
            (item) => item.amount
          );
          setStockprices(stockPrices);
        } else {
          setrawData([]);
          setStockprices([]);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getAllTransactionGraphdataDashboard = async (accountType) => {
    try {
      const response = await GetGraphDataDashboard(accountType);

      if (response.status == 200) {
        setrawData(response.data.daily_transactions);
        const stockPrices = response.data.daily_transactions.map(
          (item) => item.amount
        );
        setStockprices(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getAllUserAccounts = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/sub-accounts/user/${activeCard.customerId}?type=${
          activeCard.id == "1" ? "cash_account" : "private_wealth_account"
        }`
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.sub_accounts.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name + " - " + profile.currency.name,
          });
        });
        AllAccount.push({
          value: "ALL",
          label: "ALL",
        });
        setAllAccounts(AllAccount);
        setCustomerAccountId(response.data.account.id);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const editAccount = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/account/sub-account/${currentAccount}`;
    const bodyData = {
      user_id: activeCard.customerId,
      name: acccountName,
      description: accountDescription,
      fee: minimumInvestment,
      fee_buffer_amount: bufferAmount,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editAccount();
        if (response.status == 200) {
          setcurrentAccount(null);
          setIsModalOpenAccountEdit(false);
          dispatch(changeUpdatedAccountTrue());
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      activeCard,
      acccountName,
      accountDescription,
      minimumInvestment,
      bufferAmount,
    ] // Dependencies
  );
  const getAllUsersDashboard = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/user/customers`
          : `/v1/user/admin/users?customers=True`
      );

      if (response.status == 200) {
        let AllaccountFrom = [];
        let AllAccountTo = [];
        AllAccountTo.push({
          value: null,
          label: "Third Party Bank",
        });

        response.data.users.forEach((profile) => {
          AllaccountFrom.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
          });
          AllAccountTo.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
          });
        });
        setCustomerNameDataFrom(AllaccountFrom);
        setCustomerNameDataTo(AllAccountTo);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            symbol: profile.symbol,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllDashboardAccounts = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/account/sub-accounts/?type=${
              activeCard.id == "1" ? "cash_account" : "private_wealth_account"
            }`
          : `/v1/account/sub-accounts/?type=${
              activeCard.id == "1" ? "cash_account" : "private_wealth_account"
            }`
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.sub_accounts.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name + " - " + profile.currency.name,
          });
        });
        AllAccount.push({
          value: "ALL",
          label: "ALL",
        });
        setAllAccounts(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllDashboardPortfolioAccounts = async () => {
    setIsLoadingPortfolio(true);
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/dashboard/portfolio-management-accounts?currency=${cardCurrencyName.label}&page=${currentPage}&size=${showRecords}&search=${searchQuery}`
          : `/v1/dashboard/portfolio-management-accounts?currency=${cardCurrencyName.label}&page=${currentPage}&size=${showRecords}&search=${searchQuery}`
      );

      if (response.status == 200) {
        setPortfolioAccounttableData(response.data.data);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
        settotalPages(response.data.total_pages);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setPortfolioAccounttableData([]);
      }
    } catch (err) {
      showToast(err.message, "error");
      setPortfolioAccounttableData([]);
    } finally {
      setTimeout(() => {
        setIsLoadingPortfolio(false);
      }, 3000);
    }
  };
  const getWalletAccountsByFromCustomerId = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${toCustomerName}/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          InvestmentManagerAccountData.push({
            value: profile.id,
            label: profile.name,
            accountNumber: profile.account_number,
            currencyId: profile.currency.id,
            currencyName: profile.currency.name,
            usd_rate: profile.currency.usd_rate,
            account_currency_rate: profile.currency.account_currency_rate,
          });
        });
        setToCustomerAccountData(InvestmentManagerAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setToCustomerAccountData([]);
          setpreSelectedTouserAccount({});
          handleToAccountHolderNumber({});
        }
      }
    } catch (err) {
      setToCustomerAccountData([]);
      setpreSelectedTouserAccount({});
      handleToAccountHolderNumber({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByToCustomerId = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${
          transactionTypeValue == "debit" ||
          transactionTypeValue == "transfer" ||
          transactionTypeValue == "billPayment"
            ? // ?
              // 56 : 56
              Number(fromCustomerName)
            : Number(toCustomerName)
        }/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          InvestmentManagerAccountData.push({
            value: profile.id,
            label: profile.name,
            accountNumber: profile.account_number,
            currencyId: profile.currency.id,
            currencyName: profile.currency.name,
            currencyName: profile.currency.name,
            usd_rate: profile.currency.usd_rate,
            account_currency_rate: profile.currency.account_currency_rate,
          });
        });
        setFromCustomerAccountData(InvestmentManagerAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setFromCustomerAccountData([]);
          setpreSelectedTouserAccount({});
          handleToAccountHolderNumber({});
        }
      }
    } catch (err) {
      setFromCustomerAccountData([]);
      setpreSelectedTouserAccount({});
      handleToAccountHolderNumber({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = "";
      if (componentName == "dashboard") {
        if (activeCard && activeCard.id == "1") {
          if (filter == "request") {
            if (selectedDates.length == 2) {
              apiUrl = `/v1/transaction/export/excel?page=${currentPage}&search=${searchQuery}&status=pending,approved_web&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&size=1000&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`;
            } else {
              apiUrl = `/v1/transaction/export/excel?page=${currentPage}&status=pending,approved_web&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&search=${searchQuery}&size=1000&account_ids=${
                selectedAccounts[0] == "ALL" ? [] : selectedAccounts
              }`;
            }
          } else {
            if (selectedDates.length == 2) {
              apiUrl = `/v1/transaction/export/excel?page=${currentPage}&search=${searchQuery}&status=${
                transactionStatus == ""
                  ? "approved,failed,rejected,completed,deleted"
                  : transactionStatus
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&size=1000&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`;
            } else {
              apiUrl = `/v1/transaction/export/excel?page=${currentPage}&status=${
                transactionStatus == ""
                  ? "approved,failed,rejected,completed,deleted"
                  : transactionStatus
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&search=${searchQuery}&size=1000&account_ids=${
                selectedAccounts[0] == "ALL" ? [] : selectedAccounts
              }`;
            }
          }
        }
        if (activeCard && activeCard.id == "2") {
          if (activeCard && activeCard.id == "2") {
            if (selectedDates.length == 2) {
              apiUrl = `/v1/transaction/portfolio-management/transactions/export/excel?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`;
            } else {
              apiUrl = `/v1/transaction/portfolio-management/transactions/export/excel?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000`;
            }
          }
        }
      } else {
        if (selectedDates.length == 2) {
          apiUrl = `/v1/transaction/customer/${
            activeCard.customerId
          }/export/excel?page=${currentPage}&search=${searchQuery}&status=${
            filter == "request"
              ? "pending,approved_web"
              : "approved,approved_by_admin,failed,cancelled"
          }&account_type=${
            activeCard.id == "1" ? "cash_account" : "private_wealth_account"
          }&size=1000&start_date=${formatDateForFilter(
            selectedDates[0]
          )}&end_date=${formatDateForFilter(selectedDates[1])}`;
        } else {
          apiUrl = `/v1/transaction/customer/${
            activeCard.customerId
          }/export/excel?page=${currentPage}&status=${
            filter == "request"
              ? "pending,approved_web"
              : "approved,approved_by_admin,failed,cancelled"
          }&account_type=${
            activeCard.id == "1" ? "cash_account" : "private_wealth_account"
          }&search=${searchQuery}&size=1000&account_ids=${
            selectedAccounts[0] == "ALL" ? [] : selectedAccounts
          }`;
        }
      }
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadExcelReportInvestment = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl =
        selectedRisk == ""
          ? `/v1/user/${activeCard.customerId}/my-investment/list/export/excel?sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
          : `/v1/user/${activeCard.customerId}/my-investment/list/export/excel?risk_rating=${selectedRisk}&sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`;

      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadExcelReportAccount = async (accountId) => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = "";
      apiUrl = `/v1/transaction/customer/${
        activeCard.customerId
      }/export/excel?&account_type=${
        activeCard.id == "1" ? "cash_account" : "private_wealth_account"
      }&account_ids=${accountId}&status=${
        transactionStatus == ""
          ? "approved,approved_by_admin,failed,cancelled,pending,approved_web"
          : transactionStatus
      }`;
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReport();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download =
            activeCard && activeCard.id == "1" && filter == "request"
              ? `Requests-${formattedDate}.xlsx`
              : `Transaction History-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
          setIsOpenDownloadReport(false);
        } finally {
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          let apiUrl = "";
          if (componentName == "dashboard") {
            if (activeCard && activeCard.id == "1") {
              if (filter == "request") {
                if (selectedDates.length == 2) {
                  apiUrl = `/v1/transaction?page=${currentPage}&search=${searchQuery}&status=pending,approved_web&account_type=${
                    activeCard.id == "1"
                      ? "cash_account"
                      : "private_wealth_account"
                  }&size=1000&start_date=${formatDateForFilter(
                    selectedDates[0]
                  )}&end_date=${formatDateForFilter(selectedDates[1])}`;
                } else {
                  apiUrl = `/v1/transaction?page=${currentPage}&status=pending,approved_web&account_type=${
                    activeCard.id == "1"
                      ? "cash_account"
                      : "private_wealth_account"
                  }&search=${searchQuery}&size=1000&account_ids=${
                    selectedAccounts[0] == "ALL" ? [] : selectedAccounts
                  }`;
                }
              } else {
                if (selectedDates.length == 2) {
                  apiUrl =
                    loggedInUserRole == "advisor"
                      ? `/v1/advisor/transaction?page=${currentPage}&search=${searchQuery}&status=${
                          transactionStatus == "" ? "" : transactionStatus
                        }&account_type=${
                          activeCard.id == "1"
                            ? "cash_account"
                            : "private_wealth_account"
                        }&size=1000&start_date=${formatDateForFilter(
                          selectedDates[0]
                        )}&end_date=${formatDateForFilter(selectedDates[1])}`
                      : `/v1/transaction?page=${currentPage}&search=${searchQuery}&status=${
                          transactionStatus == ""
                            ? "approved,failed,rejected,completed,deleted"
                            : transactionStatus
                        }&account_type=${
                          activeCard.id == "1"
                            ? "cash_account"
                            : "private_wealth_account"
                        }&size=1000&start_date=${formatDateForFilter(
                          selectedDates[0]
                        )}&end_date=${formatDateForFilter(selectedDates[1])}`;
                } else {
                  apiUrl =
                    loggedInUserRole == "advisor"
                      ? `/v1/advisor/transaction?page=${currentPage}&status=${
                          transactionStatus == "" ? "" : transactionStatus
                        }&account_type=${
                          activeCard.id == "1"
                            ? "cash_account"
                            : "private_wealth_account"
                        }&search=${searchQuery}&size=1000&account_ids=${
                          selectedAccounts[0] == "ALL" ? [] : selectedAccounts
                        }`
                      : `/v1/transaction?page=${currentPage}&status=${
                          transactionStatus == ""
                            ? "approved,failed,rejected,completed,deleted"
                            : transactionStatus
                        }&account_type=${
                          activeCard.id == "1"
                            ? "cash_account"
                            : "private_wealth_account"
                        }&search=${searchQuery}&size=1000&account_ids=${
                          selectedAccounts[0] == "ALL" ? [] : selectedAccounts
                        }`;
                }
              }
            }
            if (activeCard && activeCard.id == "2") {
              if (activeCard && activeCard.id == "2") {
                if (selectedDates.length == 2) {
                  apiUrl = `/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000&start_date=${formatDateForFilter(
                    selectedDates[0]
                  )}&end_date=${formatDateForFilter(selectedDates[1])}`;
                } else {
                  apiUrl = `/v1/transaction/portfolio-management/transactions?page=${currentPagePortfolio}&search=${searchQueryPortfolio}&size=1000`;
                }
              }
            }
          } else {
            if (selectedDates.length == 2) {
              apiUrl = `/v1/transaction/customer/${
                activeCard.customerId
              }?page=${currentPage}&search=${searchQuery}&status=${
                filter == "request"
                  ? "pending,approved_web"
                  : "approved,approved_by_admin,failed,cancelled"
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&size=1000&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`;
            } else {
              apiUrl = `/v1/transaction/customer/${
                activeCard.customerId
              }?page=${currentPage}&status=${
                filter == "request"
                  ? "pending,approved_web"
                  : "approved,approved_by_admin,failed,cancelled"
              }&account_type=${
                activeCard.id == "1" ? "cash_account" : "private_wealth_account"
              }&search=${searchQuery}&size=1000&account_ids=${
                selectedAccounts[0] == "ALL" ? [] : selectedAccounts
              }`;
            }
          }

          const response = await GetAPIcalls(apiUrl);

          if (response.status == 200) {
            if (
              response.data == null ||
              response.data.transactions.length == 0
            ) {
              setPdfData([]);
              setIsHiddenTable(false);
              setLoading(false);
              setIsOpenDownloadReport(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfData(response.data.transactions);
              setIsHiddenTable(true);
            }
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfData([]);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          setLoading(false);
          setIsOpenDownloadReport(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [
      filter,
      activeCard,
      transactionStatus,
      selectedDates,
      currentPage,
      searchQuery,
      selectedAccounts,
      currentPagePortfolio,
      searchQueryPortfolio,
    ] // Dependencies
  );
  const downloadExcelReportPortfolio = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl =
        loggedInUserRole == "advisor"
          ? `/v1/advisor/dashboard/portfolio-management-accounts/export/excel?currency=${cardCurrencyName.label}&page=${currentPage}&size=1000&search=${searchQuery}`
          : `/v1/dashboard/portfolio-management-accounts/export/excel?currency=${cardCurrencyName.label}&page=${currentPage}&size=1000&search=${searchQuery}`;
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTablePortfolio = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReportPortfolio();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Portfolio Management Accounts-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          const response = await GetAPIcalls(
            loggedInUserRole == "advisor"
              ? `/v1/advisor/dashboard/portfolio-management-accounts?currency=${cardCurrencyName.label}&page=${currentPage}&size=1000&search=${searchQuery}`
              : `/v1/dashboard/portfolio-management-accounts?currency=${cardCurrencyName.label}&page=${currentPage}&size=1000&search=${searchQuery}`
          );
          if (response.status == 200) {
            if (response.data.data.length == 0) {
              setPdfDataPortfolio([]);
              setIsHiddenTablePortfolio(false);
              setLoading(false);
              setIsOpenDownloadReportPortfolio(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfDataPortfolio(response.data.data);
              setIsHiddenTablePortfolio(true);
            }
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfDataPortfolio([]);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfDataPortfolio([]);
          setLoading(false);
          setIsOpenDownloadReportPortfolio(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [currentPage, searchQuery, cardCurrencyName] // Dependencies
  );
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  function createTableBody(data, columns) {
    const body = document.createElement("tbody");

    data.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = columns
        .map(({ key, formatter }) => {
          let value = row[key];
          if (formatter) {
            value = formatter(value, row);
          }
          const styleAttr =
            key === "portfolio_name"
              ? 'style="width: 180px; white-space: normal; word-wrap: break-word; word-break: break-word;"'
              : "";

          return `<td >${value !== undefined ? value : ""}</td>`;
        })
        .join("");

      body.appendChild(tr);
    });

    return body;
  }
  const handleDownload = async (accountId, format) => {
    if (format === "pdf") {
      // Trigger PDF download
      try {
        setLoading(true);
        let apiUrl = "";
        apiUrl = `/v1/transaction/customer/${
          activeCard.customerId
        }?&account_type=${
          activeCard.id == "1" ? "cash_account" : "private_wealth_account"
        }&account_ids=${accountId}&status=${
          transactionStatus == ""
            ? "approved,approved_by_admin,failed,cancelled,pending,approved_web"
            : transactionStatus
        }`;
        const response = await GetAPIcalls(apiUrl);

        if (response.status == 200) {
          if (response.data == null || response.data.transactions.length == 0) {
            setPdfData([]);
            setIsHiddenTableAccount(false);
            setLoading(false);
            toggleDownloadDropdown(accountId);
            showToast("No data available to generate the report.", "error");
          } else {
            setPdfData(response.data.transactions);
            toggleDownloadDropdown(accountId);

            setIsHiddenTableAccount(true);
          }
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
        }
      } catch (err) {
        if (err.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setPdfData([]);
        setLoading(false);
        setIsOpenDownloadReport(false);
        showToast(err.message, "error");
      }
    } else if (format === "excel") {
      // Trigger Excel download
      setLoading(true);
      try {
        const csvBlob = await downloadExcelReportAccount(accountId);
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Transaction History-${formattedDate}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        toggleDownloadDropdown(accountId);
        setTimeout(function () {
          setLoading(false); // Ensure `loading` is false first
        }, 100);
      }
    }
  };
  const handleEditClick = (e, rowData) => {
    setcurrentAccount(rowData.id);
    setIsModalOpenAccountEdit(true);
    setAccountName(rowData.account_name);
    setminimumInvestment(rowData.fee.toString());
    setBufferAmount(rowData.fee_buffer_amount.toString());
    setAccountCurrency(rowData.currency);
  };
  const handleDownloadPDFTable = async () => {
    let headerDashboardFinal = [];
    if (activeCard && activeCard.id == "1") {
      if (componentName == "dashboard") {
        if (
          transactionTableData != null &&
          (selectedAccounts.length > 1 ||
            selectedAccounts.length == 0 ||
            selectedAccounts.includes("ALL"))
        ) {
          headerDashboardFinal = [
            {
              label: "Date & Time",
              key: "date",
              formatter: (val) => formatDateTransaction(val),
            },
            { label: "Transaction ID", key: "reference_code" },
            {
              label: "From Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit") {
                  return row.bank?.account_name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.to_account?.name || "";
                  }
                  if (row.mode == "transfer") {
                    return row.from_account?.name || "";
                  }
                }
              },
            },
            {
              label: "To Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit" || row.mode == "transfer") {
                  return row.to_account?.name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.bank?.account_name || "";
                  }
                }
              },
            },
            {
              label: "Convert Rate",
              key: "convert_rate",
              formatter: (val) => val.toFixed(2),
            },
            {
              label: "Transaction Currency",
              key: "currency",
              formatter: (_, row) => row.currency.name,
            },
            {
              label: "Debit",
              key: "debit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            {
              label: "Credit",
              key: "credit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            { label: "Transaction Status", key: "status" },
            { label: "Gateway Status", key: "gateway_status" },
          ];
        }
        if (
          transactionTableData != null &&
          selectedAccounts.length == 1 &&
          !selectedAccounts.includes("ALL")
        ) {
          headerDashboardFinal = [
            {
              label: "Date & Time",
              key: "date",
              formatter: (val) => formatDateTransaction(val),
            },
            { label: "Transaction ID", key: "reference_code" },
            {
              label: "From Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit") {
                  return row.bank?.account_name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.to_account?.name || "";
                  }
                  if (row.mode == "transfer") {
                    return row.from_account?.name || "";
                  }
                }
              },
            },
            {
              label: "To Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit" || row.mode == "transfer") {
                  return row.to_account?.name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.bank?.account_name || "";
                  }
                }
              },
            },
            {
              label: "Convert Rate",
              key: "convert_rate",
              formatter: (val) => val.toFixed(2),
            },
            {
              label: "Transaction Currency",
              key: "currency",
              formatter: (_, row) => row.currency.name,
            },
            {
              label: "Debit",
              key: "debit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            {
              label: "Credit",
              key: "credit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            {
              label: "Running Balance",
              key: "balance",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            { label: "Transaction Status", key: "status" },
            { label: "Gateway Status", key: "gateway_status" },
          ];
        }
      } else {
        if (
          transactionTableData != null &&
          (selectedAccounts.length > 1 ||
            selectedAccounts.length == 0 ||
            selectedAccounts.includes("ALL"))
        ) {
          headerDashboardFinal = [
            {
              label: "Date & Time",
              key: "date",
              formatter: (val) => formatDateTransaction(val),
            },
            { label: "Transaction ID", key: "reference_code" },
            {
              label: "From Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit") {
                  return row.bank?.account_name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.to_account?.name || "";
                  }
                  if (row.mode == "transfer") {
                    return row.from_account?.name || "";
                  }
                }
              },
            },
            {
              label: "To Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit" || row.mode == "transfer") {
                  return row.to_account?.name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.bank?.account_name || "";
                  }
                }
              },
            },
            {
              label: "Convert Rate",
              key: "convert_rate",
              formatter: (val) => val.toFixed(2),
            },
            {
              label: "Transaction Currency",
              key: "currency",
              formatter: (_, row) => row.currency.name,
            },
            {
              label: "Debit",
              key: "debit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            {
              label: "Credit",
              key: "credit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            { label: "Transaction Status", key: "status" },
          ];
        }
        if (
          transactionTableData != null &&
          selectedAccounts.length == 1 &&
          !selectedAccounts.includes("ALL")
        ) {
          headerDashboardFinal = [
            {
              label: "Date & Time",
              key: "date",
              formatter: (val) => formatDateTransaction(val),
            },
            { label: "Transaction ID", key: "reference_code" },
            {
              label: "From Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit") {
                  return row.bank?.account_name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.to_account?.name || "";
                  }
                  if (row.mode == "transfer") {
                    return row.from_account?.name || "";
                  }
                }
              },
            },
            {
              label: "To Account",
              key: "account_name",
              formatter: (_, row) => {
                if (row.mode == "deposit" || row.mode == "transfer") {
                  return row.to_account?.name || "";
                } else {
                  if (
                    row.mode == "withdrawal_rtgs" ||
                    row.mode == "withdrawal_international" ||
                    row.mode == "withdrawal"
                  ) {
                    return row.bank?.account_name || "";
                  }
                }
              },
            },
            {
              label: "Convert Rate",
              key: "convert_rate",
              formatter: (val) => val.toFixed(2),
            },
            {
              label: "Transaction Currency",
              key: "currency",
              formatter: (_, row) => row.currency.name,
            },
            {
              label: "Debit",
              key: "debit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            {
              label: "Credit",
              key: "credit",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            {
              label: "Running Balance",
              key: "balance",
              formatter: (val) =>
                val
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            },
            { label: "Transaction Status", key: "status" },
          ];
        }
      }
    }
    if (activeCard && activeCard.id == "2") {
      headerDashboardFinal = [
        {
          label: "Date & Time",
          key: "date",
          formatter: (val) => formatDateTransaction(val),
        },
        { label: "Transaction ID", key: "reference_code" },
        {
          label: "From Account",
          key: "account_name",
          formatter: (_, row) => {
            return row.from_account.name || "";
          },
        },
        {
          label: "To Account",
          key: "account_name",
          formatter: (_, row) => {
            return row.to_account.name || "";
          },
        },
        {
          label: "Convert Rate",
          key: "convert_rate",
          formatter: (val) => val.toFixed(2),
        },
        {
          label: "Transaction Currency",
          key: "currency",
          formatter: (_, row) => row.currency.name,
        },
        {
          label: "Debit",
          key: "debit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Credit",
          key: "credit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Running Balance",
          key: "balance",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        { label: "Transaction Status", key: "status" },
      ];
    }
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8" />
                <style>
                @page {
          size: A4 landscape;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 6px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
              </head>
              <body>
             <div class="pdf-container">
                <div class="custom-header">
                  <div class="logo-container">
                    <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                  </div>
                  <h2 class="title">${
                    activeCard && activeCard.id == "1" && filter == "request"
                      ? "Requests"
                      : "Transaction History"
                  }</h2>
                  <div class="date">${date}</div>
                </div>
                
          <table id="dynamic-table">
          ${tableHeader}
            ${tableBody}
        
          </table>
            
              </div> 
        
                   </body>
            </html>
          `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      activeCard && activeCard.id == "1" && filter == "request"
        ? `Requests-${formattedDate}.pdf`
        : `Transaction History-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTable(false);
    setIsOpenDownloadReport(false);
  };
  const UploadStockApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/external-stocks/bulk-submit`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const convertedArray = manualStockList.map((item) => ({
      user_id: activeCard.customerId, // or dynamically set
      asx_code: item.code,
      quantity: item.quantity,
      purchase_date: item.purcahsed_date, // match the key or fix typo if needed
      purcahse_price: "", // or assign actual price if available
      notres: "", // add notes if needed
    }));
    const bodyData = convertedArray;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  function formatDateTime(inputDateStr) {
    const date = new Date(inputDateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const yyyy = date.getFullYear();

    const HH = String(date.getHours()).padStart(2, "0");
    const MM = String(date.getMinutes()).padStart(2, "0");
    const SS = String(date.getSeconds()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy}`;
  }
  const handleDeleteFile = () => {
    setFile(null);
  };
  const handleFetchStocks = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UploadStockApi();
        if (response.status == 201) {
          getAllUserUnallocatedAccounts();
          togglePopupAddStocks();
          toastMessage = {
            message: "Data added successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setIsFetchStrategyCheck(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [hinNumber, manualStockList, activeCard] // Dependencies
  );
  const downloadExcelReportHistoricalPerformance = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(
        `${BASE_URL}/v1/external-stocks/bulk-submit/sample-csv`,
        {
          method: "GET",
          headers,
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleSampleCSV = useCallback(
    debounce(async () => {
      try {
        const csvBlob = await downloadExcelReportHistoricalPerformance();
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Sample csv template.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        setTimeout(function () {
          setLoading(false); // Ensure `loading` is false first
        }, 100);
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/external-stocks/bulk-submit/csv`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    formData3.append("user_id", activeCard.customerId);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleStockCSV = useCallback(
    debounce(async (e, file) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UploadCSVApi(file);
        if (response.status == "201") {
          setisOpenStock(false);
          getAllUserUnallocatedAccounts();
          toastMessage = {
            message: "Data added successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setIsFetchStrategyCheck(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [file, activeCard] // Dependencies
  );
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryCodeData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleDownloadPDFTableAccount = async () => {
    let headerDashboardFinal = [];
    if (activeCard && activeCard.id == "1") {
      headerDashboardFinal = [
        {
          label: "Date & Time",
          key: "date",
          formatter: (val) => formatDateTransaction(val),
        },
        { label: "Transaction ID", key: "reference_code" },
        {
          label: "From Account",
          key: "account_name",
          formatter: (_, row) => {
            return row.from_account?.name || "";
          },
        },
        {
          label: "To Account",
          key: "account_name",
          formatter: (_, row) => {
            return row.to_account?.name || "";
          },
        },
        {
          label: "Convert Rate",
          key: "convert_rate",
          formatter: (val) => val.toFixed(2),
        },
        {
          label: "Transaction Currency",
          key: "currency",
          formatter: (_, row) => row.currency.name,
        },
        {
          label: "Debit",
          key: "debit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Credit",
          key: "credit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Running Balance",
          key: "balance",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        { label: "Transaction Status", key: "status" },
      ];
    }
    if (activeCard && activeCard.id == "2") {
      headerDashboardFinal = [
        {
          label: "Date & Time",
          key: "date",
          formatter: (val) => formatDateTransaction(val),
        },
        { label: "Transaction ID", key: "reference_code" },
        {
          label: "From Account",
          key: "account_name",
          formatter: (_, row) => {
            return row.from_account.name || "";
          },
        },
        {
          label: "To Account",
          key: "account_name",
          formatter: (_, row) => {
            return row.to_account.name || "";
          },
        },
        {
          label: "Convert Rate",
          key: "convert_rate",
          formatter: (val) => val.toFixed(2),
        },
        {
          label: "Transaction Currency",
          key: "currency",
          formatter: (_, row) => row.currency.name,
        },
        {
          label: "Debit",
          key: "debit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Credit",
          key: "credit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Running Balance",
          key: "balance",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        { label: "Transaction Status", key: "status" },
      ];
    }
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8" />
                <style>
                @page {
          size: A4 landscape;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 6px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
              </head>
              <body>
             <div class="pdf-container">
                <div class="custom-header">
                  <div class="logo-container">
                    <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                  </div>
                  <h2 class="title">Transaction History</h2>
                  <div class="date">${date}</div>
                </div>
                
          <table id="dynamic-table">
          ${tableHeader}
            ${tableBody}
        
          </table>
            
              </div> 
        
                   </body>
            </html>
          `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Transaction History-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTableAccount(false);
    setIsOpenDownloadReport(false);
  };
  const UpdateRequestStatusCallBank = async (optionValue, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    const apiUrl =
      optionValue.value == "approved"
        ? `${BASE_URL}/v1/account/external-bank/approve/${rowId}`
        : `${BASE_URL}/v1/account/external-bank/reject/${rowId}`;
    const bodyData = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleStatusChangeBank = useCallback(
    debounce(async (e, option, rowId) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateRequestStatusCallBank(option, rowId);
        if (response.status == 200) {
          toastMessage = {
            message: "Request completed successfully",
            type: "success",
          };
          getAllBanksDataAdmin();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        handleDropdownToggleExternalbank(null);
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  const handleDownloadPDFTablePortfolio = async () => {
    let headerDashboardFinal = [
      {
        label: "Investment ID",
        key: "portfolio_reference_code",
      },
      {
        label: "Investment Product Name",
        key: "portfolio_name",
        formatter: (val) => "Caprock Model portfolio - " + val,
      },
      {
        label: "Balance",
        key: "total_balance",
        formatter: (val) =>
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(
      pdfDataPortfolio,
      headerDashboardFinal
    );
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8" />
                <style>
                @page {
          size: A4 portrait;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: auto;
            }
              td:nth-child(1),
th:nth-child(1) {
  width: 150px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 2px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
              </head>
              <body>
             <div class="pdf-container">
                <div class="custom-header">
                  <div class="logo-container">
                    <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                  </div>
                  <h2 class="title">Portfolio Management Accounts</h2>
                  <div class="date">${date}</div>
                </div>
                
          <table id="dynamic-table">
          ${tableHeader}
            ${tableBody}
        
          </table>
            
              </div> 
        
                   </body>
            </html>
          `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Portfolio Management Accounts-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTablePortfolio(false);
    setIsOpenDownloadReportPortfolio(false);
  };
  useEffect(() => {
    if (activeCard && activeCard.id == "2" && componentName != "dashboard") {
      gettableData();
    }
  }, [
    activeCard,
    sortkey,
    selectedFavourite,
    selectedRisk,
    searchQueryInvestmentList,
    showRecordsInvestmentList,
    currentPageInvestmentList,
    sortConfig,
  ]);
  const gettableData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        selected == ""
          ? `/v1/user/${activeCard.customerId}/my-investment/list?sort_by=${sortkey}&favorite=${selectedFavourite}&limit=${showRecordsInvestmentList}&page=${currentPageInvestmentList}&search=${searchQueryInvestmentList}&sort_order=${sortConfig.direction}`
          : `/v1/user/${activeCard.customerId}/my-investment/list?risk_rating=${selectedRisk}&sort_by=${sortkey}&favorite=${selectedFavourite}&limit=${showRecordsInvestmentList}&page=${currentPageInvestmentList}&search=${searchQueryInvestmentList}&sort_order=${sortConfig.direction}`
      );
      if (response.status == 200) {
        setTableData(response.data.data);
        settotalPagesInvestmentList(response.data.total_pages);
        settotalCountInvestmentList(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const handleUpdateHinNumber = useCallback(
    debounce(async (e, accountId) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await UpdateHinNumber(accountId);

        if (response.status == 200) {
          toggleClientPop(accountId);
          sethinClientId("");
          dispatch(AddClientIdAccountTrue());
          toastMessage = {
            message: "Client ID updated successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [hinClientId] // Dependencies
  );
  const handleUpdateHinNumberOverall = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await UpdateHinNumberOverall();

        if (response.status == 200) {
          toggleClientPopupUA();
          setBdClientId(hinOverallClientId);
          toastMessage = {
            message: "Client ID updated successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toggleClientPopupUA();
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [hinOverallClientId, activeCard] // Dependencies
  );
  const handleDownloadPDF = async () => {
    let headerDashboardFinal = [
      {
        label: "Ref ID",
        key: "ref_code",
      },
      {
        label: "Name",
        key: "name",
        formatter: (val) => "Caprock Model portfolio - " + val,
      },
      {
        label: "Investment manager",
        key: "manager",
        formatter: (val) => val.name,
      },
      {
        label: "Risk Profile",
        key: "risk_rating",
      },
      {
        label: "Strategy Type",
        key: "strategy_type",
      },
      {
        label: "Min Investment Amount",
        key: "minimum_investment",
        formatter: (val) =>
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      {
        label: "Strategy Growth",
        key: "strategy_growth",
        formatter: (val) =>
          typeof val === "string" ? val : val.toFixed(2) + "%",
      },
      {
        label: "Annual Dividend",
        key: "annual_dividend",
        formatter: (val) =>
          typeof val === "string" ? val : val.toFixed(2) + "%",
      },
      {
        label: "Performance",
        key: "performance",
        formatter: (val) =>
          typeof val === "string" ? val : val.toFixed(2) + "%",
      },
      {
        label: "Favourite",
        key: "is_favourite",
        formatter: (val) => (val == true ? "Favourite" : "Un-Favourite"),
      },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
       <style>
                @page {
          size: A4 landscape;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 6px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">My Investments</h2>
          <div class="date">${date}</div>
        </div>
        
  <table id="dynamic-table">
  ${tableHeader}
    ${tableBody}

  </table>
    
      </div> 

           </body>
    </html>
  `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }

      // For other errors
      const errorData = await response.json().catch(() => ({
        message: "An error occurred",
      }));
      throw new Error(errorData.message || `Error ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `My Investments-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
    setIsOpenReport(false);
  };
  useEffect(() => {
    if (isHiddenTable == true) {
      handleDownloadPDFTable();
    }
  }, [isHiddenTable]);
  useEffect(() => {
    if (isHiddenTableAccount == true) {
      handleDownloadPDFTableAccount();
    }
  }, [isHiddenTableAccount]);
  useEffect(() => {
    if (isHiddenTablePortfolio == true) {
      handleDownloadPDFTablePortfolio();
    }
  }, [isHiddenTablePortfolio]);
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  useEffect(() => {
    if (activeCard && componentName != "dashboard") {
      getAllUserTransactions();
    }
  }, [
    activeCard,
    searchQuery,
    showRecords,
    currentPage,
    selectedDates,
    selectedAccounts,
    status,
    filter,
  ]);
  useEffect(() => {
    if (activeCard && activeCard.id == "2" && componentName != "dashboard") {
      getAllUserUnallocatedAccounts();
    }
  }, [activeCard, showRecordsUnallocated, currentPageUnallocated]);
  useEffect(() => {
    if (activeCard && activeCard.id == "1") {
      getSettingsData();
      getAllCountryCode();
      getAllCurrency();
    }
    if (activeCard && activeCard.id == "2") {
      getAllCurrency();
    }
  }, [activeCard]);
  const prevValues = useRef({ to: "", from: "", type: "", bankType: "" });
  const handleDropdownToggleExternalbank = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  useEffect(() => {
    if (isOpenEdit == true || isOpenEditCashAccount == true) {
      const {
        to: prevTo,
        from: prevFrom,
        type: prevType,
        bankType: bankType,
      } = prevValues.current;

      const isTransfer = transactionTypeValue === "transfer";
      const isCredit = transactionTypeValue === "credit";
      const isDebit = transactionTypeValue === "debit";
      const isBillPayment = transactionTypeValue === "billPayment";

      const needsWallet =
        ((isDebit || isTransfer || isBillPayment) &&
          fromCustomerName !== "" &&
          fromCustomerName !== "-1") ||
        ((isCredit || isTransfer) &&
          toCustomerName !== "" &&
          toCustomerName !== "-1");

      if (needsWallet) {
        getWalletAccountsByToCustomerId();
      }
      if (isTransfer && toCustomerName !== "" && toCustomerName !== "-1") {
        getWalletAccountsByFromCustomerId();
      }
      if (fromCustomerName === "-1" || toCustomerName === "-1") {
        getAllBanksData();
      }

      const needsBank =
        (isCredit &&
          fromCustomerName !== "" &&
          fromCustomerName !== "-1" &&
          bankTypeValue == 1) ||
        (isDebit &&
          toCustomerName !== "" &&
          toCustomerName !== "-1" &&
          bankTypeValue == 1);

      if (needsBank) {
        getBankAccountData();
      }
      const needsThpBank =
        (isCredit &&
          fromCustomerName !== "" &&
          fromCustomerName !== "-1" &&
          bankTypeValue == 2) ||
        (isDebit &&
          toCustomerName !== "" &&
          toCustomerName !== "-1" &&
          bankTypeValue == 2);
      if (needsThpBank) {
        getThirdPartyBankAccountData();
      }
    }
  }, [
    isOpenEdit,
    isOpenEditCashAccount,
    toCustomerName,
    fromCustomerName,
    transactionTypeValue,
    bankTypeValue,
    prevValues,
  ]);
  useEffect(() => {
    // Update refs
    prevValues.current = {
      to: toCustomerName,
      from: fromCustomerName,
      type: transactionTypeValue,
      bankType: bankTypeValue,
    };
  }, [toCustomerName, fromCustomerName, transactionTypeValue, bankTypeValue]);
  useEffect(() => {
    if (activeCard && activeCard.id == "1" && componentName == "dashboard") {
      getAllDashboardTransactions();
    }
  }, [
    activeCard,
    searchQuery,
    showRecords,
    currentPage,
    selectedDates,
    selectedAccounts,
    status,
    filter,
    transactionStatus,
  ]);
  useEffect(() => {
    if (activeCard && activeCard.id == "1" && componentName == "dashboard") {
      getAllBanksDataAdmin();
    }
  }, [
    activeCard,
    showRecordsExternalBank,
    currentPageExternalBank,
    selectedStatus,
  ]);
  useEffect(() => {
    if (activeCard && activeCard.id == "1" && componentName != "dashboard") {
      getAllTransactionGraphdata("cash_account");
    }
    if (activeCard && activeCard.id == "2" && componentName != "dashboard") {
      getAllTransactionGraphdata("private_wealth_account");
    }
    if (activeCard && activeCard.id == "1" && componentName == "dashboard") {
      getAllTransactionGraphdataDashboard("cash_account");
      getAllUsersDashboard();
    }
  }, [activeCard, selectedFilter, cardCurrencyName]);
  useEffect(() => {
    if (activeCard && activeCard.id == "1" && componentName != "dashboard") {
      getAllUserMandates();
    }
  }, [activeCard, selectedStatusMandate, showRecordsMandate]);
  useEffect(() => {
    if (
      transactionTypeValue === "debit" ||
      transactionTypeValue === "transfer" ||
      transactionTypeValue === "billPayment"
    ) {
      setCustomerOptionsFrom(customerNameDataFrom);
    } else {
      setCustomerOptionsFrom(customerNameDataTo);
    }
  }, [transactionTypeValue, customerNameDataFrom, customerNameDataTo]);
  useEffect(() => {
    if (transactionTypeValue === "debit") {
      setCustomerOptionsTo(customerNameDataTo);
    } else {
      setCustomerOptionsTo(customerNameDataFrom);
    }
  }, [transactionTypeValue, customerNameDataFrom, customerNameDataTo]);

  useEffect(() => {
    if (activeCard && componentName != "dashboard" && filter == "transaction") {
      getAllUserAccounts();
    }
    if (
      activeCard &&
      activeCard.id == "1" &&
      componentName == "dashboard" &&
      filter == "transaction"
    ) {
      getAllDashboardAccounts();
    }
  }, [activeCard]);
  useEffect(() => {
    if (activeCard && activeCard.id == "2" && componentName == "dashboard") {
      getAllDashboardPortfolioAccounts();
    }
  }, [activeCard, showRecords, searchQuery, currentPage]);
  useEffect(() => {
    if (activeCard && activeCard.id == "2" && componentName == "dashboard") {
      getAllPortfolioTransactions();
    }
  }, [
    activeCard,
    showRecordsPortfolio,
    currentPagePortfolio,
    searchQueryPortfolio,
    selectedDates,
    cardCurrencyName,
  ]);
  useEffect(() => {
    if (componentName == "dashboard" && defaultCard.id == 1) {
      getAccountBalancesData();
      getTotalDepositData();
      getTotalWithdrawData();
    }
  }, [defaultCard, cardCurrencyName]);
  return (
    <div className="relative md:mr-4">
      {/* Custom Navigation Arrows */}
      <div
        onClick={handleNextClick}
        className={`absolute  right-2 transform -translate-y-1/2 translate-x-1/2 cursor-pointer z-10 md:block hidden ${
          componentName == "dashboard" ? "top-24" : "top-16"
        }`}
      >
        <img src="/right-card.svg" alt="Next" className="w-12 h-12" />
      </div>

      <Swiper
        ref={swiperRef}
        modules={[Navigation]}
        spaceBetween={16}
        navigation={{
          nextEl: ".swiper-button-next",
        }}
        className="custom-swiper overflow-visible"
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 5,
          },
        }}
      >
        {cardData.map((card, index) => (
          <SwiperSlide
            key={index}
            onClick={() => !card.isLocked && handleCardClick(card)}
            className={`group  fixed-height mb-5 flex-none rounded-lg p-4 border-2 border-transparent  relative transition-all duration-300 ease-in-out ${
              activeCard || defaultCard
                ? activeCard === card || defaultCard.id === card.id
                  ? "border-white border-2 " + card.color
                  : card.lessColor
                : card.color
            } ${
              card.isLocked
                ? ""
                : " cursor-pointer hover:border-white hover:border-2"
            }`}
          >
            {/* Lock Icon */}
            {card.isLocked && (
              <div className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm rounded-lg px-4 text-center">
                <img
                  src="/lock.svg"
                  alt="Locked"
                  className="w-8 h-8 opacity-90 mb-2 z-90"
                  title="Account not found"
                />
                <span className="text-white font-semibold text-sm  select-none max-w-full">
                  {card.label}
                </span>
              </div>
            )}

            {/* Tail indicator */}
            {activeCard === card && (
              <div className="absolute bottom-[-40px] left-1/2 transform -translate-x-1/2 z-[9999]">
                <div
                  className={`w-0 h-10 border-l-[10px] border-r-[10px] border-t-[16px] border-l-transparent border-r-transparent ${card.tail}`}
                  style={{ borderRadius: "0 0 15px 15px" }}
                />
              </div>
            )}

            {/* Card Content */}

            <div className={`text-left mb-2 ${card.isLocked ? "" : ""}`}>
              {/* Dropdown */}
              <div
                onClick={(e) => e.stopPropagation()}
                className="flex items-center justify-start"
              >
                {/* <select
                  value={selectedCurrency}
                  onChange={handleSelectCardCurrency}
                  className="bg-transparent text-md font-semibold text-white border border-white rounded-md px-1 py-0.5 focus:outline-none cursor-pointer w-[70px] sm:w-[80px]"
                >
                  {currencyData.map((currency) => (
                    <option
                      key={currency.value}
                      value={currency.label}
                      className="text-black"
                    >
                      {currency.label}
                    </option>
                  ))}
                </select> */}
                {currencyData.length > 0 && (
                  <div className="w-32">
                    {" "}
                    <CurrencyDropdown
                      label=""
                      options={currencyData}
                      search={true}
                      preselectedValue={preselectedcardCurrency}
                      onSelect={handleSelectCardCurrency}
                      colorLabel=""
                    />
                  </div>
                )}
              </div>

              {/* Balance */}
              <h2 className="text-md font-semibold text-white mt-1">
                {cardCurrencyName.symbol}
                {card.amount
                  ? Number(card.amount)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "0.00"}
              </h2>

              {/* Label */}
              <p
                className={`font-semibold text-sm ${
                  card.isLocked ? "text-white text-shadow-md" : "text-white"
                }`}
              >
                {card.label}
              </p>
            </div>

            {/* Line Graph */}
            {componentName === "dashboard" && (
              <div className="h-[50px] w-full">
                <Line data={card.graphdata} options={lineGraphOptions} />
              </div>
            )}

            {/* Customer View */}
            {componentName === "customer" && (
              <div className="absolute bottom-1 left-4 right-4 flex items-center justify-between">
                <p className="text-xs underline font-semibold text-black">
                  2 Active Acc
                </p>
                <p className="text-xs underline font-semibold text-black">
                  View Report
                </p>
              </div>
            )}

            {/* Arrow Indicator */}
            <div
              className={`absolute top-0 right-0 z-20 transition-all duration-200 ${
                activeCard === card || defaultCard.id === card.id
                  ? "block"
                  : "hidden"
              } ${
                (card.id === "1" || card.id === "2") &&
                componentName !== "cashaccount-investment-details"
                  ? "group-hover:block"
                  : ""
              }`}
            >
              <img
                src="/arrow-right-c.svg"
                alt="Arrow"
                className="w-6 h-6 m-2"
                onError={(e) => {
                  e.target.style.display = "none";
                  console.error("Image not found:", e.target.src);
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Detailed Section for Active Card */}
      {componentName == "dashboard" ? (
        <div>
          {activeCard && activeCard.id == "1" && (
            <div>
              {loading && (
                <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
                  <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
              )}

              <div className="pt-4 lg:flex mb-2 lg:space-x-4 gap-4">
                {/* Left Section: Two Cards */}
                <div className="flex flex-col flex-[1.5] space-y-4">
                  {/* Total Deposit Card */}
                  <div className="bg-white p-6 rounded-lg shadow-md w-full flex-1">
                    <div className="flex justify-between border-b  items-start">
                      <div className="flex items-center pb-2 space-x-4">
                        <img
                          src="/money-add.svg"
                          alt="Account Icon"
                          className="w-5 h-5 rounded-full"
                        />
                        <h3 className="text-black text-lg font-medium">
                          Total Deposit
                        </h3>
                      </div>
                      <span className="text-sm text-black pt-1">
                        <span className="text-sm text-[#A6A6A6]">Date: </span>
                        {getCurrentMonthYear()}
                      </span>
                    </div>
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
                      {/* Active Accounts Section */}
                      <div className="text-sm text-gray-500 pt-4 flex-1 pb-4 sm:border-b-0 sm:border-r border-gray-300 pr-4">
                        <div className="flex text-xs justify-between items-center mb-2 sm:mb-0">
                          <p className="text-[#A6A6A6]">
                            {cardCurrencyName.label}
                          </p>
                        </div>
                        <div className="font-medium text-gray-800">
                          {cardCurrencyName.symbol}
                          {totalDepositData?.overall
                            ? totalDepositData.overall
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>

                      {/* Portfolio Section */}
                      <div className="text-sm text-gray-500 pt-4 pl-0 md:pl-4 lg:pl-4 flex-1 pb-4 sm:border-b-0 border-gray-300 pr-4">
                        <div className="flex justify-between items-center mb-2 sm:mb-0">
                          <p className="text-[#A6A6A6] text-xs">
                            {totalDepositData.this_month?.month
                              ? totalDepositData.this_month.month
                              : getCurrentMonthYear()}
                            ,{" "}
                            {totalDepositData.this_month?.year
                              ? totalDepositData.this_month.year
                              : ""}
                          </p>
                        </div>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {totalDepositData.this_month?.total_amount
                            ? totalDepositData.this_month.total_amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Total Withdrawal Card */}
                  <div className="bg-white p-6 rounded-lg shadow-md w-full flex-1">
                    <div className="flex justify-between border-b  items-start">
                      <div className="flex items-center pb-2 space-x-4">
                        <img
                          src="/money-add.svg"
                          alt="Account Icon"
                          className="w-5 h-5 rounded-full"
                        />
                        <h3 className="text-black text-lg font-medium">
                          Total Withdrawal
                        </h3>
                      </div>
                      <span className="text-sm text-black pt-1">
                        <span className="text-sm text-[#A6A6A6]">Date: </span>
                        {getCurrentMonthYear()}
                      </span>
                    </div>
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
                      {/* Active Accounts Section */}
                      <div className="text-sm text-gray-500 pt-4 flex-1 pb-4 sm:border-b-0 sm:border-r border-gray-300 pr-4">
                        <div className="flex text-xs justify-between items-center mb-2 sm:mb-0">
                          <p className="text-[#A6A6A6]">
                            {cardCurrencyName.label}
                          </p>
                        </div>
                        <div className="font-medium text-gray-800">
                          {cardCurrencyName.symbol}
                          {totalWithdrawData?.overall
                            ? totalWithdrawData.overall
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>

                      {/* Portfolio Section */}
                      <div className="text-sm text-gray-500 pt-4 pl-0 md:pl-4 lg:pl-4 flex-1 pb-4 sm:border-b-0 border-gray-300 pr-4">
                        <div className="flex justify-between items-center mb-2 sm:mb-0">
                          <p className="text-[#A6A6A6] text-xs">
                            {totalWithdrawData.this_month?.month
                              ? totalWithdrawData.this_month.month
                              : getCurrentMonthYear()}
                            ,{" "}
                            {totalWithdrawData.this_month?.year
                              ? totalWithdrawData.this_month.year
                              : ""}
                          </p>
                        </div>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {totalWithdrawData.this_month?.total_amount
                            ? totalWithdrawData.this_month.total_amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Section: Account Balance */}
                <div className="bg-white p-6 rounded-lg shadow-lg w-full lg:flex-[2.1]  border border-gray-200 flex-1">
                  {/* Top Section with Date */}
                  <div className="flex justify-between border-b  items-start">
                    <div className="flex items-center pb-2 space-x-4">
                      <img
                        src="/archive.svg"
                        alt="Account Icon"
                        className="w-5 h-5 rounded-full"
                      />
                      <h3 className="text-black text-lg font-medium">
                        Account Balance
                      </h3>
                    </div>
                    <span className="text-sm text-black pt-1">
                      <span className="text-sm text-[#A6A6A6]">Date: </span>
                      {getCurrentMonthYear()}
                    </span>{" "}
                  </div>

                  {/* Title, Active Accounts, and Additional Elements */}
                  <div className="flex flex-col font-medium sm:flex-row items-start border-b sm:items-center justify-between gap-4 sm:gap-0">
                    {/* Active Accounts Section */}
                    <div className="text-sm text-gray-500 pt-4 flex-1 pb-4 sm:border-b-0 sm:border-r border-gray-300 pr-4">
                      <div className="flex justify-between items-center mb-2 sm:mb-0">
                        <p className="text-[#A6A6A6]">Active Accounts</p>
                        <span className="text-xs text-[#005A9C] font-medium px-1 py-1 rounded-full">
                          {balanceData
                            ? balanceData.sub_account_change.toFixed(2)
                            : "0.00"}
                          %
                        </span>
                      </div>
                      <div className="font-medium text-gray-800">
                        {balanceData.active_sub_accounts}
                      </div>
                    </div>

                    {/* Portfolio Section */}
                    <div className="text-sm text-gray-500 pt-4 pl-0 md:pl-4 lg:pl-4 flex-1 pb-4 sm:border-b-0 border-gray-300 pr-4">
                      <div className="flex justify-between items-center mb-2 sm:mb-0">
                        <p className="text-[#A6A6A6]">Portfolio</p>
                        <span className="text-xs font-medium text-[#005A9C] px-1 py-1 rounded-full">
                          {balanceData?.balance_change
                            ? balanceData.balance_change
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </span>
                      </div>
                      <div className="font-medium text-gray-800">
                        {cardCurrencyName.symbol}
                        {balanceData?.total_balance
                          ? balanceData.total_balance
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </div>
                    </div>
                  </div>

                  {/* Graph Section */}
                  <div className="w-full h-64 border-t pt-4">
                    <div className="h-full w-full">
                      <canvas
                        className="h-full w-full min-w-full"
                        ref={chartRef}
                      ></canvas>
                    </div>
                  </div>
                </div>
              </div>
              {loggedInUserRole == "super_admin" && (
                <div className="pt-2 text-xs overflow-x-auto flex-wrap items-center">
                  <div className="flex mb-2 relative">
                    <button
                      onClick={() => {
                        setThirdPartyFilterTab("allThp");
                        setSelectedStatus(null);
                        resetAllThpFilters();
                      }}
                      className={`px-4 py-2 rounded-l-xl border-r border-gray-100 ${
                        thirdPartyFilterTab === "allThp"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      All Third Party Accounts
                    </button>

                    <div className="relative">
                      <button
                        onClick={() => {
                          setThirdPartyFilterTab("reqThp");
                          setSelectedStatus("pending");
                          resetAllThpFilters();
                        }}
                        className={`lg:px-4 px-2 py-2 rounded-r-xl relative ${
                          thirdPartyFilterTab === "reqThp"
                            ? "bg-black text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        Requests
                        {totalPendingExternalBank > 0 && (
                          <span className="absolute -top-2 right-0  -right-2 bg-red-500 text-white text-[10px] text-xs font-bold px-1.5 lg:px-2 py-0.5 rounded-full flex items-center justify-center min-w-[16px] lg:min-w-[18px]">
                            {totalPendingExternalBank > 99
                              ? "99+"
                              : totalPendingExternalBank}
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="w-full p-4 bg-white rounded-lg shadow-lg">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b pb-5 border-gray-100">
                  {/* Left: Title */}
                  <div className="flex items-center">
                    <img
                      src="/cards.svg"
                      alt="Company Logo"
                      className="mr-2 w-6 h-6"
                    />
                    <span className="font-medium lg:text-xl text-sm">
                      Third Party Bank Accounts
                    </span>
                  </div>

                  {/* Right: Count and Button */}
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full md:w-auto justify-end">
                    <p className="text-sm">
                      <span className="font-medium text-labelLightColour">
                        No of Bank Accounts:{" "}
                      </span>
                      <span className="font-medium text-black">
                        {totalCountExternalBank}
                      </span>
                    </p>
                    <button
                      onClick={() => {
                        togglePopupAddBankCashAccount();
                      }}
                      className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                    >
                      <img
                        src="/Plus.svg"
                        alt="Add Icon"
                        className="mr-2 ml-2"
                      />
                      <span className="inline">Add Bank</span>
                    </button>
                  </div>
                </div>

                {isOpenEditCashAccountBank && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add New Third Party Bank
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={togglePopupAddBankCashAccount}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={togglePopupAddBankCashAccount}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter a valid routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleAddBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Add Bank
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Profile Section */}
                <div className="p-4">
                  {/* Filters Section */}
                  <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleshowRecordBank}
                        />
                      </div>
                    </div>
                    <div className="flex md:flex-row flex-col items-center md:space-x-4">
                      <div
                        ref={StatusRef}
                        className="relative w-full md:w-full"
                      >
                        {/* Dropdown Button */}
                        <button
                          onClick={() => setIsStatusOpen(!isStatusOpen)}
                          className={`w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-3 py-2 flex items-center focus:outline-none ${
                            isStatusOpen
                              ? "bg-black text-white"
                              : "bg-white text-black"
                          }`}
                        >
                          {/* Left Icon */}
                          <img
                            src={
                              isStatusOpen
                                ? "/filter-sort-white.svg"
                                : "/filter-sort-black.svg"
                            }
                            alt="Filter Icon"
                            className="h-5 w-5 mr-2"
                          />

                          {/* Text (pushes dropdown icon to the right) */}
                          <span className="flex-1">Filter Status</span>

                          {/* Right Dropdown Icon */}
                          <img
                            src={
                              isStatusOpen
                                ? "/chevron-down.svg"
                                : "/chevron-down-black.svg"
                            }
                            alt="Dropdown Icon"
                            className="h-5 w-5 flex-shrink-0 ml-auto transition-transform duration-300 transform"
                          />
                        </button>

                        {/* Dropdown List */}
                        {isStatusOpen && (
                          <div
                            className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-[999]"
                            style={{
                              maxHeight: "200px", // Optional: limit height
                            }}
                          >
                            {AllStatusFilters.map((option) => (
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleSelectStatus(option);
                                }}
                                key={option.value}
                                className={`px-4 py-2 flex items-center hover:bg-black hover:text-white cursor-pointer ${
                                  option.value == selectedStatus
                                    ? " bg-black text-white"
                                    : ""
                                }`}
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Table */}

                  <div className="overflow-x-auto">
                    <table className="w-full h-full  border-separate pb-4 border-[#EDEDED]  border-spacing-y-2">
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr className="border border-[#EDEDED]">
                          {externalAccountHeaders.map((header, index) => (
                            <th
                              key={header.label}
                              className={`
                                             cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-center
                                             ${
                                               index === 0
                                                 ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                                                 : ""
                                             }
                                                 ${
                                                   index === 1 ||
                                                   index === 2 ||
                                                   index === 3 ||
                                                   index === 4 ||
                                                   index === 5 ||
                                                   index === 6 ||
                                                   index === 7 ||
                                                   index === 8
                                                     ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                                     : ""
                                                 }
                                               ${
                                                 index === 9
                                                   ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                                                   : ""
                                               }
                                           `}
                            >
                              <div class="flex items-center">
                                <span>{header.label}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(3)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(8)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {externalbankTable.length > 0 ? (
                            externalbankTable.map((row, index) => (
                              <React.Fragment key={index}>
                                <tr
                                  className={`cursor-pointer mb-2 bg-[#F9F9F9]`}
                                >
                                  <td className="px-4 py-2">
                                    <div className="flex items-center space-x-2">
                                      <img
                                        src="/clock.svg"
                                        alt="Time Icon"
                                        className="h-4 w-4"
                                      />
                                      <span className="rounded-xl">
                                        {`${formatDateList(row.created_at)}`}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_name}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_number}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.account_bsb}
                                  </td>
                                  <td className="px-4 py-2">{row.bank_name}</td>
                                  <td className="px-4 py-2 space-y-1">
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Swift Code:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.swift_code ?? "N/A"}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Institution Number:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.institution_number ?? "N/A"}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="text-gray-500 font-medium">
                                        Transit Number:
                                      </span>{" "}
                                      <span className="text-black">
                                        {row.transit_number ?? "N/A"}
                                      </span>
                                    </p>
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.address_line1}-{row.address_line2}
                                    {row.address_line3
                                      ? "-" + row.address_line3
                                      : ""}
                                  </td>
                                  <td className="px-4 py-2">
                                    {row.country_code}
                                  </td>
                                  <td className="px-4 py-2 relative">
                                    <button
                                      onClick={() =>
                                        handleDropdownToggleExternalbank(row.id)
                                      }
                                      ref={(el) =>
                                        (buttonRefs.current[`${row.id}`] = el)
                                      }
                                      disabled={
                                        loggedInUserRole == "super_admin" &&
                                        row.status == "pending"
                                          ? false
                                          : true
                                      }
                                      className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                        row.status == "pending"
                                          ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                          : ""
                                      }
                                            ${
                                              row.status == "approved"
                                                ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                                : ""
                                            }
                                            ${
                                              row.status == "rejected"
                                                ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                                : ""
                                            }
                                            `}
                                    >
                                      <span className="mr-6">
                                        {" "}
                                        {row.status == "pending"
                                          ? "Pending"
                                          : row.status.charAt(0).toUpperCase() +
                                            row.status.slice(1)}
                                      </span>
                                      {loggedInUserRole == "super_admin" &&
                                        row.status == "pending" && (
                                          <img
                                            src={`${
                                              openDropdown === row.id
                                                ? "/Vector.svg"
                                                : "/down-grey.svg"
                                            }`}
                                            alt="Selected"
                                            className="w-3 h-3 ml-4"
                                          />
                                        )}
                                    </button>
                                    <DropdownTest
                                      isOpen={openDropdown === row.id}
                                      buttonRef={
                                        buttonRefs.current[`${row.id}`]
                                      } // Pass unique ref to the dropdown
                                    >
                                      <div
                                        ref={dropdownRef}
                                        className="absolute left-0 bg-white rounded-md shadow-lg overflow-hidden z-50 w-full max-w-[200px] border"
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                        }}
                                      >
                                        {AllStatusExternal.map((option) => (
                                          <div
                                            key={option.value}
                                            onClick={(e) => {
                                              setLoading(true);
                                              handleStatusChangeBank(
                                                e,
                                                option,
                                                row.id
                                              );
                                            }}
                                            className={`px-4 py-2 p-3 w-30 mx-2 my-1 text-sm cursor-pointer flex items-center justify-between rounded-xl ${
                                              option.value === "approved"
                                                ? "border-2 border-[#34C046] text-[#34C046] bg-[#93DB9C] hover:bg-[#34C046] hover:text-white"
                                                : "border-2 border-[#FF5050] text-[#FF5050] bg-[#E9BDBD] hover:bg-[#FF5050] hover:text-white"
                                            }`}
                                          >
                                            <span>{option.label}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </DropdownTest>
                                  </td>
                                  <td
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleEditClickBank(e, row);
                                    }}
                                    className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap"
                                  >
                                    <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                                      Edit Details
                                    </span>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                  {externalbankTable != null && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing{" "}
                        {showRecordsExternalBank *
                          (currentPageExternalBank - 1) +
                          1}{" "}
                        to{" "}
                        {currentPageExternalBank === totalPagesExternalBank ||
                        totalPagesExternalBank == 0
                          ? totalCountExternalBank
                          : Math.max(
                              showRecordsExternalBank * currentPageExternalBank,
                              externalbankTable.length
                            )}{" "}
                        of {totalCountExternalBank} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPageExternalBank === 1}
                          onClick={() =>
                            setCurrentPageExternalBank((prev) => prev - 1)
                          }
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({
                          length: Math.min(totalPagesExternalBank, 5),
                        }).map((_, index) => {
                          const startPage = Math.max(
                            1,
                            Math.min(
                              totalPagesExternalBank - 4,
                              currentPageExternalBank - 2
                            )
                          );
                          const page = startPage + index;

                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPageExternalBank(page)}
                              className={`px-3 py-1 rounded ${
                                currentPageExternalBank === page
                                  ? "bg-black text-white"
                                  : "bg-white border border-gray-300 text-black"
                              }`}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {/* Next Button */}
                        <button
                          disabled={
                            currentPageExternalBank === totalPagesExternalBank
                          }
                          onClick={() =>
                            setCurrentPageExternalBank((prev) => prev + 1)
                          }
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {isModalOpenBankEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Edit External Bank
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={() => {
                                setcurrentBank(null);
                                setIsModalOpenBankEdit(false);
                              }}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={() => {
                              setcurrentBank(null);
                              setIsModalOpenBankEdit(false);
                            }}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter a valid routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleEditBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Edit Bank
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
                <div className="py-6 px-4 bg-white">
                  <div className="mb-4 flex flex-wrap justify-between items-center"></div>
                  <div className="mb-4 flex flex-wrap items-center justify-between">
                    <div className="flex text-sm md:text-md">
                      {["1M", "3M", "6M", "1Y", "All"].map((filter, index) => (
                        <button
                          key={filter}
                          className={`px-3 py-2 shadow-md ${
                            filter === "All" ? "rounded-r-xl" : ""
                          } ${filter === "1M" ? "rounded-l-xl" : ""} ${
                            selectedFilter === filter
                              ? "bg-black text-white"
                              : "bg-white text-black"
                          }`}
                          onClick={() => setSelectedFilter(filter)}
                        >
                          {filter}
                        </button>
                      ))}
                    </div>

                    <div className="mt-2 md:mt-0">
                      <button className="bg-white text-black pl-2 pr-6 py-1 h-10 whitespace-nowrap border-gray-300 border rounded-lg flex items-center">
                        <img
                          src="/presention-chart.svg" // Replace with the actual path to your image
                          alt="Graph Icon"
                          className="h-5 w-5 mr-2" // Adjust size and spacing as needed
                        />
                        Generate Graph
                      </button>
                    </div>
                  </div>

                  <div style={{ width: "100%", height: "400px" }}>
                    <Line data={dataLine} options={optionsLine} />
                  </div>
                </div>
              </div>
              {loggedInUserRole == "super_admin" && (
                <div className="pt-4 text-xs overflow-x-auto flex-wrap items-center">
                  <div className="flex mb-2 relative">
                    <button
                      onClick={() => {
                        setFilter("transaction");
                        resetAllFilters();
                      }}
                      className={`px-4 py-2 rounded-l-xl border-r border-gray-100 ${
                        filter === "transaction"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      Transactions
                    </button>

                    <div className="relative">
                      <button
                        onClick={() => {
                          setFilter("request");
                          resetAllFilters();
                        }}
                        className={`lg:px-4 px-2 py-2 rounded-r-xl relative ${
                          filter === "request"
                            ? "bg-black text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        Requests
                        {totalPendingRequest > 0 && (
                          <span className="absolute -top-2 right-0  -right-2 bg-red-500 text-white text-[10px] text-xs font-bold px-1.5 lg:px-2 py-0.5 rounded-full flex items-center justify-center min-w-[16px] lg:min-w-[18px]">
                            {totalPendingRequest > 99
                              ? "99+"
                              : totalPendingRequest}
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {filter == "transaction" && (
                <div className="bg-white mt-4 p-4 shadow-md rounded-md">
                  <div className="flex flex-wrap justify-between items-center border-b border-colour-custom px-4 py-2 gap-y-4">
                    {/* Left: Title */}
                    <h1 className="text-xl font-medium text-black">
                      Transaction History
                    </h1>

                    {/* Right: Download & Add Transaction */}
                    <div className="flex flex-wrap justify-end items-center gap-2 w-full sm:w-auto">
                      {/* Download Dropdown */}
                      <div ref={DownloadRef} className="relative">
                        <div
                          className="flex items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                          onClick={() =>
                            setIsOpenDownloadReport(!isOpenDownloadReport)
                          }
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <img
                            src="/download-small-arrow.svg"
                            alt="Dropdown"
                            className="w-2 h-2 ml-auto"
                          />
                        </div>

                        {isOpenDownloadReport && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                            {reportOptions.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDFTable(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Add Transaction Button */}
                      <button
                        onClick={() => {
                          getAllUsersDashboard();
                          togglePopupAddTransactionCashAccount();
                        }}
                        className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                      >
                        <img
                          src="/Plus.svg"
                          alt="Add Icon"
                          className="mr-2 ml-2"
                        />
                        <span className="inline">Add Transaction</span>
                      </button>
                    </div>
                  </div>

                  {isOpenEditCashAccount && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                        {/* Modal Header */}
                        <div className="flex flex-wrap items-center justify-between mb-6 text-sm md:text-base">
                          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 w-full">
                            {/* Left Tabs */}
                            <div className="flex items-center space-x-2 md:space-x-4">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  resetAllFiltersCashAccount();
                                  getAllUsersDashboard();

                                  setTransactionTab("addTransaction");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addTransaction"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add Transaction
                              </span>
                              <span className="hidden md:block text-[#B2B2B2]">
                                |
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearAllFieldsBank();
                                  setTransactionTab("addThirdPartyBank");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addThirdPartyBank"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add Third Party Bank
                              </span>
                            </div>

                            {/* Right Add Button */}
                            <div className="flex justify-end">
                              <img
                                onClick={togglePopupAddTransactionCashAccount}
                                src="/add.svg"
                                alt="Add"
                                className="w-10 h-10 cursor-pointer"
                              />
                            </div>
                          </div>

                          {/* <button onClick={togglePopupAddTransaction}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button> */}
                        </div>
                        {transactionTab === "addTransaction" && (
                          <div>
                            {summaryDetails === false && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Add New Transaction
                                  </h2>
                                  <button
                                    onClick={
                                      togglePopupAddTransactionCashAccount
                                    }
                                  ></button>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <div className="">
                                      <Dropdown
                                        label="Transaction Type"
                                        options={transactionTypeMore}
                                        preselectedValue={
                                          preselectedTransactionType
                                        }
                                        onSelect={handleTransactionType}
                                      />
                                    </div>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <Dropdown
                                          label="RTGS/International/Normal"
                                          options={transactionTypeSecond}
                                          preselectedValue={
                                            preselectedTransactionTypeSecond
                                          }
                                          onSelect={handleTransactionTypeSecond}
                                        />
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={nabFees}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                        <div className="flex items-center space-x-2 mt-4">
                                          <input
                                            type="checkbox"
                                            id="confirm-all"
                                            className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                                            checked={isCheckedSecond}
                                            onChange={(e) =>
                                              setIsCheckedSecond(
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor="confirm-all"
                                            className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                                          >
                                            I accept the applicable fees.
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <textarea
                                        type="text"
                                        name="documentId"
                                        value={commentsCashAccount}
                                        maxLength={18}
                                        onChange={(e) =>
                                          setCommentsCashAccount(e.target.value)
                                        }
                                        className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                        placeholder="Add your comments"
                                      />
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-xs text-labelColour whitespace-normal words-break"
                                      >
                                        You can enter only up to 18 characters
                                      </label>{" "}
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>
                                      <input
                                        type="date"
                                        value={creationDate}
                                        onChange={(e) =>
                                          setCreationDate(e.target.value)
                                        }
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                        <input
                                          type="text"
                                          name="field2"
                                          value={
                                            isFocused
                                              ? transactionAmount
                                              : formatNumber(transactionAmount)
                                          }
                                          ref={inputRef}
                                          onChange={(e) => {
                                            if (!isFocused) return;
                                            handleChangeAmount(
                                              e,
                                              e.target.value
                                            );
                                          }}
                                          onFocus={() => setIsFocused(true)}
                                          onBlur={() => setIsFocused(false)}
                                          className="p-2 w-full text-black font-medium outline-none text-md"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div className="">
                                          <Dropdown
                                            label="Set Recurrence"
                                            options={recurringTypes}
                                            preselectedValue={
                                              preselectedRecurringType
                                            }
                                            onSelect={handleRecurringType}
                                          />
                                        </div>
                                        {recurringTypeValue != "never" && (
                                          <>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                Start Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recStartDate}
                                                onChange={(e) => {
                                                  const newStart =
                                                    e.target.value;
                                                  setRecStartDate(newStart);

                                                  // Auto-clear end date if it becomes invalid
                                                  if (
                                                    recEndDate &&
                                                    recEndDate < newStart
                                                  ) {
                                                    setRecEndDate("");
                                                  }
                                                }}
                                                min={getCurrentDate()}
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                End Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recEndDate}
                                                onChange={(e) =>
                                                  setRecEndDate(e.target.value)
                                                }
                                                min={
                                                  recStartDate ||
                                                  getCurrentDate()
                                                }
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        <div className="">
                                          <Dropdown
                                            key={`${transactionTypeValue}-${customerOptionsFrom.length}`}
                                            label="Select Customer"
                                            options={customerOptionsFrom}
                                            preselectedValue={
                                              preSelectedCustomerNameCashAccount
                                            }
                                            search={true}
                                            onSelect={
                                              handleSelectCustomerNameCashAccount
                                            }
                                          />
                                        </div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour mt-4"
                                        >
                                          Currency
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromCurrencyCashAccount}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        <div>
                                          {(transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment") && (
                                            <Dropdown
                                              label="Select Account"
                                              options={fromCustomerAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                          {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            fromCustomerName === "-1" && (
                                              <Dropdown
                                                label="Select Account"
                                                options={allBanks}
                                                preselectedValue={
                                                  preSelectedFromuserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleFromAccountHolderNumber
                                                }
                                              />
                                            )}

                                          {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            fromCustomerName !== "-1" && (
                                              <Dropdown
                                                label="Select Bank Type"
                                                options={bankType}
                                                preselectedValue={
                                                  preselectedBankType
                                                }
                                                onSelect={handleChangeBankType}
                                              />
                                            )}
                                          {(transactionTypeValue ==
                                            "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment" ||
                                            (transactionTypeValue == "debit" &&
                                              transactionTypeValueSecond ==
                                                "international")) && (
                                            <>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour mt-4"
                                              >
                                                Currency Rate
                                              </label>{" "}
                                              <input
                                                id="accbalance"
                                                type="text"
                                                value="1.00"
                                                disabled={true}
                                                className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                                placeholder="CT0291288"
                                              />
                                            </>
                                          )}
                                        </div>
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue != "debit" &&
                                          transactionTypeValue != "transfer" &&
                                          transactionTypeValue !=
                                            "billPayment" &&
                                          fromCustomerName !== "-1" &&
                                          bankTypeValue == 1 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={bankAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {transactionTypeValue != "debit" &&
                                          transactionTypeValue != "transfer" &&
                                          fromCustomerName !== "-1" &&
                                          bankTypeValue == 2 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={
                                                thirdPartyBankAccountData
                                              }
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromAccountNumber}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <div className="">
                                              <Dropdown
                                                key={`${transactionTypeValue}-${customerOptionsTo.length}`}
                                                label="Select Customer"
                                                options={customerOptionsTo}
                                                preselectedValue={
                                                  preSelectedCustomerNameCashAccountTo
                                                }
                                                search={true}
                                                onSelect={
                                                  handleSelectCustomerNameCashAccountTo
                                                }
                                              />
                                            </div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toCurrencyCashAccount}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="AUD"
                                            />
                                          </>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerCode"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller Code
                                            </label>{" "}
                                            <input
                                              id="billerCode"
                                              type="text"
                                              value={billerCode}
                                              onChange={(e) =>
                                                setBillerCode(e.target.value)
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0 md:border-r  sm:border-l-0 border-r-0 md:border-l  border-gray-300 px-4">
                                        {transactionTypeValue == "transfer" && (
                                          <div>
                                            <Dropdown
                                              label="Select Account"
                                              options={toCustomerAccountData}
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          </div>
                                        )}
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <Dropdown
                                              label="Select Account"
                                              options={fromCustomerAccountData}
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          </div>
                                        )}

                                        {transactionTypeValue == "debit" &&
                                          toCustomerName === "-1" && (
                                            <div>
                                              <Dropdown
                                                label="Select Account"
                                                options={allBanks}
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            </div>
                                          )}
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" && (
                                            <Dropdown
                                              label="Select Bank Type"
                                              options={bankType}
                                              preselectedValue={
                                                preselectedBankType
                                              }
                                              onSelect={handleChangeBankType}
                                            />
                                          )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={finalConvertedRate}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerRefnumber"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <input
                                              id="billerRefnumber"
                                              type="text"
                                              value={billerRefnumber}
                                              onChange={(e) =>
                                                setBillerRefnumber(
                                                  e.target.value
                                                )
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" &&
                                          bankTypeValue == 1 && (
                                            <div>
                                              <Dropdown
                                                label="Select Account"
                                                options={bankAccountData}
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            </div>
                                          )}
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" &&
                                          bankTypeValue == 2 && (
                                            <div>
                                              <Dropdown
                                                label="Select Account"
                                                options={
                                                  thirdPartyBankAccountData
                                                }
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            </div>
                                          )}
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={
                                                isFocusedFinal
                                                  ? finalConvertedAmount
                                                  : formatNumber(
                                                      finalConvertedAmount
                                                    )
                                              }
                                              ref={inputRefFinal}
                                              onChange={(e) => {
                                                if (!isFocusedFinal) return;
                                                handleChangeAmountFinal(
                                                  e,
                                                  e.target.value
                                                );
                                              }}
                                              onFocus={() =>
                                                setIsFocusedFinal(true)
                                              }
                                              onBlur={() =>
                                                setIsFocusedFinal(false)
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="100.00"
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          togglePopupAddTransactionCashAccount();
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (!transactionAmount) {
                                            showToast(
                                              "Please Add valid amount",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromCustomerName) {
                                            showToast(
                                              "Please Select From Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toCustomerName
                                          ) {
                                            showToast(
                                              "Please Select To Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "Please Select To Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromAccountIdCashAccount) {
                                            showToast(
                                              "Please Select From Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            fromAccountIdCashAccount ==
                                            toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "From and To account can't be same",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!creationDate) {
                                            showToast(
                                              "Please Select Transaction Date",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recStartDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence start date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recEndDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence end date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!commentsCashAccount) {
                                            showToast(
                                              "Please Add some description",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            (transactionTypeValue == "debit" ||
                                              transactionTypeValue ==
                                                "credit") &&
                                            isCheckedSecond == false
                                          ) {
                                            showToast(
                                              "Please confirm applicable fees",
                                              "error"
                                            ); // Success toast
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerCode
                                          ) {
                                            showToast(
                                              "Please enter biller code",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerRefnumber
                                          ) {
                                            showToast(
                                              "Please enter reference number",
                                              "error"
                                            );
                                            return;
                                          }
                                          setSummaryDetails(true);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Next
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                            {summaryDetails === true && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Transaction Summary
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Transaction Type
                                    </label>{" "}
                                    <span>{transactionTypeName}</span>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          RTGS/International/Normal
                                        </label>{" "}
                                        <span>{transactionTypeNameSecond}</span>
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <span>{nabFees}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <span>{commentsCashAccount}</span>
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>

                                      <span>
                                        {formatDateForFilterNew(creationDate)}
                                      </span>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center">
                                        <span>
                                          $
                                          {Number(transactionAmount)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div>
                                          <label
                                            htmlFor="Recurring Frequency"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Recurring Frequency
                                          </label>{" "}
                                          <span>{recurringTypeLabel}</span>
                                        </div>
                                        {recurringTypeValue != "never" && (
                                          <>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                Start Date
                                              </label>
                                              <span>
                                                {formatDateForFilterNew(
                                                  recStartDate
                                                )}
                                              </span>
                                            </div>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                End Date
                                              </label>
                                              <span>
                                                {formatDateForFilterNew(
                                                  recEndDate
                                                )}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-0">
                                        <div className="">
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Selected Customer
                                          </label>{" "}
                                          <span>{fromCustomerLabel}</span>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Currency
                                          </label>{" "}
                                          <span>{fromCurrencyCashAccount}</span>
                                        </div>
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            fromCustomerName !== "-1"
                                              ? "Selected Bank Type"
                                              : "Selected Account"}
                                          </label>{" "}
                                          <span>
                                            {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            fromCustomerName !== "-1"
                                              ? bankTypeLabel
                                              : fromAccountIdCashAccountLabel}
                                          </span>
                                        </div>
                                        {(transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>1.00</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue != "debit" &&
                                          transactionTypeValue != "transfer" &&
                                          transactionTypeValue !=
                                            "billPayment" &&
                                          fromCustomerName !== "-1" && (
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Account
                                              </label>{" "}
                                              <span>
                                                {fromAccountIdCashAccountLabel}
                                              </span>
                                            </div>
                                          )}
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Account Number
                                          </label>{" "}
                                          <span>{fromAccountNumber}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-0">
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <div className="">
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Customer
                                              </label>{" "}
                                              <span>{toCustomerNameLabel}</span>
                                            </div>
                                            <div className="">
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Currency
                                              </label>{" "}
                                              <span>
                                                {toCurrencyCashAccount}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller code
                                            </label>{" "}
                                            <span>{billerCode}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Center Column with Border */}
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <span>{billerRefnumber}</span>
                                          </div>
                                        )}
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              {transactionTypeValue ==
                                                "debit" &&
                                              toCustomerName !== "-1"
                                                ? "Selected Bank Type"
                                                : "Selected Account"}
                                            </label>{" "}
                                            <span>
                                              {" "}
                                              {transactionTypeValue ==
                                                "debit" &&
                                              toCustomerName !== "-1"
                                                ? bankTypeLabel
                                                : toAccountIdCashAccountLabel}
                                            </span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>{finalConvertedRate}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" && (
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Account
                                              </label>{" "}
                                              <span>
                                                {toAccountIdCashAccountLabel}
                                              </span>
                                            </div>
                                          )}
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <span>{toAccountNumber}</span>
                                          </div>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <span>
                                              {Number(finalConvertedAmount)
                                                .toFixed(2)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ","
                                                )}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setSummaryDetails(false);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Back
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setLoading(true);
                                          handleAddTransacionCashAccount(e);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Transfer Now
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {transactionTab === "addThirdPartyBank" && (
                          <div>
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New Third Party Bank
                              </h2>
                            </div>
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-4">
                                {/* Code */}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountName}
                                    onChange={(e) =>
                                      setToAccountName(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="John Doe"
                                  />
                                </div>
                                {countryCode != "AE" &&
                                  countryCode != "GB" &&
                                  !isEuropeanCountry(countryCode) && (
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Account Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={toAccountNumber}
                                        onChange={(e) =>
                                          setToAccountNumber(e.target.value)
                                        }
                                        className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="0291288"
                                      />
                                    </div>
                                  )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Bank Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toBank}
                                    onChange={(e) => setToBank(e.target.value)}
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Bank Name"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Select Country"
                                    options={countryCodeData}
                                    search={true}
                                    preselectedValue={preselectedCountryCode}
                                    onSelect={handleSelectCountryCode}
                                    colorLabel=""
                                  />
                                </div>
                                <div className="">
                                  <Dropdown
                                    label="Currency"
                                    options={currencyData}
                                    search={true}
                                    preselectedValue={preselectedcashCurrency}
                                    onSelect={handleSelectToCurrency}
                                    colorLabel=""
                                  />
                                </div>
                                {countryCode == "AU" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      BSB
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={toBsb}
                                      maxLength={6}
                                      onChange={(e) =>
                                        handleBsbChange(e.target.value)
                                      }
                                      className={`${
                                        bsbError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000"
                                    />
                                    {bsbError && (
                                      <p className="text-red-600 text-xs mt-1">
                                        {bsbError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Swift/BIC code
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={swiftCode}
                                    onChange={handleSwiftChange}
                                    className={`${
                                      swiftError && countryCode != "AU"
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="000000"
                                  />
                                  {swiftError && countryCode != "AU" && (
                                    <p className="text-red-500 text-xs mt-1">
                                      {swiftError}
                                    </p>
                                  )}
                                </div>
                                {countryCode == "US" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Routing Number (ABA)
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={routingNumber}
                                      maxLength={9}
                                      onChange={(e) =>
                                        handleRoutingChange(e.target.value)
                                      }
                                      className={`${
                                        routingError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000000"
                                    />
                                    {routingError && (
                                      <p className="text-red-600 text-sm mt-1">
                                        {routingError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {countryCode == "CA" && (
                                  <>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transit Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={transitNumber}
                                        maxLength={5}
                                        onChange={(e) =>
                                          handleTransitChange(e.target.value)
                                        }
                                        className={`${
                                          transitError
                                            ? "border-red-300 "
                                            : "border-gray-300 "
                                        }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                        placeholder="00000"
                                      />
                                      {transitError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          {transitError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Institution Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={institutionNumber}
                                        onChange={(e) =>
                                          setinstitutionNumber(e.target.value)
                                        }
                                        className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="000000"
                                      />
                                    </div>
                                  </>
                                )}
                                {(countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      IBAN
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={iban}
                                      onChange={handleChangeIban}
                                      className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                      placeholder="000000"
                                    />
                                    {error && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {error}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 1
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine1}
                                    onChange={(e) =>
                                      setAddressLine1(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Street address"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 2
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine2}
                                    onChange={(e) =>
                                      setAddressLine2(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Apartment, unit etc."
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 3
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine3}
                                    onChange={(e) =>
                                      setAddressLine3(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="City, Country etc."
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                              <button
                                onClick={togglePopupAddTransactionCashAccount}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    countryCode == "AU" &&
                                    (!toBsb || bsbError)
                                  ) {
                                    showToast(
                                      "Please enter a valid BSB",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "US" &&
                                    (!routingNumber || routingError)
                                  ) {
                                    showToast(
                                      "Please enter a valid routing number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    (countryCode == "AE" ||
                                      countryCode == "GB" ||
                                      isEuropeanCountry(countryCode)) &&
                                    !iban
                                  ) {
                                    showToast("Please enter iban", "error");
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    (!transitNumber || transitError)
                                  ) {
                                    showToast(
                                      "Please enter a valid transit number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    !institutionNumber
                                  ) {
                                    showToast(
                                      "Please enter institution number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AU" &&
                                    (!swiftCode || swiftError)
                                  ) {
                                    showToast(
                                      "Please enter a valid swift code/BIC code",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (error) {
                                    showToast(
                                      "Please enter valid iban",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AE" &&
                                    countryCode != "GB" &&
                                    !isEuropeanCountry(countryCode) &&
                                    !toAccountNumber
                                  ) {
                                    showToast(
                                      "Please enter account number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    !toAccountName ||
                                    !toCurrency ||
                                    !addressLine1 ||
                                    !addressLine2 ||
                                    !addressLine3 ||
                                    !countryCode ||
                                    !toBank
                                  ) {
                                    showToast("Please Add all fields", "error");
                                    return;
                                  }
                                  setLoading(true);
                                  handleAddBank(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Add Bank
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="p-4">
                    {/* Filters Section */}
                    <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                      <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                        <div className="flex items-center space-x-2">
                          <span className="lg:text-md  text-sm text-[#8C8C8C]">
                            Show Records
                          </span>
                          <Dropdown
                            label=""
                            options={filterOptions}
                            preselectedValue={preSelectedFilter}
                            onSelect={handleshowRecord}
                          />
                        </div>
                        <div className="flex items-center">
                          <div className="relative w-full">
                            <input
                              type="text"
                              className="p-2 pl-8 w-full lg:w-auto border  rounded-xl"
                              placeholder="Search here"
                              value={searchQuery}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                setCurrentPage(1);
                              }}
                            />
                            <span className="absolute left-2 top-3 text-gray-500">
                              {" "}
                              <img
                                src="/search-normal.svg"
                                alt="Company Logo"
                                className="mr-2"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* Dropdown */}

                      <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                        <div
                          ref={statusRef}
                          className="relative w-full lg:w-auto"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setisOpenStatus(!isOpenStatus)}
                            className={`w-full md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none ${
                              isOpenStatus
                                ? "bg-black text-white"
                                : "bg-white text-black"
                            }`}
                          >
                            <div className="flex items-center">
                              {isOpenStatus ? (
                                <img
                                  src="/filter-sort-white.svg"
                                  alt="Filter Icon"
                                  className="h-5 w-5 mr-2"
                                />
                              ) : (
                                <img
                                  src="/filter-sort-black.svg"
                                  alt="Filter Icon"
                                  className="h-5 w-5 mr-2"
                                />
                              )}
                              Status
                            </div>
                          </button>

                          {/* Dropdown List */}
                          {isOpenStatus && (
                            <div
                              className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              {(loggedInUserRole === "advisor"
                                ? AllStatusAdvisor
                                : AllStatus
                              ).map((option) => (
                                <div
                                  key={option.value}
                                  onClick={() => {
                                    setTransactionStatus(option.value);
                                    setisOpenStatus(false);
                                    setCurrentPage(1);
                                  }}
                                  className={`px-2 py-1 flex items-center cursor-pointer ${
                                    transactionStatus === option.value
                                      ? "text-white bg-black"
                                      : "text-black bg-white"
                                  }`}
                                >
                                  {option.label}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div
                          ref={accountRef}
                          className="relative w-full mt-4 md:mt-0 md:w-full"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="w-full  font-medium border-gray-300  rounded-xl text-sm  py-2 flex items-center justify-between focus:outline-none bg-white text-black"
                          >
                            <div
                              className="flex items-center justify-between p-2 w-full md:w-40 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              {/* Dropdown Text */}
                              <span className="">
                                {selectedAccounts.length > 0 &&
                                selectedAccounts.includes("ALL")
                                  ? "ALL"
                                  : "Select Account"}
                              </span>
                              {/* Dropdown Icon */}
                              <img
                                src={
                                  isOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>
                          </button>

                          {/* Dropdown List */}
                          {isOpen && (
                            <div
                              className="absolute text-xs left-0 mt-2 overflow-y-auto mb-5 md:w-60 w-full bg-white border rounded-md shadow-lg z-50"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              <div className="p-2">
                                <input
                                  type="text"
                                  value={searchAccount}
                                  onChange={(e) =>
                                    setSearchAccount(e.target.value)
                                  }
                                  placeholder="Search..."
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                />
                              </div>
                              {AllAccount.filter((option) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchAccount.toLowerCase())
                              ).map((option) => (
                                <div
                                  key={option.value}
                                  className={`px-4 py-2 flex items-center cursor-pointer ${
                                    selectedAccounts.includes(option.value)
                                      ? "text-white bg-black"
                                      : "text-black bg-white"
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedAccounts.includes(
                                      option.value
                                    )}
                                    onChange={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="custom-checkbox"
                                  />
                                  <span
                                    onClick={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="ml-2"
                                  >
                                    {option.label}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div
                          ref={DateCalendarRef}
                          className="flex items-center z-10 mt-4 md:mt-0 w-full space-x-4"
                        >
                          <div className="relative w-full">
                            {/* Dropdown Trigger */}
                            <div
                              className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              <span>{selectedRange}</span>
                              <img
                                src={
                                  isDropdownOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>

                            {/* Dropdown */}
                            {isDropdownOpen && (
                              <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-80 w-[90vw] lg:w-[650px] max-h-[400px] overflow-auto">
                                <div className="flex  flex-col md:flex-row h-full">
                                  {/* Left: Quick Filters */}
                                  <div className="w-full md:w-1/3 border-r p-3 h-full">
                                    {quickFilters.map((filter) => (
                                      <div
                                        key={filter.value}
                                        className={`p-2 cursor-pointer rounded ${
                                          quickFilter === filter.value
                                            ? "bg-black text-white"
                                            : "hover:bg-gray-200 text-black"
                                        } transition-all duration-200 ease-in-out`}
                                        onClick={() =>
                                          handleQuickFilter(filter.value)
                                        }
                                      >
                                        {filter.label}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Right: Calendar */}
                                  <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                    <Flatpickr
                                      key={selectedDates}
                                      options={{
                                        mode: "range",
                                        inline: true,
                                        dateFormat: "Y-m-d",
                                        showMonths: 2,
                                        defaultDate:
                                          selectedDates.length > 0
                                            ? selectedDates
                                            : [],
                                        shorthandCurrentMonth: true,
                                        locale: {
                                          firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                        },
                                        onChange: (dates) => {
                                          if (
                                            quickFilter === "custom" &&
                                            dates.length === 2
                                          ) {
                                            setSelectedDates(dates);
                                          }
                                        },
                                      }}
                                      className="w-full"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="relative w-full mt-4 md:mt-0 md:w-full">
                          {/* Dropdown Button */}
                          <button
                            onClick={() => {
                              resetAllFilters();
                            }}
                            className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                          >
                            <div className="flex items-center relative">
                              Clear All
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    {transactionTableData != null && (
                      <div className="overflow-x-auto">
                        <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                          <thead className="text-[#8C8C8C] text-sm">
                            <tr className="border border-[#EDEDED]">
                              {headersDashboard.map((header, index) => (
                                <th
                                  key={header.label}
                                  className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8 ||
                              index === 9
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 10
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                                >
                                  <div class="flex items-center">
                                    <span>{header.label}</span>
                                  </div>
                                </th>
                              ))}
                            </tr>
                          </thead>

                          {isLoading ? (
                            <tbody className="shimmer-container-list ">
                              {/* Creating 5 rows of shimmer effect */}
                              {[...Array(5)].map((_, rowIndex) => (
                                <tr key={rowIndex} className="shimmer-row-list">
                                  {/* Creating 7 cells in each row for shimmer */}
                                  {[...Array(9)].map((_, colIndex) => (
                                    <td
                                      key={colIndex}
                                      className="shimmer-cell-list"
                                    >
                                      <div className="shimmer-loader"></div>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody className="text-sm font-medium text-black">
                              {transactionTableData.length > 0 ? (
                                transactionTableData.map((row, index) => (
                                  <React.Fragment key={index}>
                                    <tr
                                      className={`cursor-pointer mb-2 ${
                                        expandedRow === row.id
                                          ? "bg-[#EBF3F8]"
                                          : "bg-[#F9F9F9]"
                                      }`}
                                    >
                                      <td className="px-4 py-2">
                                        <div className="flex items-center space-x-2">
                                          <img
                                            src="/clock.svg"
                                            alt="Time Icon"
                                            className="h-4 w-4"
                                          />
                                          <span className="rounded-xl">
                                            {`${formatDateTransaction(
                                              row.date
                                            )}`}
                                          </span>
                                        </div>
                                      </td>
                                      <td className="p-2">
                                        {row.reference_code}
                                      </td>
                                      <td className="p-2">
                                        {row.account_name}
                                      </td>
                                      <td className="p-2">
                                        {row.convert_rate.toFixed(2)}
                                      </td>
                                      <td className="p-2">
                                        {row.currency.name}
                                      </td>
                                      <td className="p-2  text-[#FF5050]">
                                        {row.currency.symbol}
                                        {row.debit
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>
                                      <td className="p-2  text-[#62D76E]">
                                        {row.currency.symbol}
                                        {row.credit
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>
                                      <td className="p-2">
                                        {row.balance
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>

                                      <td className="px-4 py-2 relative">
                                        <button
                                          ref={(el) =>
                                            (statusButtonRefs.current[
                                              `${row.id}`
                                            ] = el)
                                          }
                                          disabled={
                                            row.status == "pending"
                                              ? false
                                              : true
                                          }
                                          onClick={() =>
                                            handleDropdownToggle(row.id)
                                          }
                                          className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                            row.status == "pending"
                                              ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                              : ""
                                          }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                                    ${
                                      row.status == "completed"
                                        ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                        : ""
                                    }
                              ${
                                row.status == "rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                        >
                                          <span className="mr-6">
                                            {" "}
                                            {row.status
                                              .charAt(0)
                                              .toUpperCase() +
                                              row.status.slice(1)}
                                          </span>
                                          {filter == "" &&
                                            row.status != "approved" && (
                                              <img
                                                src={`${
                                                  openDropdown === row.id
                                                    ? "/Vector.svg"
                                                    : "/down-grey.svg"
                                                }`}
                                                alt="Selected"
                                                className="w-3 h-3 ml-4"
                                              />
                                            )}
                                        </button>
                                      </td>
                                      <td className="p-2">
                                        {row.gateway_status == null
                                          ? ""
                                          : row.gateway_status
                                              .charAt(0)
                                              .toUpperCase() +
                                            row.gateway_status.slice(1)}
                                      </td>
                                      <td
                                        onClick={() => toggleRowDetails(row.id)}
                                        className="text-center rounded-r"
                                      >
                                        {expandedRow === row.id && (
                                          <img
                                            src="/expanded-black.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                        {expandedRow !== row.id && (
                                          <img
                                            src="/down-grey-steps.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                      </td>
                                    </tr>
                                    {expandedRow === row.id && (
                                      <tr>
                                        <td
                                          colSpan={11}
                                          className="bg-[#EEF7FD] w-full"
                                        >
                                          <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4  md:pt-6">
                                                <label
                                                  htmlFor="refId"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  From
                                                </label>
                                                <Tooltip
                                                  nametext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""
                                                  }
                                                  numbertext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_number}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.unique_id}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.unique_id}`
                                                      : ""
                                                  }
                                                  currencytext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency.name
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.name}`
                                                      : `${row.currency.name}`
                                                  }
                                                  amounttext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency
                                                          .amount_in_currency
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.amount_in_currency}`
                                                      : ``
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""}
                                                  </span>
                                                </Tooltip>

                                                <div className="mt-4"></div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Description
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.description}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      To
                                                    </span>
                                                  </label>
                                                  <Tooltip
                                                    nametext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : "Biller"
                                                    }
                                                    numbertext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.unique_id}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_number}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""
                                                    }
                                                    currencytext={
                                                      row.mode == "transfer"
                                                        ? row.to_account
                                                            .currency.name
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.name}`
                                                        : `${row.currency.name}`
                                                    }
                                                    amounttext={
                                                      row.mode == "transfer" ||
                                                      row.mode == "bpay"
                                                        ? row.to_account
                                                            .currency
                                                            .amount_in_currency
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.amount_in_currency}`
                                                        : ``
                                                    }
                                                  >
                                                    <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                      {row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""}
                                                    </span>
                                                  </Tooltip>
                                                </div>
                                              </div>
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Ip address
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.ip_address}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4 md:pt-6">
                                                <div className="mt-4">
                                                  <label
                                                    htmlFor="investmentType"
                                                    className="mb-1 text-xs text-[#A6A6A6]"
                                                  >
                                                    Initiated by
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.created_by}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                  >
                                                    Signatories
                                                  </label>
                                                  <div className="text-sm">
                                                    <span>
                                                      {row.approved_by} (
                                                      {formatDateTransaction(
                                                        row.date
                                                      )}
                                                      )
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-4" colSpan="7">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>
                    )}
                    {transactionTableData != null && (
                      <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                        {/* Entries Info Section */}
                        <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                          Showing {showRecords * (currentPage - 1) + 1} to{" "}
                          {currentPage === totalPages || totalPages == 0
                            ? totalCount
                            : Math.max(
                                showRecords * currentPage,
                                transactionTableData.length
                              )}{" "}
                          of {totalCount} entries
                        </div>

                        {/* Pagination Section */}
                        <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                          {/* Previous Button */}
                          <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Prev
                          </button>

                          {/* Page Buttons */}
                          {Array.from({ length: Math.min(totalPages, 5) }).map(
                            (_, index) => {
                              const startPage = Math.max(
                                1,
                                Math.min(totalPages - 4, currentPage - 2)
                              );
                              const page = startPage + index;

                              return (
                                <button
                                  key={page}
                                  onClick={() => setCurrentPage(page)}
                                  className={`px-3 py-1 rounded ${
                                    currentPage === page
                                      ? "bg-black text-white"
                                      : "bg-white border border-gray-300 text-black"
                                  }`}
                                >
                                  {page}
                                </button>
                              );
                            }
                          )}

                          {/* Next Button */}
                          <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {filter == "request" && (
                <div className=" bg-white mt-4 p-4 px-4 shadow-md rounded-md">
                  <div className="flex flex-wrap justify-between items-center border-b border-colour-custom px-4 py-2 gap-y-4">
                    {/* Left: Title */}
                    <h1 className="text-xl font-medium text-black">Requests</h1>

                    {/* Right: Download & Add Transaction */}
                    <div className="flex flex-wrap justify-end items-center gap-2 w-full sm:w-auto">
                      {/* Download Dropdown */}
                      <div ref={DownloadRef} className="relative">
                        <div
                          className="flex items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                          onClick={() =>
                            setIsOpenDownloadReport(!isOpenDownloadReport)
                          }
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <img
                            src="/download-small-arrow.svg"
                            alt="Dropdown"
                            className="w-2 h-2 ml-auto"
                          />
                        </div>

                        {isOpenDownloadReport && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                            {reportOptions.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDFTable(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Add Transaction Button */}
                      <button
                        onClick={() => {
                          getAllUsersDashboard();
                          togglePopupAddTransactionCashAccount();
                        }}
                        className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                      >
                        <img
                          src="/Plus.svg"
                          alt="Add Icon"
                          className="mr-2 ml-2"
                        />
                        <span className="inline">Add Transaction</span>
                      </button>
                    </div>
                  </div>

                  {isOpenEditCashAccount && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                        {/* Modal Header */}
                        <div className="flex flex-wrap items-center justify-between mb-6 text-sm md:text-base">
                          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 w-full">
                            {/* Left Tabs */}
                            <div className="flex items-center space-x-2 md:space-x-4">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  resetAllFiltersCashAccount();
                                  getAllUsersDashboard();
                                  setTransactionTab("addTransaction");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addTransaction"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add Transaction
                              </span>
                              <span className="hidden md:block text-[#B2B2B2]">
                                |
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearAllFieldsBank();
                                  setTransactionTab("addThirdPartyBank");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addThirdPartyBank"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add Third Party Bank
                              </span>
                            </div>

                            {/* Right Add Button */}
                            <div className="flex justify-end">
                              <img
                                onClick={togglePopupAddTransactionCashAccount}
                                src="/add.svg"
                                alt="Add"
                                className="w-10 h-10 cursor-pointer"
                              />
                            </div>
                          </div>

                          {/* <button onClick={togglePopupAddTransaction}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button> */}
                        </div>
                        {transactionTab === "addTransaction" && (
                          <div>
                            {summaryDetails === false && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Add New Transaction
                                  </h2>
                                  <button
                                    onClick={
                                      togglePopupAddTransactionCashAccount
                                    }
                                  ></button>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <div className="">
                                      <Dropdown
                                        label="Transaction Type"
                                        options={transactionTypeMore}
                                        preselectedValue={
                                          preselectedTransactionType
                                        }
                                        onSelect={handleTransactionType}
                                      />
                                    </div>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <Dropdown
                                          label="RTGS/International/Normal"
                                          options={transactionTypeSecond}
                                          preselectedValue={
                                            preselectedTransactionTypeSecond
                                          }
                                          onSelect={handleTransactionTypeSecond}
                                        />
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={nabFees}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                        <div className="flex items-center space-x-2 mt-4">
                                          <input
                                            type="checkbox"
                                            id="confirm-all"
                                            className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                                            checked={isCheckedSecond}
                                            onChange={(e) =>
                                              setIsCheckedSecond(
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor="confirm-all"
                                            className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                                          >
                                            I accept the applicable fees.
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <textarea
                                        type="text"
                                        name="documentId"
                                        value={commentsCashAccount}
                                        maxLength={18}
                                        onChange={(e) =>
                                          setCommentsCashAccount(e.target.value)
                                        }
                                        className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                        placeholder="Add your comments"
                                      />
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-xs text-labelColour whitespace-normal words-break"
                                      >
                                        You can enter only up to 18 characters
                                      </label>{" "}
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>
                                      <input
                                        type="date"
                                        value={creationDate}
                                        onChange={(e) =>
                                          setCreationDate(e.target.value)
                                        }
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                        <input
                                          type="text"
                                          name="field2"
                                          value={
                                            isFocused
                                              ? transactionAmount
                                              : formatNumber(transactionAmount)
                                          }
                                          ref={inputRef}
                                          onChange={(e) => {
                                            if (!isFocused) return;
                                            handleChangeAmount(
                                              e,
                                              e.target.value
                                            );
                                          }}
                                          onFocus={() => setIsFocused(true)}
                                          onBlur={() => setIsFocused(false)}
                                          className="p-2 w-full text-black font-medium outline-none text-md"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div className="">
                                          <Dropdown
                                            label="Set Recurrence"
                                            options={recurringTypes}
                                            preselectedValue={
                                              preselectedRecurringType
                                            }
                                            onSelect={handleRecurringType}
                                          />
                                        </div>
                                        {recurringTypeValue != "never" && (
                                          <>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                Start Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recStartDate}
                                                onChange={(e) => {
                                                  const newStart =
                                                    e.target.value;
                                                  setRecStartDate(newStart);

                                                  // Auto-clear end date if it becomes invalid
                                                  if (
                                                    recEndDate &&
                                                    recEndDate < newStart
                                                  ) {
                                                    setRecEndDate("");
                                                  }
                                                }}
                                                min={getCurrentDate()}
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                End Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recEndDate}
                                                onChange={(e) =>
                                                  setRecEndDate(e.target.value)
                                                }
                                                min={
                                                  recStartDate ||
                                                  getCurrentDate()
                                                }
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        <div className="">
                                          <Dropdown
                                            key={`${transactionTypeValue}-${customerOptionsFrom.length}`}
                                            label="Select Customer"
                                            options={customerOptionsFrom}
                                            preselectedValue={
                                              preSelectedCustomerNameCashAccount
                                            }
                                            search={true}
                                            onSelect={
                                              handleSelectCustomerNameCashAccount
                                            }
                                          />
                                        </div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour mt-4"
                                        >
                                          Currency
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromCurrencyCashAccount}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        <div>
                                          {(transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment") && (
                                            <Dropdown
                                              label="Select Account"
                                              options={fromCustomerAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                          {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            fromCustomerName === "-1" && (
                                              <Dropdown
                                                label="Select Account"
                                                options={allBanks}
                                                preselectedValue={
                                                  preSelectedFromuserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleFromAccountHolderNumber
                                                }
                                              />
                                            )}

                                          {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            fromCustomerName !== "-1" && (
                                              <Dropdown
                                                label="Select Bank Type"
                                                options={bankType}
                                                preselectedValue={
                                                  preselectedBankType
                                                }
                                                onSelect={handleChangeBankType}
                                              />
                                            )}
                                          {(transactionTypeValue ==
                                            "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment" ||
                                            (transactionTypeValue == "debit" &&
                                              transactionTypeValueSecond ==
                                                "international")) && (
                                            <>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour mt-4"
                                              >
                                                Currency Rate
                                              </label>{" "}
                                              <input
                                                id="accbalance"
                                                type="text"
                                                value="1.00"
                                                disabled={true}
                                                className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                                placeholder="CT0291288"
                                              />
                                            </>
                                          )}
                                        </div>
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue != "debit" &&
                                          transactionTypeValue != "transfer" &&
                                          transactionTypeValue !=
                                            "billPayment" &&
                                          fromCustomerName !== "-1" &&
                                          bankTypeValue == 1 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={bankAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {transactionTypeValue != "debit" &&
                                          transactionTypeValue != "transfer" &&
                                          fromCustomerName !== "-1" &&
                                          bankTypeValue == 2 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={
                                                thirdPartyBankAccountData
                                              }
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromAccountNumber}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <div className="">
                                              <Dropdown
                                                key={`${transactionTypeValue}-${customerOptionsTo.length}`}
                                                label="Select Customer"
                                                options={customerOptionsTo}
                                                preselectedValue={
                                                  preSelectedCustomerNameCashAccountTo
                                                }
                                                search={true}
                                                onSelect={
                                                  handleSelectCustomerNameCashAccountTo
                                                }
                                              />
                                            </div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toCurrencyCashAccount}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="AUD"
                                            />
                                          </>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerCode"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller Code
                                            </label>{" "}
                                            <input
                                              id="billerCode"
                                              type="text"
                                              value={billerCode}
                                              onChange={(e) =>
                                                setBillerCode(e.target.value)
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0 md:border-r  sm:border-l-0 border-r-0 md:border-l  border-gray-300 px-4">
                                        {transactionTypeValue == "transfer" && (
                                          <div>
                                            <Dropdown
                                              label="Select Account"
                                              options={toCustomerAccountData}
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          </div>
                                        )}
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <Dropdown
                                              label="Select Account"
                                              options={fromCustomerAccountData}
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          </div>
                                        )}

                                        {transactionTypeValue == "debit" &&
                                          toCustomerName === "-1" && (
                                            <div>
                                              <Dropdown
                                                label="Select Account"
                                                options={allBanks}
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            </div>
                                          )}
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" && (
                                            <Dropdown
                                              label="Select Bank Type"
                                              options={bankType}
                                              preselectedValue={
                                                preselectedBankType
                                              }
                                              onSelect={handleChangeBankType}
                                            />
                                          )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={finalConvertedRate}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerRefnumber"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <input
                                              id="billerRefnumber"
                                              type="text"
                                              value={billerRefnumber}
                                              onChange={(e) =>
                                                setBillerRefnumber(
                                                  e.target.value
                                                )
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" &&
                                          bankTypeValue == 1 && (
                                            <div>
                                              <Dropdown
                                                label="Select Account"
                                                options={bankAccountData}
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            </div>
                                          )}
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" &&
                                          bankTypeValue == 2 && (
                                            <div>
                                              <Dropdown
                                                label="Select Account"
                                                options={
                                                  thirdPartyBankAccountData
                                                }
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            </div>
                                          )}
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={
                                                isFocusedFinal
                                                  ? finalConvertedAmount
                                                  : formatNumber(
                                                      finalConvertedAmount
                                                    )
                                              }
                                              ref={inputRefFinal}
                                              onChange={(e) => {
                                                if (!isFocusedFinal) return;
                                                handleChangeAmountFinal(
                                                  e,
                                                  e.target.value
                                                );
                                              }}
                                              onFocus={() =>
                                                setIsFocusedFinal(true)
                                              }
                                              onBlur={() =>
                                                setIsFocusedFinal(false)
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="100.00"
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          togglePopupAddTransactionCashAccount();
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (!transactionAmount) {
                                            showToast(
                                              "Please Add valid amount",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromCustomerName) {
                                            showToast(
                                              "Please Select From Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toCustomerName
                                          ) {
                                            showToast(
                                              "Please Select To Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "Please Select To Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromAccountIdCashAccount) {
                                            showToast(
                                              "Please Select From Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            fromAccountIdCashAccount ==
                                            toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "From and To account can't be same",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!creationDate) {
                                            showToast(
                                              "Please Select Transaction Date",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recStartDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence start date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recEndDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence end date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!commentsCashAccount) {
                                            showToast(
                                              "Please Add some description",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            (transactionTypeValue == "debit" ||
                                              transactionTypeValue ==
                                                "credit") &&
                                            isCheckedSecond == false
                                          ) {
                                            showToast(
                                              "Please confirm applicable fees",
                                              "error"
                                            ); // Success toast
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerCode
                                          ) {
                                            showToast(
                                              "Please enter biller code",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerRefnumber
                                          ) {
                                            showToast(
                                              "Please enter reference number",
                                              "error"
                                            );
                                            return;
                                          }
                                          setSummaryDetails(true);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Next
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                            {summaryDetails === true && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Transaction Summary
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Transaction Type
                                    </label>{" "}
                                    <span>{transactionTypeName}</span>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          RTGS/International/Normal
                                        </label>{" "}
                                        <span>{transactionTypeNameSecond}</span>
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <span>{nabFees}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <span>{commentsCashAccount}</span>
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>

                                      <span>
                                        {formatDateForFilterNew(creationDate)}
                                      </span>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center">
                                        <span>
                                          $
                                          {Number(transactionAmount)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div>
                                          <label
                                            htmlFor="Recurring Frequency"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Recurring Frequency
                                          </label>{" "}
                                          <span>{recurringTypeLabel}</span>
                                        </div>
                                        {recurringTypeValue != "never" && (
                                          <>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                Start Date
                                              </label>
                                              <span>
                                                {formatDateForFilterNew(
                                                  recStartDate
                                                )}
                                              </span>
                                            </div>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                End Date
                                              </label>
                                              <span>
                                                {formatDateForFilterNew(
                                                  recEndDate
                                                )}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-0">
                                        <div className="">
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Selected Customer
                                          </label>{" "}
                                          <span>{fromCustomerLabel}</span>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Currency
                                          </label>{" "}
                                          <span>{fromCurrencyCashAccount}</span>
                                        </div>
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            fromCustomerName !== "-1"
                                              ? "Selected Bank Type"
                                              : "Selected Account"}
                                          </label>{" "}
                                          <span>
                                            {transactionTypeValue != "debit" &&
                                            transactionTypeValue !=
                                              "transfer" &&
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            fromCustomerName !== "-1"
                                              ? bankTypeLabel
                                              : fromAccountIdCashAccountLabel}
                                          </span>
                                        </div>
                                        {(transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>1.00</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue != "debit" &&
                                          transactionTypeValue != "transfer" &&
                                          transactionTypeValue !=
                                            "billPayment" &&
                                          fromCustomerName !== "-1" && (
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Account
                                              </label>{" "}
                                              <span>
                                                {fromAccountIdCashAccountLabel}
                                              </span>
                                            </div>
                                          )}
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Account Number
                                          </label>{" "}
                                          <span>{fromAccountNumber}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-0">
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <div className="">
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Customer
                                              </label>{" "}
                                              <span>{toCustomerNameLabel}</span>
                                            </div>
                                            <div className="">
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Currency
                                              </label>{" "}
                                              <span>
                                                {toCurrencyCashAccount}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller code
                                            </label>{" "}
                                            <span>{billerCode}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Center Column with Border */}
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <span>{billerRefnumber}</span>
                                          </div>
                                        )}
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              {transactionTypeValue ==
                                                "debit" &&
                                              toCustomerName !== "-1"
                                                ? "Selected Bank Type"
                                                : "Selected Account"}
                                            </label>{" "}
                                            <span>
                                              {" "}
                                              {transactionTypeValue ==
                                                "debit" &&
                                              toCustomerName !== "-1"
                                                ? bankTypeLabel
                                                : toAccountIdCashAccountLabel}
                                            </span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>{finalConvertedRate}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" &&
                                          toCustomerName !== "-1" && (
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Account
                                              </label>{" "}
                                              <span>
                                                {toAccountIdCashAccountLabel}
                                              </span>
                                            </div>
                                          )}
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <span>{toAccountNumber}</span>
                                          </div>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <span>
                                              {Number(finalConvertedAmount)
                                                .toFixed(2)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ","
                                                )}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setSummaryDetails(false);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Back
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setLoading(true);
                                          handleAddTransacionCashAccount(e);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Transfer Now
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {transactionTab === "addThirdPartyBank" && (
                          <div>
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New Third Party Bank
                              </h2>
                            </div>
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-4">
                                {/* Code */}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountName}
                                    onChange={(e) =>
                                      setToAccountName(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="John Doe"
                                  />
                                </div>
                                {countryCode != "AE" &&
                                  countryCode != "GB" &&
                                  !isEuropeanCountry(countryCode) && (
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Account Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={toAccountNumber}
                                        onChange={(e) =>
                                          setToAccountNumber(e.target.value)
                                        }
                                        className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="0291288"
                                      />
                                    </div>
                                  )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Bank Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toBank}
                                    onChange={(e) => setToBank(e.target.value)}
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Bank Name"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Select Country"
                                    options={countryCodeData}
                                    search={true}
                                    preselectedValue={preselectedCountryCode}
                                    onSelect={handleSelectCountryCode}
                                    colorLabel=""
                                  />
                                </div>
                                <div className="">
                                  <Dropdown
                                    label="Currency"
                                    options={currencyData}
                                    search={true}
                                    preselectedValue={preselectedcashCurrency}
                                    onSelect={handleSelectToCurrency}
                                    colorLabel=""
                                  />
                                </div>
                                {countryCode == "AU" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      BSB
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={toBsb}
                                      maxLength={6}
                                      onChange={(e) =>
                                        handleBsbChange(e.target.value)
                                      }
                                      className={`${
                                        bsbError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000"
                                    />
                                    {bsbError && (
                                      <p className="text-red-600 text-xs mt-1">
                                        {bsbError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Swift/BIC code
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={swiftCode}
                                    onChange={handleSwiftChange}
                                    className={`${
                                      swiftError && countryCode != "AU"
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="000000"
                                  />
                                  {swiftError && countryCode != "AU" && (
                                    <p className="text-red-500 text-xs mt-1">
                                      {swiftError}
                                    </p>
                                  )}
                                </div>
                                {countryCode == "US" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Routing Number (ABA)
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={routingNumber}
                                      maxLength={9}
                                      onChange={(e) =>
                                        handleRoutingChange(e.target.value)
                                      }
                                      className={`${
                                        routingError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000000"
                                    />
                                    {routingError && (
                                      <p className="text-red-600 text-sm mt-1">
                                        {routingError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {countryCode == "CA" && (
                                  <>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transit Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={transitNumber}
                                        maxLength={5}
                                        onChange={(e) =>
                                          handleTransitChange(e.target.value)
                                        }
                                        className={`${
                                          transitError
                                            ? "border-red-300 "
                                            : "border-gray-300 "
                                        }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                        placeholder="00000"
                                      />
                                      {transitError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          {transitError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Institution Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={institutionNumber}
                                        onChange={(e) =>
                                          setinstitutionNumber(e.target.value)
                                        }
                                        className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="000000"
                                      />
                                    </div>
                                  </>
                                )}
                                {(countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      IBAN
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={iban}
                                      onChange={handleChangeIban}
                                      className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                      placeholder="000000"
                                    />
                                    {error && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {error}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 1
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine1}
                                    onChange={(e) =>
                                      setAddressLine1(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Street address"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 2
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine2}
                                    onChange={(e) =>
                                      setAddressLine2(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Apartment, unit etc."
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 3
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine3}
                                    onChange={(e) =>
                                      setAddressLine3(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="City, Country etc."
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                              <button
                                onClick={togglePopupAddTransactionCashAccount}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    countryCode == "AU" &&
                                    (!toBsb || bsbError)
                                  ) {
                                    showToast(
                                      "Please enter a valid BSB",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "US" &&
                                    (!routingNumber || routingError)
                                  ) {
                                    showToast(
                                      "Please enter a valid routing number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    (countryCode == "AE" ||
                                      countryCode == "GB" ||
                                      isEuropeanCountry(countryCode)) &&
                                    !iban
                                  ) {
                                    showToast("Please enter iban", "error");
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    (!transitNumber || transitError)
                                  ) {
                                    showToast(
                                      "Please enter a valid transit number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    !institutionNumber
                                  ) {
                                    showToast(
                                      "Please enter institution number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AU" &&
                                    (!swiftCode || swiftError)
                                  ) {
                                    showToast(
                                      "Please enter a valid swift code/BIC code",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (error) {
                                    showToast(
                                      "Please enter valid iban",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AE" &&
                                    countryCode != "GB" &&
                                    !isEuropeanCountry(countryCode) &&
                                    !toAccountNumber
                                  ) {
                                    showToast(
                                      "Please enter account number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    !toAccountName ||
                                    !toCurrency ||
                                    !addressLine1 ||
                                    !addressLine2 ||
                                    !addressLine3 ||
                                    !countryCode ||
                                    !toBank
                                  ) {
                                    showToast("Please Add all fields", "error");
                                    return;
                                  }
                                  setLoading(true);
                                  handleAddBank(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Add Bank
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="p-4">
                    {/* Filters Section */}
                    <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                      <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                        <div className="flex items-center space-x-2">
                          <span className="lg:text-md  text-sm text-[#8C8C8C]">
                            Show Records
                          </span>
                          <Dropdown
                            label=""
                            options={filterOptions}
                            preselectedValue={preSelectedFilter}
                            onSelect={handleshowRecord}
                          />
                        </div>
                        <div className="flex items-center">
                          <div className="relative">
                            <input
                              type="text"
                              className="p-2 pl-8 border rounded-xl"
                              placeholder="Search Requests"
                              value={searchQuery}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                setCurrentPage(1);
                              }}
                            />
                            <span className="absolute left-2 top-3 text-gray-500">
                              {" "}
                              <img
                                src="/search-normal.svg"
                                alt="Company Logo"
                                className="mr-2"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                        <div
                          ref={accountRef}
                          className="relative w-full mt-4 md:mt-0 md:w-full"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="w-full  font-medium border-gray-300  rounded-xl text-sm  py-2 flex items-center justify-between focus:outline-none bg-white text-black"
                          >
                            <div
                              className="flex items-center justify-between p-2 w-full md:w-40 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              {/* Dropdown Text */}
                              <span className="">
                                {selectedAccounts.length > 0 &&
                                selectedAccounts.includes("ALL")
                                  ? "ALL"
                                  : "Select Account"}
                              </span>
                              {/* Dropdown Icon */}
                              <img
                                src={
                                  isOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>
                          </button>

                          {/* Dropdown List */}
                          {isOpen && (
                            <div
                              className="absolute text-xs left-0 mt-2 overflow-y-auto mb-5 md:w-60 w-full bg-white border rounded-md shadow-lg z-50"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              <div className="p-2">
                                <input
                                  type="text"
                                  value={searchAccount}
                                  onChange={(e) =>
                                    setSearchAccount(e.target.value)
                                  }
                                  placeholder="Search..."
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                />
                              </div>
                              {AllAccount.filter((option) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchAccount.toLowerCase())
                              ).map((option) => (
                                <div
                                  key={option.value}
                                  className={`px-4 py-2 flex items-center cursor-pointer ${
                                    selectedAccounts.includes(option.value)
                                      ? "text-white bg-black"
                                      : "text-black bg-white"
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedAccounts.includes(
                                      option.value
                                    )}
                                    onChange={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="custom-checkbox"
                                  />
                                  <span
                                    onClick={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="ml-2"
                                  >
                                    {option.label}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div
                          ref={DateCalendarRef}
                          className="flex items-center  w-full space-x-4"
                        >
                          <div className="relative w-full">
                            {/* Dropdown Trigger */}
                            <div
                              className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              <span>{selectedRange}</span>
                              <img
                                src={
                                  isDropdownOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>

                            {/* Dropdown */}
                            {isDropdownOpen && (
                              <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] lg:w-[650px] max-h-[400px] overflow-auto">
                                <div className="flex  flex-col md:flex-row h-full">
                                  {/* Left: Quick Filters */}
                                  <div className="w-full md:w-1/3 border-r p-3 h-full">
                                    {quickFilters.map((filter) => (
                                      <div
                                        key={filter.value}
                                        className={`p-2 cursor-pointer rounded ${
                                          quickFilter === filter.value
                                            ? "bg-black text-white"
                                            : "hover:bg-gray-200 text-black"
                                        } transition-all duration-200 ease-in-out`}
                                        onClick={() =>
                                          handleQuickFilter(filter.value)
                                        }
                                      >
                                        {filter.label}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Right: Calendar */}
                                  <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                    <Flatpickr
                                      key={selectedDates}
                                      options={{
                                        mode: "range",
                                        inline: true,
                                        dateFormat: "Y-m-d",
                                        showMonths: 2,
                                        defaultDate:
                                          selectedDates.length > 0
                                            ? selectedDates
                                            : [],
                                        shorthandCurrentMonth: true,
                                        locale: {
                                          firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                        },
                                        onChange: (dates) => {
                                          if (
                                            quickFilter === "custom" &&
                                            dates.length === 2
                                          ) {
                                            setSelectedDates(dates);
                                          }
                                        },
                                      }}
                                      className="w-full"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="relative w-full mt-4 md:mt-0 md:w-full">
                          {/* Dropdown Button */}
                          <button
                            onClick={() => {
                              resetAllFilters();
                            }}
                            className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                          >
                            <div className="flex items-center relative">
                              Clear All
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Table */}
                    {transactionTableData != null && (
                      <div className="overflow-x-auto">
                        <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                          <thead className="text-[#8C8C8C] text-sm">
                            <tr className="border border-[#EDEDED]">
                              {withOutheadersRequestDashboard.map(
                                (header, index) => (
                                  <th
                                    key={header.label}
                                    className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8 ||
                              index === 9
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 10
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                                  >
                                    <div class="flex items-center">
                                      <span>{header.label}</span>
                                    </div>
                                  </th>
                                )
                              )}
                            </tr>
                          </thead>

                          {isLoading ? (
                            <tbody className="shimmer-container-list ">
                              {/* Creating 5 rows of shimmer effect */}
                              {[...Array(5)].map((_, rowIndex) => (
                                <tr key={rowIndex} className="shimmer-row-list">
                                  {/* Creating 7 cells in each row for shimmer */}
                                  {[...Array(8)].map((_, colIndex) => (
                                    <td
                                      key={colIndex}
                                      className="shimmer-cell-list"
                                    >
                                      <div className="shimmer-loader"></div>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody className="text-sm font-medium text-black">
                              {transactionTableData.length > 0 ? (
                                transactionTableData.map((row, index) => (
                                  <React.Fragment key={index}>
                                    <tr
                                      className={`cursor-pointer mb-2 ${
                                        expandedRow === row.id
                                          ? "bg-[#EBF3F8]"
                                          : "bg-[#F9F9F9]"
                                      }`}
                                    >
                                      <td className="px-4 py-2">
                                        <div className="flex items-center space-x-2">
                                          <img
                                            src="/clock.svg"
                                            alt="Time Icon"
                                            className="h-4 w-4"
                                          />
                                          <span className="rounded-xl">
                                            {`${formatDateTransaction(
                                              row.date
                                            )}`}
                                          </span>
                                        </div>
                                      </td>
                                      <td className="p-2">
                                        {row.reference_code}
                                      </td>
                                      <td className="p-2">
                                        {row.account_name}
                                      </td>
                                      <td className="p-2">
                                        ${row.convert_rate.toFixed(2)}
                                      </td>
                                      <td className="p-2">
                                        {row.currency.name}
                                      </td>
                                      <td className="p-2  text-[#FF5050]">
                                        {row.currency.symbol}
                                        {row.debit
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>
                                      <td className="p-2  text-[#62D76E]">
                                        {row.currency.symbol}
                                        {row.credit
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>

                                      <td className="px-4 py-2 relative">
                                        <button
                                          ref={(el) =>
                                            (statusButtonRefs.current[
                                              `${row.id}`
                                            ] = el)
                                          }
                                          disabled={
                                            row.status == "pending"
                                              ? false
                                              : true
                                          }
                                          onClick={() =>
                                            handleDropdownToggle(row.id)
                                          }
                                          className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                            row.status == "pending"
                                              ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                              : ""
                                          }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                                    ${
                                      row.status == "completed"
                                        ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                        : ""
                                    }
                              ${
                                row.status == "rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                        >
                                          <span className="mr-6">
                                            {" "}
                                            {row.status
                                              .charAt(0)
                                              .toUpperCase() +
                                              row.status.slice(1)}
                                          </span>
                                          {filter == "" &&
                                            row.status != "approved" && (
                                              <img
                                                src={`${
                                                  openDropdown === row.id
                                                    ? "/Vector.svg"
                                                    : "/down-grey.svg"
                                                }`}
                                                alt="Selected"
                                                className="w-3 h-3 ml-4"
                                              />
                                            )}
                                        </button>
                                      </td>
                                      <td className="p-2">
                                        {row.gateway_status == null
                                          ? ""
                                          : row.gateway_status
                                              .charAt(0)
                                              .toUpperCase() +
                                            row.gateway_status.slice(1)}
                                      </td>
                                      <td
                                        onClick={() => toggleRowDetails(row.id)}
                                        className="text-center rounded-r"
                                      >
                                        {expandedRow === row.id && (
                                          <img
                                            src="/expanded-black.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                        {expandedRow !== row.id && (
                                          <img
                                            src="/down-grey-steps.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                      </td>
                                      <td className="text-center px-4 rounded-r">
                                        {/* Status and Button */}
                                        <div className="relative flex items-center justify-between w-full">
                                          {/* Status */}
                                          <span className="flex items-center">
                                            {/* Dropdown Button */}
                                            <button
                                              ref={(el) =>
                                                (statusButtonRefs.current[
                                                  `${row.id}`
                                                ] = el)
                                              }
                                              onClick={() => {
                                                setIsMenuOpen((prev) =>
                                                  prev === row.id
                                                    ? null
                                                    : row.id
                                                );
                                              }}
                                              className="flex items-center justify-center"
                                            >
                                              <img
                                                src="/three-dots.svg"
                                                alt="Actions"
                                                className="h-6 w-6 ml-4 object-contain"
                                              />
                                            </button>
                                          </span>
                                          <DropdownTest
                                            isOpen={
                                              dotMenuOpened &&
                                              isMenuOpen === row.id
                                            }
                                            buttonRef={
                                              statusButtonRefs.current[
                                                `${row.id}`
                                              ]
                                            } // Pass unique ref to the dropdown
                                          >
                                            <div className="absolute top-full right-0 text-xs mt-2 w-40 bg-white rounded-md shadow-lg z-50">
                                              <button
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setTransactionRemarksId(
                                                    row.id
                                                  );
                                                  setTransactionRemarksStatus(
                                                    "rejected"
                                                  );
                                                  setIsMenuOpen((prev) =>
                                                    prev === row.id
                                                      ? null
                                                      : row.id
                                                  );
                                                  togglePopupEditRemarks(true);
                                                }}
                                                className="block w-full text-left hover:bg-black hover:text-white px-4 py-2"
                                              >
                                                Reject Request
                                              </button>
                                              <button
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setTransactionRemarksId(
                                                    row.id
                                                  );
                                                  setTransactionRemarksStatus(
                                                    "approved"
                                                  );
                                                  setIsMenuOpen((prev) =>
                                                    prev === row.id
                                                      ? null
                                                      : row.id
                                                  );
                                                  togglePopupEditRemarks(true);
                                                }}
                                                className="block w-full hover:bg-black hover:text-white text-left px-4 py-2"
                                              >
                                                Approve Request
                                              </button>
                                              {/* <button
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleStatusChange(
                                                  e,
                                                  "pending",
                                                  row.id
                                                );
                                                setIsMenuOpen((prev) =>
                                                  prev === row.id
                                                    ? null
                                                    : row.id
                                                );
                                              }}
                                              className="block w-full hover:bg-black hover:text-white text-left px-4 py-2"
                                            >
                                              Active Reject Request{" "}
                                            </button> */}
                                            </div>
                                          </DropdownTest>
                                        </div>
                                      </td>
                                    </tr>
                                    {expandedRow === row.id && (
                                      <tr>
                                        <td
                                          colSpan={11}
                                          className="bg-[#EEF7FD] w-full"
                                        >
                                          <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4  md:pt-6">
                                                <label
                                                  htmlFor="refId"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  From
                                                </label>
                                                <Tooltip
                                                  nametext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""
                                                  }
                                                  numbertext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_number}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.unique_id}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.unique_id}`
                                                      : ""
                                                  }
                                                  currencytext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency.name
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.name}`
                                                      : `${row.currency.name}`
                                                  }
                                                  amounttext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency
                                                          .amount_in_currency
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.amount_in_currency}`
                                                      : ``
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""}
                                                  </span>
                                                </Tooltip>

                                                <div className="mt-4"></div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Description
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.description}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      To
                                                    </span>
                                                  </label>
                                                  <Tooltip
                                                    nametext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : "Biller"
                                                    }
                                                    numbertext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.unique_id}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_number}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""
                                                    }
                                                    currencytext={
                                                      row.mode == "transfer"
                                                        ? row.to_account
                                                            .currency.name
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.name}`
                                                        : `${row.currency.name}`
                                                    }
                                                    amounttext={
                                                      row.mode == "transfer" ||
                                                      row.mode == "bpay"
                                                        ? row.to_account
                                                            .currency
                                                            .amount_in_currency
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.amount_in_currency}`
                                                        : ``
                                                    }
                                                  >
                                                    <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                      {row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""}
                                                    </span>
                                                  </Tooltip>
                                                </div>
                                              </div>
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Ip address
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.ip_address}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4 md:pt-6">
                                                <div className="mt-4">
                                                  <label
                                                    htmlFor="investmentType"
                                                    className="mb-1 text-xs text-[#A6A6A6]"
                                                  >
                                                    Initiated by
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.created_by}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                  >
                                                    Signatories
                                                  </label>
                                                  <div className="text-sm">
                                                    <span>
                                                      {row.approved_by} (
                                                      {formatDateTransaction(
                                                        row.date
                                                      )}
                                                      )
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-4" colSpan="7">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          )}
                        </table>
                        {isOpenRemarksPopup && (
                          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white rounded-lg w-[70%] md:w-[500px] p-6">
                              {/* Modal Header */}
                              <div className="flex items-center justify-between mb-4">
                                <h2 className="text-lg font-medium text-center w-full">
                                  Update Transaction
                                </h2>
                                <button onClick={togglePopupEditRemarks}>
                                  <img
                                    src="/add.svg"
                                    alt="Close"
                                    className="w-10 h-10"
                                  />
                                </button>
                              </div>

                              {/* Modal Body */}
                              <div className="grid grid-cols-1  gap-6">
                                <div className="flex flex-col mx-auto max-w-sm w-full">
                                  <label
                                    htmlFor="stockCode"
                                    className="mb-1 mt-4 text-sm text-labelColour block"
                                  >
                                    Remarks
                                  </label>
                                  <textarea
                                    type="text"
                                    name="documentId"
                                    value={transactionStatusRemarks}
                                    maxLength={18}
                                    onChange={(e) =>
                                      setTransactionStatusRemarks(
                                        e.target.value
                                      )
                                    }
                                    className="w-full resize-none bg-white text-black rounded-xl px-3 py-4"
                                    placeholder="Add your comments"
                                  />
                                </div>
                                {/* Risk type */}
                                <div className="flex flex-col mx-auto max-w-sm w-full"></div>
                              </div>

                              {/* Modal Footer */}
                              <div className="flex justify-center space-x-4 mt-6">
                                <button
                                  onClick={togglePopupEditRemarks}
                                  className="px-8 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setLoading(true);
                                    handleStatusChange(
                                      e,
                                      transactionRemarksStatus,
                                      transactionRemarksId
                                    );
                                  }}
                                  className="px-8 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                >
                                  Confirm
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {transactionTableData != null && (
                      <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                        {/* Entries Info Section */}
                        <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                          Showing {showRecords * (currentPage - 1) + 1} to{" "}
                          {currentPage === totalPages || totalPages == 0
                            ? totalCount
                            : Math.max(
                                showRecords * currentPage,
                                transactionTableData.length
                              )}{" "}
                          of {totalCount} entries
                        </div>

                        {/* Pagination Section */}
                        <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                          {/* Previous Button */}
                          <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Prev
                          </button>

                          {/* Page Buttons */}
                          {Array.from({ length: Math.min(totalPages, 5) }).map(
                            (_, index) => {
                              const startPage = Math.max(
                                1,
                                Math.min(totalPages - 4, currentPage - 2)
                              );
                              const page = startPage + index;

                              return (
                                <button
                                  key={page}
                                  onClick={() => setCurrentPage(page)}
                                  className={`px-3 py-1 rounded ${
                                    currentPage === page
                                      ? "bg-black text-white"
                                      : "bg-white border border-gray-300 text-black"
                                  }`}
                                >
                                  {page}
                                </button>
                              );
                            }
                          )}

                          {/* Next Button */}
                          <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          {activeCard && activeCard.id == "2" && (
            <div>
              {loading && (
                <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
                  <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
              )}
              <div className="bg-white p-4 shadow-md rounded-md">
                <div className="flex justify-between items-center border-b border-colour-custom px-4 py-2 flex-wrap">
                  {/* Left: Title */}
                  <h3 className="text-lg font-medium mb-2  md:text-ellipsis  md:overflow-hidden md:whitespace-nowrap md:mb-0">
                    Portfolio Management Accounts
                  </h3>

                  {/* Right: Download Dropdown */}
                  <div
                    ref={DownloadRefPortfolio}
                    className="relative inline-block mt-2 sm:mt-0"
                  >
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() =>
                        setIsOpenDownloadReportPortfolio(
                          !isOpenDownloadReportPortfolio
                        )
                      }
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2 ml-auto"
                      />
                    </div>

                    {isOpenDownloadReportPortfolio && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                        {reportOptions.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDFTablePortfolio(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="flex justify-between mt-4 flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                  <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                    <div className="flex items-center space-x-2">
                      <span className="lg:text-md  text-sm text-[#8C8C8C]">
                        Show Records
                      </span>
                      <Dropdown
                        label=""
                        options={filterOptions}
                        preselectedValue={preSelectedFilter}
                        onSelect={handleshowRecord}
                      />
                    </div>
                    <div className="flex items-center">
                      <div className="relative">
                        <input
                          type="text"
                          className="p-2 pl-8 border rounded-xl"
                          placeholder="Search Account"
                          value={searchQuery}
                          onChange={(e) => {
                            setCurrentPage(1);
                            setSearchQuery(e.target.value);
                          }}
                        />
                        <span className="absolute left-2 top-3 text-gray-500">
                          {" "}
                          <img
                            src="/search-normal.svg"
                            alt="Company Logo"
                            className="mr-2"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="overflow-x-auto ">
                  <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                    {/* Table Header */}
                    <thead className="text-labelcolour text-sm">
                      <tr className="border border-[#EDEDED]">
                        {portfolioAccountheaders.map((header) => (
                          <th
                            key={header.label}
                            onClick={() => handleSort(header.key)}
                            className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                          >
                            <div class="flex items-center">
                              <span>{header.label}</span>
                              {/* {header.label != "" && (
                                <img
                                  src="/sort.svg"
                                  alt="Icon"
                                  class="w-4 h-4 ml-2"
                                />
                              )} */}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>

                    {isLoadingPortfolio ? (
                      <tbody className="shimmer-container-list ">
                        {/* Creating 5 rows of shimmer effect */}
                        {[...Array(5)].map((_, rowIndex) => (
                          <tr key={rowIndex} className="shimmer-row-list">
                            {/* Creating 7 cells in each row for shimmer */}
                            {[...Array(4)].map((_, colIndex) => (
                              <td key={colIndex} className="shimmer-cell-list">
                                <div className="shimmer-loader"></div>
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody className="text-sm font-medium text-black">
                        {portfolioAccounttableData.length > 0 ? (
                          portfolioAccounttableData.map((row, index) => (
                            <tr key={index} className="mb-2 bg-[#F9F9F9]">
                              {/* Dropdown Button */}
                              <td className="px-4 py-4 relative">
                                {row.portfolio_reference_code}
                              </td>
                              <td
                                onClick={() => {
                                  dispatch(resetSelectedUsers());
                                  dispatch(resetDocumentId());
                                  dispatch(setInvestmentId(row.portfolio_id));

                                  let redirectState = {
                                    path: "/investment-details-by-id",
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    "redirectAfterLogin",
                                    JSON.stringify(redirectState)
                                  );
                                  navigate("/investment-details-by-id", {
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  });
                                }}
                                className="relative px-4 py-2 w-[600px] cursor-pointer group"
                              >
                                <span className="inline-block underline text-black hover:text-gray-800 transition max-w-[600px] break-words">
                                  Caprock Model portfolio - {row.portfolio_name}
                                </span>

                                {/* Tooltip */}
                                <div className="absolute left-[100px] top-10 translate-x-1/2 z-50 hidden group-hover:block bg-gray-800 text-white text-xs px-3 py-1 rounded-md shadow-lg whitespace-nowrap max-w-xs">
                                  Check portfolio details
                                </div>
                              </td>

                              <td className="px-4 py-4 relative">
                                {cardCurrencyName.symbol}
                                {row.total_balance
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                              <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                                <span
                                  onClick={() => {
                                    dispatch(
                                      setPortfolioInvestmentId(row.portfolio_id)
                                    );
                                    let redirectState = {
                                      path: "/investor-list",
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    };
                                    sessionStorage.setItem(
                                      "redirectAfterLogin",
                                      JSON.stringify(redirectState)
                                    );
                                    navigate("/investor-list", {
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    });
                                  }}
                                  className="text-black bg-white px-2 py-2 cursor-pointer border shadow-md rounded-xl"
                                >
                                  View Investors
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center py-4" colSpan="7">
                              No results found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
                {!isLoading && (
                  <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                    {/* Entries Info Section */}
                    <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                      Showing {showRecords * (currentPage - 1) + 1} to{" "}
                      {currentPage === totalPages || totalPages == 0
                        ? totalCount
                        : Math.max(
                            showRecords * currentPage,
                            portfolioAccounttableData.length
                          )}{" "}
                      of {totalCount} entries
                    </div>

                    {/* Pagination Section */}
                    <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                      {/* Previous Button */}
                      <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => prev - 1)}
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Prev
                      </button>

                      {/* Page Buttons */}
                      {Array.from({ length: Math.min(totalPages, 5) }).map(
                        (_, index) => {
                          const startPage = Math.max(
                            1,
                            Math.min(totalPages - 4, currentPage - 2)
                          );
                          const page = startPage + index;

                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPage(page)}
                              className={`px-3 py-1 rounded ${
                                currentPage === page
                                  ? "bg-black text-white"
                                  : "bg-white border border-gray-300 text-black"
                              }`}
                            >
                              {page}
                            </button>
                          );
                        }
                      )}

                      {/* Next Button */}
                      <button
                        disabled={currentPage === totalPages || totalPages == 0}
                        onClick={() => setCurrentPage((prev) => prev + 1)}
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="bg-white mt-4 p-4 shadow-md rounded-md">
                <div className="flex justify-between items-center border-b border-colour-custom px-4 py-2 flex-wrap">
                  {/* Left: Title */}
                  <h1 className="text-xl font-medium text-black mb-2">
                    Transaction History
                  </h1>

                  {/* Right: Download Dropdown */}
                  <div
                    ref={DownloadRef}
                    className="relative inline-block mt-2 sm:mt-0"
                  >
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() =>
                        setIsOpenDownloadReport(!isOpenDownloadReport)
                      }
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2 ml-auto"
                      />
                    </div>

                    {isOpenDownloadReport && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                        {reportOptions.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDFTable(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="p-4">
                  {/* Filters Section */}
                  <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleshowRecordPortfolios}
                        />
                      </div>
                      <div className="flex items-center">
                        <div className="relative w-full">
                          <input
                            type="text"
                            className="p-2 pl-8 w-full lg:w-auto border  rounded-xl"
                            placeholder="Search here"
                            value={searchQueryPortfolio}
                            onChange={(e) => {
                              setSearchQueryPortfolio(e.target.value);
                              setCurrentPagePortfolio(1);
                            }}
                          />
                          <span className="absolute left-2 top-3 text-gray-500">
                            {" "}
                            <img
                              src="/search-normal.svg"
                              alt="Company Logo"
                              className="mr-2"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* Dropdown */}

                    <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                      <div
                        ref={DateCalendarRef}
                        className="flex items-center z-10 mt-4 md:mt-0 w-full space-x-4"
                      >
                        <div className="relative w-full">
                          {/* Dropdown Trigger */}
                          <div
                            className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                            onClick={toggleDropdown}
                          >
                            <span>{selectedRange}</span>
                            <img
                              src={
                                isDropdownOpen
                                  ? "/open-dropdown.svg"
                                  : "/download-small-arrow.svg"
                              }
                              alt="Dropdown Icon"
                              className="h-2 w-2 transition-transform duration-300 transform"
                            />
                          </div>

                          {/* Dropdown */}
                          {isDropdownOpen && (
                            <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-80 w-[90vw] lg:w-[650px] max-h-[400px] overflow-auto">
                              <div className="flex  flex-col md:flex-row h-full">
                                {/* Left: Quick Filters */}
                                <div className="w-full md:w-1/3 border-r p-3 h-full">
                                  {quickFilters.map((filter) => (
                                    <div
                                      key={filter.value}
                                      className={`p-2 cursor-pointer rounded ${
                                        quickFilter === filter.value
                                          ? "bg-black text-white"
                                          : "hover:bg-gray-200 text-black"
                                      } transition-all duration-200 ease-in-out`}
                                      onClick={() => {
                                        setCurrentPagePortfolio(1);
                                        handleQuickFilter(filter.value);
                                      }}
                                    >
                                      {filter.label}
                                    </div>
                                  ))}
                                </div>

                                {/* Right: Calendar */}
                                <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                  <Flatpickr
                                    key={selectedDates}
                                    options={{
                                      mode: "range",
                                      inline: true,
                                      dateFormat: "Y-m-d",
                                      showMonths: 2,
                                      defaultDate:
                                        selectedDates.length > 0
                                          ? selectedDates
                                          : [],
                                      shorthandCurrentMonth: true,
                                      locale: {
                                        firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                      },
                                      onChange: (dates) => {
                                        if (
                                          quickFilter === "custom" &&
                                          dates.length === 2
                                        ) {
                                          setSelectedDates(dates);
                                        }
                                      },
                                    }}
                                    className="w-full"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="relative w-full mt-4 md:mt-0 md:w-full">
                        {/* Dropdown Button */}
                        <button
                          onClick={() => {
                            resetAllFilters();
                          }}
                          className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                        >
                          <div className="flex items-center relative">
                            Clear All
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                  {transactionTableData != null && (
                    <div className="overflow-x-auto">
                      <table className="w-full h-full table-fixed  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                        <thead className="text-[#8C8C8C] text-sm">
                          <tr className="border border-[#EDEDED]">
                            {headersDashboardPortfolio.map((header, index) => (
                              <th
                                key={header.label}
                                className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 9
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                              >
                                <div class="flex items-center">
                                  <span>{header.label}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        </thead>

                        {isLoading ? (
                          <tbody className="shimmer-container-list ">
                            {/* Creating 5 rows of shimmer effect */}
                            {[...Array(5)].map((_, rowIndex) => (
                              <tr key={rowIndex} className="shimmer-row-list">
                                {/* Creating 7 cells in each row for shimmer */}
                                {[...Array(9)].map((_, colIndex) => (
                                  <td
                                    key={colIndex}
                                    className="shimmer-cell-list"
                                  >
                                    <div className="shimmer-loader"></div>
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <tbody className="text-sm font-medium text-black">
                            {transactionTableData.length > 0 ? (
                              transactionTableData.map((row, index) => (
                                <React.Fragment key={index}>
                                  <tr
                                    className={`cursor-pointer mb-2 ${
                                      expandedRow === row.id
                                        ? "bg-[#EBF3F8]"
                                        : "bg-[#F9F9F9]"
                                    }`}
                                  >
                                    <td className="px-4 py-2">
                                      <div className="flex items-center space-x-2">
                                        <img
                                          src="/clock.svg"
                                          alt="Time Icon"
                                          className="h-4 w-4"
                                        />
                                        <span className="rounded-xl">
                                          {`${formatDateTransaction(row.date)}`}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      {row.reference_code}
                                    </td>
                                    <td className="p-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight">
                                      <span class="block">
                                        {row.account_name}
                                      </span>
                                    </td>
                                    <td className="p-2">
                                      ${row.convert_rate.toFixed(2)}
                                    </td>
                                    <td className="p-2">{row.currency.name}</td>
                                    <td className="p-2  text-[#FF5050]">
                                      {row.currency.symbol}
                                      {row.debit
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2  text-[#62D76E]">
                                      {row.currency.symbol}
                                      {row.credit
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2">
                                      {row.balance
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>

                                    <td className="px-4 py-2 relative">
                                      <button
                                        ref={(el) =>
                                          (statusButtonRefs.current[
                                            `${row.id}`
                                          ] = el)
                                        }
                                        disabled={
                                          row.status == "pending" ? false : true
                                        }
                                        onClick={() =>
                                          handleDropdownToggle(row.id)
                                        }
                                        className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                          row.status == "pending"
                                            ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                            : ""
                                        }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                                    ${
                                      row.status == "completed"
                                        ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                        : ""
                                    }
                              ${
                                row.status == "rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                      >
                                        <span className="mr-6">
                                          {" "}
                                          {row.status.charAt(0).toUpperCase() +
                                            row.status.slice(1)}
                                        </span>
                                        {filter == "" &&
                                          row.status != "approved" && (
                                            <img
                                              src={`${
                                                openDropdown === row.id
                                                  ? "/Vector.svg"
                                                  : "/down-grey.svg"
                                              }`}
                                              alt="Selected"
                                              className="w-3 h-3 ml-4"
                                            />
                                          )}
                                      </button>
                                    </td>
                                    <td
                                      onClick={() => toggleRowDetails(row.id)}
                                      className="text-center rounded-r"
                                    >
                                      {expandedRow === row.id && (
                                        <img
                                          src="/expanded-black.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                      {expandedRow !== row.id && (
                                        <img
                                          src="/down-grey-steps.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  {expandedRow === row.id && (
                                    <tr>
                                      <td
                                        colSpan={10}
                                        className="bg-[#EEF7FD] w-full"
                                      >
                                        <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4  md:pt-6">
                                              <label
                                                htmlFor="refId"
                                                className="mb-1 text-xs text-[#A6A6A6]"
                                              >
                                                From
                                              </label>
                                              <Tooltip
                                                nametext={row.from_account.name}
                                                numbertext={
                                                  row.from_account.unique_id
                                                }
                                                currencytext={row.currency.name}
                                              >
                                                <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                  {row.from_account.name}
                                                </span>
                                              </Tooltip>

                                              <div className="mt-4"></div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Description
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.description}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    To
                                                  </span>
                                                </label>
                                                <Tooltip
                                                  nametext={row.to_account.name}
                                                  numbertext={
                                                    row.to_account.unique_id
                                                  }
                                                  currencytext={
                                                    row.currency.name
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.to_account.name}
                                                  </span>
                                                </Tooltip>
                                              </div>
                                            </div>
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Ip address
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.ip_address}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4 md:pt-6">
                                              <div className="mt-4">
                                                <label
                                                  htmlFor="investmentType"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  Initiated by
                                                </label>
                                                <div className="text-sm">
                                                  {row.created_by}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                >
                                                  Signatories
                                                </label>
                                                <div className="text-sm">
                                                  <span>
                                                    {row.approved_by} (
                                                    {formatDateTransaction(
                                                      row.date
                                                    )}
                                                    )
                                                  </span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center py-4" colSpan="7">
                                  No results found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  )}
                  {transactionTableData != null && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing{" "}
                        {showRecordsPortfolio * (currentPagePortfolio - 1) + 1}{" "}
                        to{" "}
                        {currentPagePortfolio === totalPagesPortfolio ||
                        totalPagesPortfolio == 0
                          ? totalCountPortfolio
                          : Math.max(
                              showRecordsPortfolio * currentPagePortfolio,
                              transactionTableData.length
                            )}{" "}
                        of {totalCountPortfolio} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPagePortfolio === 1}
                          onClick={() =>
                            setCurrentPagePortfolio((prev) => prev - 1)
                          }
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({
                          length: Math.min(totalPagesPortfolio, 5),
                        }).map((_, index) => {
                          const startPage = Math.max(
                            1,
                            Math.min(
                              totalPagesPortfolio - 4,
                              currentPagePortfolio - 2
                            )
                          );
                          const page = startPage + index;

                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPagePortfolio(page)}
                              className={`px-3 py-1 rounded ${
                                currentPagePortfolio === page
                                  ? "bg-black text-white"
                                  : "bg-white border border-gray-300 text-black"
                              }`}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {/* Next Button */}
                        <button
                          disabled={
                            currentPagePortfolio === totalPagesPortfolio
                          }
                          onClick={() =>
                            setCurrentPagePortfolio((prev) => prev + 1)
                          }
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          {activeCard && activeCard.id == "1" && (
            <div>
              {loading && (
                <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
                  <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
              )}
              <div className={`p-4 shadow-md rounded-md ${activeCard.color}`}>
                <div className="flex justify-between items-center border-b border-colour-custom px-4 text-white">
                  {/* Left side: Icon and heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/cash-account.svg"
                      alt="User Avatar"
                      className="h-6 w-6 mb-2"
                    />
                    <h1 className="text-xl font-medium mb-2">
                      Cash Account Portfolio
                    </h1>
                  </div>

                  {/* Right side: Add Stocks button */}
                  <button
                    onClick={togglePopupAddAccount}
                    className="text-sm mb-2 flex items-center text-black bg-white border-2 border-black py-2 px-3 rounded-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    <span className="font-medium text-sm">Add Account</span>
                  </button>
                </div>

                {isOpenAccount && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[70vh] max-h-screen overflow-y-auto">
                      {/* Modal Header */}
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add New Cash Account
                          </h2>
                          <div className="flex justify-end">
                            <img
                              onClick={togglePopupAddAccount}
                              src="/add.svg"
                              alt="Add"
                              className="w-10 h-10 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={newAccountName}
                                onChange={(e) =>
                                  setNewAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Description
                              </label>{" "}
                              <textarea
                                id="finInstituition"
                                type="text"
                                value={accountDescription}
                                onChange={(e) =>
                                  setAccountDescription(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Add text.."
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Balance
                              </label>{" "}
                              <input
                                type="text"
                                name="field2"
                                value={
                                  isFocusedAccountBalance
                                    ? accountBalance
                                    : formatNumber(accountBalance)
                                }
                                ref={inputRefAccountBalance}
                                onChange={(e) => {
                                  if (!isFocusedAccountBalance) return;
                                  handleChangeAmountBalance(e, e.target.value);
                                }}
                                onFocus={() => setIsFocusedAccountBalance(true)}
                                onBlur={() => setIsFocusedAccountBalance(false)}
                                className="rounded-md border border-gray-300 p-2 w-full text-black font-medium outline-none text-md"
                              />
                            </div>
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Fees
                              </label>
                              <input
                                type="text"
                                name="field2"
                                value={
                                  isFocusedAccountFee
                                    ? minimumInvestment
                                    : formatNumber(minimumInvestment)
                                }
                                ref={inputRefAccountFee}
                                onChange={(e) => {
                                  if (!isFocusedAccountFee) return;
                                  handleChangeAmountFee(e, e.target.value);
                                }}
                                onFocus={() => setIsFocusedAccountFee(true)}
                                onBlur={() => setIsFocusedAccountFee(false)}
                                className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Fee Buffer Amount
                              </label>
                              <input
                                type="text"
                                name="field2"
                                value={
                                  isFocusedAccountFeeBuffer
                                    ? bufferAmount
                                    : formatNumber(bufferAmount)
                                }
                                ref={inputRefAccountFeeBuffer}
                                onChange={(e) => {
                                  if (!isFocusedAccountFeeBuffer) return;
                                  handleChangeAmountFeeBuffer(
                                    e,
                                    e.target.value
                                  );
                                }}
                                onFocus={() => setIsFocusedFeeBuffer(true)}
                                onBlur={() => setIsFocusedFeeBuffer(false)}
                                className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={togglePopupAddAccount}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (
                                !newAccountName ||
                                !toCurrency ||
                                !accountBalance ||
                                !minimumInvestment ||
                                !bufferAmount ||
                                !accountDescription
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleAddCashAccount(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Add Account
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="grid mt-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {activeCard.accounts.map((account) => (
                    <div
                      key={account.id}
                      className="border p-4 rounded-md shadow-md relative"
                    >
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="text-sm font-semibold text-white">
                            Account {account.id}
                          </h3>
                        </div>
                        <div className="relative  flex items-center space-x-2">
                          {/* Three-dot button */}
                          <button
                            ref={(el) =>
                              (buttonRefs.current[`${account.id}`] = el)
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleDropdownAccount(account.id);
                            }}
                            className="text-lg font-bold focus:outline-none"
                          >
                            ⋮
                          </button>

                          {/* Dropdown Menu */}
                          {activeDropdownId === account.id && (
                            <div className="absolute top-full right-0 mt-2 bg-white border border-gray-300 rounded-md shadow-lg text-sm z-50">
                              {options.map((option) => (
                                <button
                                  key={option}
                                  onClick={() =>
                                    handleOptionClick(option, account.id)
                                  }
                                  className="block w-full px-4 py-2 hover:bg-black hover:text-white text-left"
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row items-start sm:items-stretch justify-between gap-6 w-full">
                        {/* Left Section */}
                        <div className="flex-1 pr-4 border-r border-gray-200">
                          {/* Account Name */}
                          <div className="font-medium">
                            <div className="flex items-center justify-between">
                              <p className="text-xs text-white">Account Name</p>
                              <img
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditClick(e, account);
                                }}
                                src="/edit-details.svg"
                                alt="Edit Icon"
                                className="w-3 h-3 cursor-pointer"
                              />
                            </div>
                            <p className="text-sm">{account.account_name}</p>
                          </div>

                          {/* Account Number */}
                          <div className="mt-4 font-medium">
                            <p className="text-xs text-white">Account Number</p>
                            <p className="text-sm">{account.account_number}</p>
                          </div>
                        </div>

                        {/* Right Section */}
                        <div className="flex-1 pl-4">
                          {/* Currency */}
                          <div className="font-medium">
                            <p className="text-xs text-white">Currency</p>
                            <p className="text-sm">{account.currency}</p>
                          </div>

                          {/* Account Balance */}
                          <div className="mt-4 font-medium">
                            <p className="text-xs text-white">
                              Account Balance
                            </p>
                            <p className="text-sm  font-medium">
                              {account.balance
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </p>
                          </div>
                        </div>
                      </div>
                      {isPayIDPopupOpen === account.id && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                          <div className="bg-white rounded-lg w-[90%] md:w-[500px] p-6">
                            {/* Modal Header */}
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add Pay ID
                              </h2>
                              <button
                                onClick={() => togglePayIDPop(account.id)}
                              >
                                <img
                                  src="/add.svg"
                                  alt="Close"
                                  className="w-10 h-10"
                                />
                              </button>
                            </div>

                            {/* Modal Body */}
                            <div className="grid grid-cols-1 gap-6 items-center">
                              <div className="space-y-4 mx-auto ">
                                <div className="mb-4 relative">
                                  <label
                                    htmlFor="password"
                                    className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                                  >
                                    Enter Pay ID
                                  </label>
                                  <input
                                    type="text"
                                    value={payId}
                                    required={true}
                                    id="currentpassword"
                                    onChange={(e) => setPayId(e.target.value)}
                                    className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="Pay Id"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="flex justify-center space-x-4 mt-6">
                              <button
                                onClick={() => togglePayIDPop(account.id)}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!payId) {
                                    showToast("Please enter pay ID", "error");
                                    return;
                                  }
                                  // setLoading(true);
                                  ///  handleUpdateHinNumber(e, account.id);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="flex items-center justify-between mt-4">
                        {/* Left: Download Buttons */}
                        <div
                          ref={(el) =>
                            (buttonDownloadRefs.current[`${account.id}`] = el)
                          }
                          className="relative mt-4 sm:mt-0"
                        >
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              toggleDownloadDropdown(account.id);
                            }}
                            className="flex items-center gap-2 font-medium bg-white text-black border border-gray-300 px-3 py-1.5 rounded-xl shadow-sm hover:bg-gray-100 text-sm"
                          >
                            Download Report
                            <svg
                              className="w-4 h-4 ml-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </button>

                          {isDownloadOpen === account.id && (
                            <div className="absolute left-0 mt-2 w-38 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
                              <button
                                onClick={() =>
                                  handleDownload(account.id, "pdf")
                                }
                                className="rounded-xl w-full text-left px-4 py-2 hover:bg-black hover:text-white text-sm text-black"
                              >
                                Download PDF
                              </button>
                              <button
                                onClick={() =>
                                  handleDownload(account.id, "excel")
                                }
                                className="rounded-xl w-full text-left px-4 py-2 hover:bg-black hover:text-white text-sm text-black"
                              >
                                Download Excel
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Right: Tooltip Icon */}
                        <div
                          className="relative flex items-center ml-auto"
                          onMouseEnter={() => setTooltipVisible(account.id)}
                          onMouseLeave={() => setTooltipVisible(null)}
                        >
                          <button>
                            <img
                              src={
                                tooltipVisible === account.id
                                  ? "/tooltip-white.svg"
                                  : "/tooltip-black.svg"
                              }
                              alt="Tooltip Icon"
                              className="h-4 w-4"
                            />
                          </button>

                          {tooltipVisible === account.id && (
                            <div className="font-medium absolute bottom-full right-0 mb-2 bg-white text-xs p-2 rounded shadow-lg z-50">
                              <div className="relative">
                                <span className="text-[#888888]">
                                  Type:{" "}
                                  <span className="text-[#595959]">
                                    {account.type}
                                  </span>
                                </span>
                                <br />
                                <span className="text-[#888888]">
                                  Created:{" "}
                                  <span className="text-[#595959]">
                                    {formatDateList(account.created_at)}
                                  </span>
                                </span>
                                <div className="absolute -bottom-2 right-1 w-3 h-2 bg-white transform rotate-45"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {isModalOpenAccountEdit && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[70vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Edit Account Details
                        </h2>
                        <div className="flex justify-end">
                          <img
                            onClick={() => {
                              setcurrentAccount(null);
                              setIsModalOpenAccountEdit(false);
                            }}
                            src="/add.svg"
                            alt="Add"
                            className="w-10 h-10 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 pt-4 px-4">
                          {/* Code */}
                          <div>
                            <label
                              htmlFor="acccountName"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Account Name
                            </label>{" "}
                            <input
                              id="acccountName"
                              type="text"
                              value={acccountName}
                              onChange={(e) => setAccountName(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="John Doe"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Description
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={accountDescription}
                              onChange={(e) =>
                                setAccountDescription(e.target.value)
                              }
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Add text.."
                            />
                          </div>
                        </div>

                        {/* Center Column with Border */}
                        <div className="space-y- lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Fees
                            </label>
                            <input
                              type="text"
                              name="field2"
                              value={
                                isFocusedAccountFee
                                  ? minimumInvestment
                                  : formatNumber(minimumInvestment)
                              }
                              ref={inputRefAccountFee}
                              onChange={(e) => {
                                if (!isFocusedAccountFee) return;
                                handleChangeAmountFee(e, e.target.value);
                              }}
                              onFocus={() => setIsFocusedAccountFee(true)}
                              onBlur={() => setIsFocusedAccountFee(false)}
                              className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                            />
                          </div>
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 px-4 pt-4">
                          <div>
                            {" "}
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Fee Buffer Amount
                            </label>
                            <input
                              type="text"
                              name="field2"
                              value={
                                isFocusedAccountFeeBuffer
                                  ? bufferAmount
                                  : formatNumber(bufferAmount)
                              }
                              ref={inputRefAccountFeeBuffer}
                              onChange={(e) => {
                                if (!isFocusedAccountFeeBuffer) return;
                                handleChangeAmountFeeBuffer(e, e.target.value);
                              }}
                              onFocus={() => setIsFocusedFeeBuffer(true)}
                              onBlur={() => setIsFocusedFeeBuffer(false)}
                              className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                        <button
                          onClick={() => {
                            setcurrentAccount(null);
                            setIsModalOpenAccountEdit(false);
                          }}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (!acccountName) {
                              showToast("Account name is required", "error");
                              return;
                            }
                            setLoading(true);
                            handleEditAccount(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Update Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
                <div className="py-6 px-4 bg-white">
                  <div className="mb-4 flex flex-wrap justify-between items-center"></div>
                  <div className="mb-4 flex flex-wrap items-center justify-between">
                    <div className="flex text-sm md:text-md">
                      {["1M", "3M", "6M", "1Y", "All"].map((filter, index) => (
                        <button
                          key={filter}
                          className={`px-3 py-2 shadow-md ${
                            filter === "All" ? "rounded-r-xl" : ""
                          } ${filter === "1M" ? "rounded-l-xl" : ""} ${
                            selectedFilter === filter
                              ? "bg-black text-white"
                              : "bg-white text-black"
                          }`}
                          onClick={() => setSelectedFilter(filter)}
                        >
                          {filter}
                        </button>
                      ))}
                    </div>

                    <div className="mt-2 md:mt-0">
                      <button className="bg-white text-black pl-2 pr-6 py-1 h-10 whitespace-nowrap border-gray-300 border rounded-lg flex items-center">
                        <img
                          src="/presention-chart.svg" // Replace with the actual path to your image
                          alt="Graph Icon"
                          className="h-5 w-5 mr-2" // Adjust size and spacing as needed
                        />
                        Generate Graph
                      </button>
                    </div>
                  </div>

                  <div style={{ width: "100%", height: "400px" }}>
                    <Line data={dataLine} options={optionsLine} />
                  </div>
                </div>
              </div>
              <div className="pt-4  text-xs overflow-x-auto  flex-wrap items-center">
                <div className="flex mb-2 ">
                  <button
                    onClick={() => {
                      resetAllFilters();

                      setFilter("transaction");
                    }}
                    className={`px-4 py-2  rounded-l-xl border-r border-gray-100 ${
                      filter === "transaction"
                        ? "bg-black text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    Transactions
                  </button>
                  <div className="relative">
                    <button
                      onClick={() => {
                        setFilter("request");
                        resetAllFilters();
                      }}
                      className={`lg:px-4 px-2 py-2 rounded-r-xl relative ${
                        filter === "request"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      Requests
                      {totalPendingRequest > 0 && (
                        <span className="absolute -top-2 right-0  -right-2 bg-red-500 text-white text-[10px] text-xs font-bold px-1.5 lg:px-2 py-0.5 rounded-full flex items-center justify-center min-w-[16px] lg:min-w-[18px]">
                          {totalPendingRequest > 99
                            ? "99+"
                            : totalPendingRequest}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {filter == "transaction" && (
                <div className="bg-white mt-2 p-4 px-4 shadow-md rounded-md">
                  <div className="flex flex-col lg:flex-row justify-between lg:items-center mb-4 border-b pb-5 border-gray-100 gap-y-4">
                    {/* Left: Title */}
                    <h1 className="text-xl font-medium text-black">
                      Transaction History
                    </h1>

                    {/* Right: Actions */}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-x-4 ml-0 lg:ml-auto">
                      {/* Download Dropdown */}
                      <div
                        ref={DownloadRef}
                        className="relative w-full sm:w-auto"
                      >
                        <div
                          className="flex items-center p-3 border border-gray-200 h-11 w-full sm:w-60 rounded-xl cursor-pointer"
                          onClick={() =>
                            setIsOpenDownloadReport(!isOpenDownloadReport)
                          }
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span className="truncate">{selected}</span>
                          <img
                            src="/download-small-arrow.svg"
                            alt="Dropdown"
                            className="w-2 h-2 ml-auto"
                          />
                        </div>

                        {isOpenDownloadReport && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                            {reportOptions.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDFTable(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Add Transaction Button */}
                      <button
                        onClick={() => {
                          getAllUsersDashboard();
                          togglePopupAddTransaction();
                        }}
                        className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                      >
                        <img
                          src="/Plus.svg"
                          alt="Add Icon"
                          className="mr-2 ml-2"
                        />
                        <span className="inline">Add Transaction</span>
                      </button>
                    </div>
                  </div>

                  {isOpenEdit && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                        {/* Modal Header */}
                        <div className="flex flex-wrap items-center justify-between mb-6 text-sm md:text-base">
                          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 w-full">
                            {/* Left Tabs */}
                            <div className="flex items-center space-x-2 md:space-x-4">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  resetAllFiltersCashAccount();
                                  setTransactionTab("addTransaction");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addTransaction"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Account Number
                              </span>
                              <span className="hidden md:block text-[#B2B2B2]">
                                |
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearAllFieldsBank();
                                  setTransactionTab("addBank");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addBank"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add External Bank
                              </span>
                              <span className="hidden md:block text-[#B2B2B2]">
                                |
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearAllFieldsBank();
                                  setTransactionTab("addThirdPartyBank");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addThirdPartyBank"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add Third Party Bank
                              </span>
                            </div>

                            {/* Right Add Button */}
                            <div className="flex justify-end">
                              <img
                                onClick={togglePopupAddTransaction}
                                src="/add.svg"
                                alt="Add"
                                className="w-10 h-10 cursor-pointer"
                              />
                            </div>
                          </div>

                          {/* <button onClick={togglePopupAddTransaction}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button> */}
                        </div>
                        {transactionTab === "addTransaction" && (
                          <div>
                            {summaryDetails === false && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Add New Transaction
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <div className="">
                                      <Dropdown
                                        label="Transaction Type"
                                        options={transactionTypeMore}
                                        preselectedValue={
                                          preselectedTransactionType
                                        }
                                        onSelect={handleTransactionType}
                                      />
                                    </div>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <Dropdown
                                          label="RTGS/International/Normal"
                                          options={transactionTypeSecond}
                                          preselectedValue={
                                            preselectedTransactionTypeSecond
                                          }
                                          onSelect={handleTransactionTypeSecond}
                                        />
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={nabFees}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                        <div className="flex items-center space-x-2 mt-4">
                                          <input
                                            type="checkbox"
                                            id="confirm-all"
                                            className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                                            checked={isCheckedSecond}
                                            onChange={(e) =>
                                              setIsCheckedSecond(
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor="confirm-all"
                                            className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                                          >
                                            I accept the applicable fees.
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <textarea
                                        type="text"
                                        name="documentId"
                                        value={commentsCashAccount}
                                        maxLength={18}
                                        onChange={(e) =>
                                          setCommentsCashAccount(e.target.value)
                                        }
                                        className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                        placeholder="Add your comments"
                                      />
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-xs text-labelColour whitespace-normal words-break"
                                      >
                                        You can enter only up to 18 characters.
                                      </label>{" "}
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>
                                      <input
                                        type="date"
                                        value={creationDate}
                                        onChange={(e) =>
                                          setCreationDate(e.target.value)
                                        }
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                        <input
                                          type="text"
                                          name="field2"
                                          value={
                                            isFocused
                                              ? transactionAmount
                                              : formatNumber(transactionAmount)
                                          }
                                          ref={inputRef}
                                          onChange={(e) => {
                                            if (!isFocused) return;
                                            handleChangeAmount(
                                              e,
                                              e.target.value
                                            );
                                          }}
                                          onFocus={() => setIsFocused(true)}
                                          onBlur={() => setIsFocused(false)}
                                          className="p-2 w-full text-black font-medium outline-none text-md"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div className="">
                                          <Dropdown
                                            label="Set Recurrence"
                                            options={recurringTypes}
                                            preselectedValue={
                                              preselectedRecurringType
                                            }
                                            onSelect={handleRecurringType}
                                          />
                                        </div>
                                        {recurringTypeValue != "never" && (
                                          <>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                Start Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recStartDate}
                                                onChange={(e) => {
                                                  const newStart =
                                                    e.target.value;
                                                  setRecStartDate(newStart);

                                                  // Auto-clear end date if it becomes invalid
                                                  if (
                                                    recEndDate &&
                                                    recEndDate < newStart
                                                  ) {
                                                    setRecEndDate("");
                                                  }
                                                }}
                                                min={getCurrentDate()}
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                End Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recEndDate}
                                                onChange={(e) =>
                                                  setRecEndDate(e.target.value)
                                                }
                                                min={
                                                  recStartDate ||
                                                  getCurrentDate()
                                                }
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        <div>
                                          {(transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment") && (
                                            <Dropdown
                                              label="Select Account"
                                              options={fromCustomerAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}{" "}
                                          {transactionTypeValue == "credit" && (
                                            <Dropdown
                                              label="Select Bank Type"
                                              options={bankType}
                                              preselectedValue={
                                                preselectedBankType
                                              }
                                              onSelect={handleChangeBankType}
                                            />
                                          )}
                                          {transactionTypeValue == "credit" && (
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Currency
                                              </label>{" "}
                                              <input
                                                id="accbalance"
                                                type="text"
                                                value={fromCurrencyCashAccount}
                                                disabled={true}
                                                className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                                placeholder="CT0291288"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue == "credit" &&
                                          bankTypeValue == 1 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={bankAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {transactionTypeValue == "credit" &&
                                          bankTypeValue == 2 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={
                                                thirdPartyBankAccountData
                                              }
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={1.0}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromCurrencyCashAccount}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <div>
                                            {transactionTypeValue ==
                                              "transfer" && (
                                              <Dropdown
                                                label="Select Account"
                                                options={toCustomerAccountData}
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            )}
                                            {transactionTypeValue ==
                                              "credit" && (
                                              <Dropdown
                                                label="Select Account"
                                                options={
                                                  fromCustomerAccountData
                                                }
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            )}

                                            {transactionTypeValue ==
                                              "debit" && (
                                              <>
                                                <Dropdown
                                                  label="Select Bank Type"
                                                  options={bankType}
                                                  preselectedValue={
                                                    preselectedBankType
                                                  }
                                                  onSelect={
                                                    handleChangeBankType
                                                  }
                                                />
                                                <label
                                                  htmlFor="accbalance"
                                                  className="mb-1 mt-4 text-sm text-labelColour"
                                                >
                                                  Currency
                                                </label>{" "}
                                                <input
                                                  id="accbalance"
                                                  type="text"
                                                  value={toCurrencyCashAccount}
                                                  disabled={true}
                                                  className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                                  placeholder="CT0291288"
                                                />
                                              </>
                                            )}
                                          </div>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerCode"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller Code
                                            </label>{" "}
                                            <input
                                              id="billerCode"
                                              type="text"
                                              value={billerCode}
                                              onChange={(e) =>
                                                setBillerCode(e.target.value)
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0 md:border-r  sm:border-l-0 border-r-0 md:border-l  border-gray-300 px-4">
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerRefnumber"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <input
                                              id="billerRefnumber"
                                              type="text"
                                              value={billerRefnumber}
                                              onChange={(e) =>
                                                setBillerRefnumber(
                                                  e.target.value
                                                )
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {transactionTypeValue == "debit" &&
                                          bankTypeValue == 1 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={bankAccountData}
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {transactionTypeValue == "debit" &&
                                          bankTypeValue == 2 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={
                                                thirdPartyBankAccountData
                                              }
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            {" "}
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={finalConvertedRate}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" && (
                                          <>
                                            {" "}
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toCurrencyCashAccount}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={
                                                isFocusedFinal
                                                  ? finalConvertedAmount
                                                  : formatNumber(
                                                      finalConvertedAmount
                                                    )
                                              }
                                              ref={inputRefFinal}
                                              onChange={(e) => {
                                                if (!isFocusedFinal) return;
                                                handleChangeAmountFinal(
                                                  e,
                                                  e.target.value
                                                );
                                              }}
                                              onFocus={() =>
                                                setIsFocusedFinal(true)
                                              }
                                              onBlur={() =>
                                                setIsFocusedFinal(false)
                                              }
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          togglePopupAddTransaction();
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (!transactionAmount) {
                                            showToast(
                                              "Please Add valid amount",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromCustomerName) {
                                            showToast(
                                              "Please Select From Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toCustomerName
                                          ) {
                                            showToast(
                                              "Please Select To Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "Please Select To Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromAccountIdCashAccount) {
                                            showToast(
                                              "Please Select From Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            fromAccountIdCashAccount ==
                                            toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "From and To account can't be same",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!creationDate) {
                                            showToast(
                                              "Please Select Transaction Date",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recStartDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence start date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recEndDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence end date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!commentsCashAccount) {
                                            showToast(
                                              "Please Add some description",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            (transactionTypeValue == "debit" ||
                                              transactionTypeValue ==
                                                "credit") &&
                                            isCheckedSecond == false
                                          ) {
                                            showToast(
                                              "Please confirm applicable fees",
                                              "error"
                                            ); // Success toast
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerCode
                                          ) {
                                            showToast(
                                              "Please enter biller code",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerRefnumber
                                          ) {
                                            showToast(
                                              "Please enter reference number",
                                              "error"
                                            );
                                            return;
                                          }
                                          setSummaryDetails(true);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Next
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                            {summaryDetails === true && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Transaction Summary
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Transaction Type
                                    </label>{" "}
                                    <span>{transactionTypeName}</span>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          RTGS/International/Normal
                                        </label>{" "}
                                        <span>{transactionTypeNameSecond}</span>
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <span>{nabFees}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <span>{commentsCashAccount}</span>
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>

                                      <span>
                                        {formatDateForFilterNew(creationDate)}
                                      </span>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center">
                                        <span>
                                          $
                                          {Number(transactionAmount)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div>
                                          <label
                                            htmlFor="Recurring Frequency"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Recurring Frequency
                                          </label>{" "}
                                          <span>{recurringTypeLabel}</span>
                                        </div>

                                        <div>
                                          <label className="block mb-1 w-full text-sm text-labelColour">
                                            Start Date
                                          </label>
                                          <span>
                                            {formatDateForFilterNew(
                                              recStartDate
                                            )}
                                          </span>
                                        </div>
                                        <div>
                                          <label className="block mb-1 w-full text-sm text-labelColour">
                                            End Date
                                          </label>
                                          <span>
                                            {formatDateForFilterNew(recEndDate)}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "billPayment" ||
                                  transactionTypeValue == "transfer") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-0">
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            {transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment"
                                              ? "Selected Account"
                                              : "Selected Bank Type"}
                                          </label>{" "}
                                          <span>
                                            {transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment"
                                              ? fromAccountIdCashAccountLabel
                                              : bankTypeLabel}
                                          </span>
                                        </div>
                                        {transactionTypeValue == "credit" && (
                                          <div className="">
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <span>
                                              {fromCurrencyCashAccount}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Selected Account
                                            </label>{" "}
                                            <span>
                                              {fromAccountIdCashAccountLabel}
                                            </span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <span>{fromAccountNumber}</span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>{1.0}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <span>{fromAccountNumber}</span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div className="">
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <span>
                                              {fromCurrencyCashAccount}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div>
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              {transactionTypeValue ==
                                                "transfer" ||
                                              transactionTypeValue == "credit"
                                                ? "Selected Account "
                                                : "Selected Bank Type"}
                                            </label>{" "}
                                            <span>
                                              {transactionTypeValue ==
                                                "transfer" ||
                                              transactionTypeValue == "credit"
                                                ? toAccountIdCashAccountLabel
                                                : bankTypeLabel}
                                            </span>
                                          </>
                                        )}
                                        {transactionTypeValue == "debit" && (
                                          <div className="">
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <span>{toCurrencyCashAccount}</span>
                                          </div>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller code
                                            </label>{" "}
                                            <span>{billerCode}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Center Column with Border */}
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <span>{billerRefnumber}</span>
                                          </div>
                                        )}
                                        {transactionTypeValue == "debit" && (
                                          <>
                                            {" "}
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Account
                                              </label>{" "}
                                              <span>
                                                {toAccountIdCashAccountLabel}
                                              </span>
                                            </div>
                                          </>
                                        )}

                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            {" "}
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Account Number
                                              </label>{" "}
                                              <span>{toAccountNumber}</span>
                                            </div>
                                          </>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>{finalConvertedRate}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" && (
                                          <>
                                            {" "}
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Account Number
                                              </label>{" "}
                                              <span>{toAccountNumber}</span>
                                            </div>
                                          </>
                                        )}

                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            {" "}
                                            <div className="">
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Currency
                                              </label>{" "}
                                              <span>
                                                {toCurrencyCashAccount}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <span>
                                              {Number(finalConvertedAmount)
                                                .toFixed(2)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ","
                                                )}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setSummaryDetails(false);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Back
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setLoading(true);
                                          handleAddTransacionCashAccount(e);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Transfer Now
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {transactionTab === "payId" && (
                          <div>
                            {summaryDetailsPayID === false && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Pay Easily Using Pay ID{" "}
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <div>
                                      {" "}
                                      <label
                                        htmlFor="accbalance"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Pay ID
                                      </label>{" "}
                                      <input
                                        id="accbalance"
                                        type="text"
                                        value={userPayId}
                                        onChange={(e) =>
                                          setUserPayID(e.target.value)
                                        }
                                        className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="Enter Pay ID here"
                                      />
                                    </div>
                                    <div>
                                      <label className="block mb-1 mt-4 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>
                                      <input
                                        type="date"
                                        value={creationDate}
                                        onChange={(e) =>
                                          setCreationDate(e.target.value)
                                        }
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                        <span className="px-2 text-gray-500 font-medium">
                                          $
                                        </span>
                                        <input
                                          type="text"
                                          name="field2"
                                          value={
                                            isFocusedPayID
                                              ? transactionAmountPayID
                                              : formatNumber(
                                                  transactionAmountPayID
                                                )
                                          }
                                          ref={inputRefPayID}
                                          onChange={(e) => {
                                            if (!isFocusedPayID) return;
                                            handleChangeAmountPayID(
                                              e,
                                              e.target.value
                                            );
                                          }}
                                          onFocus={() =>
                                            setIsFocusedPayID(true)
                                          }
                                          onBlur={() =>
                                            setIsFocusedPayID(false)
                                          }
                                          className="p-2 w-full text-black font-medium outline-none text-md"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 md:pt-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <textarea
                                        type="text"
                                        name="documentId"
                                        value={commentsPayID}
                                        maxLength={18}
                                        onChange={(e) =>
                                          setCommentsPayID(e.target.value)
                                        }
                                        className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                        placeholder="Add your comments"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="flex justify-center space-x-4 mt-10">
                                  <button
                                    onClick={togglePopupAddTransaction}
                                    className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (!transactionAmountPayID) {
                                        showToast(
                                          "Please Add valid amount",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!userPayId) {
                                        showToast(
                                          "Please enter Pay ID",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!creationDate) {
                                        showToast(
                                          "Please Select Transaction Date",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!commentsPayID) {
                                        showToast(
                                          "Please Add some description",
                                          "error"
                                        );
                                        return;
                                      }
                                      setSummaryDetailsPayID(true);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            )}
                            {summaryDetailsPayID === true && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Transaction Summary
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Pay ID
                                    </label>{" "}
                                    <span>{userPayId}</span>
                                    <div className="">
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Date
                                      </label>{" "}
                                      <span>
                                        {" "}
                                        {formatDateForFilterNew(creationDate)}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="Recurring Frequency"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <span>
                                        $
                                        {Number(transactionAmountPayID)
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <span>{commentsPayID}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex justify-center space-x-4 mt-10">
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSummaryDetailsPayID(false);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                  >
                                    Back
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      // setLoading(true);
                                      //handleAddTransacion(e);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                  >
                                    Transfer Now
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {transactionTab === "addBank" && (
                          <div>
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New External Bank
                              </h2>
                            </div>
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-4">
                                {/* Code */}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountName}
                                    onChange={(e) =>
                                      setToAccountName(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="John Doe"
                                  />
                                </div>
                                {countryCode != "AE" &&
                                  countryCode != "GB" &&
                                  !isEuropeanCountry(countryCode) && (
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Account Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={toAccountNumber}
                                        onChange={(e) =>
                                          setToAccountNumber(e.target.value)
                                        }
                                        className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="0291288"
                                      />
                                    </div>
                                  )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Bank Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toBank}
                                    onChange={(e) => setToBank(e.target.value)}
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Bank Name"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Select Country"
                                    options={countryCodeData}
                                    search={true}
                                    preselectedValue={preselectedCountryCode}
                                    onSelect={handleSelectCountryCode}
                                    colorLabel=""
                                  />
                                </div>
                                <div className="">
                                  <Dropdown
                                    label="Currency"
                                    options={currencyData}
                                    search={true}
                                    preselectedValue={preselectedcashCurrency}
                                    onSelect={handleSelectToCurrency}
                                    colorLabel=""
                                  />
                                </div>
                                {countryCode == "AU" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      BSB
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={toBsb}
                                      maxLength={6}
                                      onChange={(e) =>
                                        handleBsbChange(e.target.value)
                                      }
                                      className={`${
                                        bsbError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000"
                                    />
                                    {bsbError && (
                                      <p className="text-red-600 text-xs mt-1">
                                        {bsbError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Swift/BIC code
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={swiftCode}
                                    onChange={handleSwiftChange}
                                    className={`${
                                      swiftError && countryCode != "AU"
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="000000"
                                  />
                                  {swiftError && countryCode != "AU" && (
                                    <p className="text-red-500 text-xs mt-1">
                                      {swiftError}
                                    </p>
                                  )}
                                </div>
                                {countryCode == "US" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Routing Number (ABA)
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={routingNumber}
                                      maxLength={9}
                                      onChange={(e) =>
                                        handleRoutingChange(e.target.value)
                                      }
                                      className={`${
                                        routingError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000000"
                                    />
                                    {routingError && (
                                      <p className="text-red-600 text-sm mt-1">
                                        {routingError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {countryCode == "CA" && (
                                  <>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transit Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={transitNumber}
                                        maxLength={5}
                                        onChange={(e) =>
                                          handleTransitChange(e.target.value)
                                        }
                                        className={`${
                                          transitError
                                            ? "border-red-300 "
                                            : "border-gray-300 "
                                        }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                        placeholder="00000"
                                      />
                                      {transitError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          {transitError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Institution Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={institutionNumber}
                                        onChange={(e) =>
                                          setinstitutionNumber(e.target.value)
                                        }
                                        className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="000000"
                                      />
                                    </div>
                                  </>
                                )}
                                {(countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      IBAN
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={iban}
                                      onChange={handleChangeIban}
                                      className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                      placeholder="000000"
                                    />
                                    {error && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {error}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 1
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine1}
                                    onChange={(e) =>
                                      setAddressLine1(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Street address"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 2
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine2}
                                    onChange={(e) =>
                                      setAddressLine2(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Apartment, unit etc."
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 3
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine3}
                                    onChange={(e) =>
                                      setAddressLine3(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="City, Country etc."
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                              <button
                                onClick={togglePopupAddTransaction}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    countryCode == "AU" &&
                                    (!toBsb || bsbError)
                                  ) {
                                    showToast(
                                      "Please enter a valid BSB",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "US" &&
                                    (!routingNumber || routingError)
                                  ) {
                                    showToast(
                                      "Please enter a valid routing number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    (countryCode == "AE" ||
                                      countryCode == "GB" ||
                                      isEuropeanCountry(countryCode)) &&
                                    !iban
                                  ) {
                                    showToast("Please enter iban", "error");
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    (!transitNumber || transitError)
                                  ) {
                                    showToast(
                                      "Please enter a valid transit number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    !institutionNumber
                                  ) {
                                    showToast(
                                      "Please enter institution number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AU" &&
                                    (!swiftCode || swiftError)
                                  ) {
                                    showToast(
                                      "Please enter a valid swift code/BIC code",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (error) {
                                    showToast(
                                      "Please enter valid iban",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AE" &&
                                    countryCode != "GB" &&
                                    !isEuropeanCountry(countryCode) &&
                                    !toAccountNumber
                                  ) {
                                    showToast(
                                      "Please enter account number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    !toAccountName ||
                                    !toCurrency ||
                                    !addressLine1 ||
                                    !addressLine2 ||
                                    !addressLine3 ||
                                    !countryCode ||
                                    !toBank
                                  ) {
                                    showToast("Please Add all fields", "error");
                                    return;
                                  }
                                  setLoading(true);
                                  handleAddBank(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Add Bank
                              </button>
                            </div>
                          </div>
                        )}
                        {transactionTab === "addThirdPartyBank" && (
                          <div>
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New Third Party Bank
                              </h2>
                            </div>
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-4">
                                {/* Code */}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountName}
                                    onChange={(e) =>
                                      setToAccountName(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="John Doe"
                                  />
                                </div>
                                {countryCode != "AE" &&
                                  countryCode != "GB" &&
                                  !isEuropeanCountry(countryCode) && (
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Account Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={toAccountNumber}
                                        onChange={(e) =>
                                          setToAccountNumber(e.target.value)
                                        }
                                        className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="0291288"
                                      />
                                    </div>
                                  )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Bank Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toBank}
                                    onChange={(e) => setToBank(e.target.value)}
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Bank Name"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Select Country"
                                    options={countryCodeData}
                                    search={true}
                                    preselectedValue={preselectedCountryCode}
                                    onSelect={handleSelectCountryCode}
                                    colorLabel=""
                                  />
                                </div>
                                <div className="">
                                  <Dropdown
                                    label="Currency"
                                    options={currencyData}
                                    search={true}
                                    preselectedValue={preselectedcashCurrency}
                                    onSelect={handleSelectToCurrency}
                                    colorLabel=""
                                  />
                                </div>
                                {countryCode == "AU" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      BSB
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={toBsb}
                                      maxLength={6}
                                      onChange={(e) =>
                                        handleBsbChange(e.target.value)
                                      }
                                      className={`${
                                        bsbError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000"
                                    />
                                    {bsbError && (
                                      <p className="text-red-600 text-xs mt-1">
                                        {bsbError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Swift/BIC code
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={swiftCode}
                                    onChange={handleSwiftChange}
                                    className={`${
                                      swiftError && countryCode != "AU"
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="000000"
                                  />
                                  {swiftError && countryCode != "AU" && (
                                    <p className="text-red-500 text-xs mt-1">
                                      {swiftError}
                                    </p>
                                  )}
                                </div>
                                {countryCode == "US" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Routing Number (ABA)
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={routingNumber}
                                      maxLength={9}
                                      onChange={(e) =>
                                        handleRoutingChange(e.target.value)
                                      }
                                      className={`${
                                        routingError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000000"
                                    />
                                    {routingError && (
                                      <p className="text-red-600 text-sm mt-1">
                                        {routingError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {countryCode == "CA" && (
                                  <>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transit Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={transitNumber}
                                        maxLength={5}
                                        onChange={(e) =>
                                          handleTransitChange(e.target.value)
                                        }
                                        className={`${
                                          transitError
                                            ? "border-red-300 "
                                            : "border-gray-300 "
                                        }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                        placeholder="00000"
                                      />
                                      {transitError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          {transitError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Institution Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={institutionNumber}
                                        onChange={(e) =>
                                          setinstitutionNumber(e.target.value)
                                        }
                                        className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="000000"
                                      />
                                    </div>
                                  </>
                                )}
                                {(countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      IBAN
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={iban}
                                      onChange={handleChangeIban}
                                      className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                      placeholder="000000"
                                    />
                                    {error && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {error}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 1
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine1}
                                    onChange={(e) =>
                                      setAddressLine1(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Street address"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 2
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine2}
                                    onChange={(e) =>
                                      setAddressLine2(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Apartment, unit etc."
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 3
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine3}
                                    onChange={(e) =>
                                      setAddressLine3(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="City, Country etc."
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                              <button
                                onClick={togglePopupAddTransactionCashAccount}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    countryCode == "AU" &&
                                    (!toBsb || bsbError)
                                  ) {
                                    showToast(
                                      "Please enter a valid BSB",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "US" &&
                                    (!routingNumber || routingError)
                                  ) {
                                    showToast(
                                      "Please enter a valid routing number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    (countryCode == "AE" ||
                                      countryCode == "GB" ||
                                      isEuropeanCountry(countryCode)) &&
                                    !iban
                                  ) {
                                    showToast("Please enter iban", "error");
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    (!transitNumber || transitError)
                                  ) {
                                    showToast(
                                      "Please enter a valid transit number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    !institutionNumber
                                  ) {
                                    showToast(
                                      "Please enter institution number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AU" &&
                                    (!swiftCode || swiftError)
                                  ) {
                                    showToast(
                                      "Please enter a valid swift code/BIC code",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (error) {
                                    showToast(
                                      "Please enter valid iban",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AE" &&
                                    countryCode != "GB" &&
                                    !isEuropeanCountry(countryCode) &&
                                    !toAccountNumber
                                  ) {
                                    showToast(
                                      "Please enter account number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    !toAccountName ||
                                    !toCurrency ||
                                    !addressLine1 ||
                                    !addressLine2 ||
                                    !addressLine3 ||
                                    !countryCode ||
                                    !toBank
                                  ) {
                                    showToast("Please Add all fields", "error");
                                    return;
                                  }
                                  setLoading(true);
                                  handleAddBank(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Add Bank
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="p-4">
                    {/* Filters Section */}
                    <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                      <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                        <div className="flex items-center space-x-2">
                          <span className="lg:text-md  text-sm text-[#8C8C8C]">
                            Show Records
                          </span>
                          <Dropdown
                            label=""
                            options={filterOptions}
                            preselectedValue={preSelectedFilter}
                            onSelect={handleshowRecord}
                          />
                        </div>
                        <div className="flex items-center">
                          <div className="relative">
                            <input
                              type="text"
                              className="p-2 pl-8 border rounded-xl"
                              placeholder="Search Here"
                              value={searchQuery}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setCurrentPage(1);
                                setSearchQuery(e.target.value);
                              }}
                            />
                            <span className="absolute left-2 top-3 text-gray-500">
                              {" "}
                              <img
                                src="/search-normal.svg"
                                alt="Company Logo"
                                className="mr-2"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                        <div
                          ref={DateCalendarRef}
                          className="flex items-center  w-full space-x-4"
                        >
                          <div className="relative w-full">
                            {/* Dropdown Trigger */}
                            <div
                              className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              <span>{selectedRange}</span>
                              <img
                                src={
                                  isDropdownOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>

                            {/* Dropdown */}
                            {isDropdownOpen && (
                              <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] lg:w-[700px] max-h-[400px] overflow-auto">
                                <div className="flex  flex-col md:flex-row h-full">
                                  {/* Left: Quick Filters */}
                                  <div className="w-full md:w-1/3 border-r p-3 h-full">
                                    {quickFilters.map((filter) => (
                                      <div
                                        key={filter.value}
                                        className={`p-2 cursor-pointer rounded ${
                                          quickFilter === filter.value
                                            ? "bg-black text-white"
                                            : "hover:bg-gray-200 text-black"
                                        } transition-all duration-200 ease-in-out`}
                                        onClick={() =>
                                          handleQuickFilter(filter.value)
                                        }
                                      >
                                        {filter.label}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Right: Calendar */}
                                  <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                    <Flatpickr
                                      key={selectedDates}
                                      options={{
                                        mode: "range",
                                        inline: true,
                                        dateFormat: "Y-m-d",
                                        showMonths: 2,
                                        defaultDate:
                                          selectedDates.length > 0
                                            ? selectedDates
                                            : [],
                                        shorthandCurrentMonth: true,
                                        locale: {
                                          firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                        },
                                        onChange: (dates) => {
                                          if (
                                            quickFilter === "custom" &&
                                            dates.length === 2
                                          ) {
                                            setSelectedDates(dates);
                                          }
                                        },
                                      }}
                                      className="w-full"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          ref={accountRef}
                          className="relative w-full mt-4 md:mt-0 md:w-full"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="w-full  font-medium border-gray-300  rounded-xl text-sm  py-2 flex items-center justify-between focus:outline-none bg-white text-black"
                          >
                            <div
                              className="flex items-center justify-between p-2 w-full md:w-40 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              {/* Dropdown Text */}
                              <span className="">
                                {selectedAccounts.length > 0 &&
                                selectedAccounts.includes("ALL")
                                  ? "ALL"
                                  : "Select Account"}
                              </span>
                              {/* Dropdown Icon */}
                              <img
                                src={
                                  isOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>
                          </button>

                          {/* Dropdown List */}
                          {isOpen && (
                            <div
                              className="absolute text-xs left-0 mt-2 overflow-y-auto mb-5 md:w-60 w-full bg-white border rounded-md shadow-lg z-50"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              <div className="p-2">
                                <input
                                  type="text"
                                  value={searchAccount}
                                  onChange={(e) =>
                                    setSearchAccount(e.target.value)
                                  }
                                  placeholder="Search..."
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                />
                              </div>
                              {AllAccount.filter((option) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchAccount.toLowerCase())
                              ).map((option) => (
                                <div
                                  key={option.value}
                                  className={`px-4 py-2 flex items-center cursor-pointer ${
                                    selectedAccounts.includes(option.value)
                                      ? "text-white bg-black"
                                      : "text-black bg-white"
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedAccounts.includes(
                                      option.value
                                    )}
                                    onChange={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="custom-checkbox"
                                  />
                                  <span
                                    onClick={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="ml-2"
                                  >
                                    {option.label}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="relative w-full mt-4 md:mt-0 md:w-full">
                          {/* Dropdown Button */}
                          <button
                            onClick={() => {
                              resetAllFilters();
                            }}
                            className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                          >
                            <div className="flex items-center relative">
                              Clear All
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Table */}
                    {transactionTableData != null && (
                      <div className="overflow-x-auto">
                        <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                          <thead className="text-[#8C8C8C] text-sm">
                            <tr className="border border-[#EDEDED]">
                              {headers.map((header, index) => (
                                <th
                                  key={header.label}
                                  className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 9
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                                >
                                  <div class="flex items-center">
                                    <span>{header.label}</span>
                                  </div>
                                </th>
                              ))}
                            </tr>
                          </thead>

                          {isLoading ? (
                            <tbody className="shimmer-container-list ">
                              {/* Creating 5 rows of shimmer effect */}
                              {[...Array(5)].map((_, rowIndex) => (
                                <tr key={rowIndex} className="shimmer-row-list">
                                  {/* Creating 7 cells in each row for shimmer */}
                                  {[...Array(7)].map((_, colIndex) => (
                                    <td
                                      key={colIndex}
                                      className="shimmer-cell-list"
                                    >
                                      <div className="shimmer-loader"></div>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody className="text-sm font-medium text-black">
                              {transactionTableData.length > 0 ? (
                                transactionTableData.map((row, index) => (
                                  <React.Fragment key={index}>
                                    <tr
                                      className={`cursor-pointer mb-2 ${
                                        expandedRow === row.id
                                          ? "bg-[#EBF3F8]"
                                          : "bg-[#F9F9F9]"
                                      }`}
                                    >
                                      <td className="px-4 py-2">
                                        <div className="flex items-center space-x-2">
                                          <img
                                            src="/clock.svg"
                                            alt="Time Icon"
                                            className="h-4 w-4"
                                          />
                                          <span className="rounded-xl">
                                            {`${formatDateTransaction(
                                              row.date
                                            )}`}
                                          </span>
                                        </div>
                                      </td>
                                      <td className="p-2">
                                        {row.reference_code}
                                      </td>
                                      <td className="p-2">
                                        {row.account_name}
                                      </td>
                                      <td className="p-2">
                                        {row.convert_rate.toFixed(2)}
                                      </td>
                                      <td className="p-2">
                                        {row.currency.name}
                                      </td>
                                      <td className="p-2  text-[#FF5050]">
                                        {row.currency.symbol}
                                        {row.debit
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>
                                      <td className="p-2  text-[#62D76E]">
                                        {row.currency.symbol}{" "}
                                        {row.credit
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>
                                      <td className="p-2">
                                        {row.balance
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>

                                      <td className="px-4 py-2 relative">
                                        <button
                                          ref={(el) =>
                                            (statusButtonRefs.current[
                                              `${row.id}`
                                            ] = el)
                                          }
                                          disabled={
                                            row.status == "pending"
                                              ? false
                                              : true
                                          }
                                          onClick={() =>
                                            handleDropdownToggle(row.id)
                                          }
                                          className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                            row.status == "pending"
                                              ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                              : ""
                                          }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "cancelled"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                        >
                                          <span className="mr-6">
                                            {" "}
                                            {row.status
                                              .charAt(0)
                                              .toUpperCase() +
                                              row.status.slice(1)}
                                          </span>
                                          {filter == "" &&
                                            row.status != "approved" && (
                                              <img
                                                src={`${
                                                  openDropdown === row.id
                                                    ? "/Vector.svg"
                                                    : "/down-grey.svg"
                                                }`}
                                                alt="Selected"
                                                className="w-3 h-3 ml-4"
                                              />
                                            )}
                                        </button>
                                      </td>
                                      <td
                                        onClick={() => toggleRowDetails(row.id)}
                                        className="text-center rounded-r"
                                      >
                                        {expandedRow === row.id && (
                                          <img
                                            src="/expanded-black.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                        {expandedRow !== row.id && (
                                          <img
                                            src="/down-grey-steps.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                      </td>
                                    </tr>
                                    {expandedRow === row.id && (
                                      <tr>
                                        <td
                                          colSpan={10}
                                          className="bg-[#EEF7FD] w-full"
                                        >
                                          <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4  md:pt-6">
                                                <label
                                                  htmlFor="refId"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  From
                                                </label>
                                                <Tooltip
                                                  nametext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""
                                                  }
                                                  numbertext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_number}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.unique_id}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.unique_id}`
                                                      : ""
                                                  }
                                                  currencytext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency.name
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.name}`
                                                      : `${row.currency.name}`
                                                  }
                                                  amounttext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency
                                                          .amount_in_currency
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.amount_in_currency}`
                                                      : ``
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""}
                                                  </span>
                                                </Tooltip>

                                                <div className="mt-4"></div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Description
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.description}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      To
                                                    </span>
                                                  </label>
                                                  <Tooltip
                                                    nametext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : "Biller"
                                                    }
                                                    numbertext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.unique_id}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_number}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""
                                                    }
                                                    currencytext={
                                                      row.mode == "transfer"
                                                        ? row.to_account
                                                            .currency.name
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.name}`
                                                        : `${row.currency.name}`
                                                    }
                                                    amounttext={
                                                      row.mode == "transfer" ||
                                                      row.mode == "bpay"
                                                        ? row.to_account
                                                            .currency
                                                            .amount_in_currency
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.amount_in_currency}`
                                                        : ``
                                                    }
                                                  >
                                                    <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                      {row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""}
                                                    </span>
                                                  </Tooltip>
                                                </div>
                                              </div>
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Ip address
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.ip_address}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4 md:pt-6">
                                                <div className="mt-4">
                                                  <label
                                                    htmlFor="investmentType"
                                                    className="mb-1 text-xs text-[#A6A6A6]"
                                                  >
                                                    Initiated by
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.created_by}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                  >
                                                    Signatories
                                                  </label>
                                                  <div className="text-sm">
                                                    <span>
                                                      {row.approved_by} (
                                                      {formatDateTransaction(
                                                        row.date
                                                      )}
                                                      )
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-4" colSpan="7">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>
                    )}
                    {transactionTableData != null && (
                      <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                        {/* Entries Info Section */}
                        <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                          Showing {showRecords * (currentPage - 1) + 1} to{" "}
                          {currentPage === totalPages || totalPages == 0
                            ? totalCount
                            : Math.max(
                                showRecords * currentPage,
                                transactionTableData.length
                              )}{" "}
                          of {totalCount} entries
                        </div>

                        {/* Pagination Section */}
                        <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                          {/* Previous Button */}
                          <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Prev
                          </button>

                          {/* Page Buttons */}
                          {Array.from({ length: Math.min(totalPages, 5) }).map(
                            (_, index) => {
                              const startPage = Math.max(
                                1,
                                Math.min(totalPages - 4, currentPage - 2)
                              );
                              const page = startPage + index;

                              return (
                                <button
                                  key={page}
                                  onClick={() => setCurrentPage(page)}
                                  className={`px-3 py-1 rounded ${
                                    currentPage === page
                                      ? "bg-black text-white"
                                      : "bg-white border border-gray-300 text-black"
                                  }`}
                                >
                                  {page}
                                </button>
                              );
                            }
                          )}

                          {/* Next Button */}
                          <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {filter == "request" && (
                <div className=" bg-white mt-2 p-4 px-4 shadow-md rounded-md">
                  <div className="flex flex-col lg:flex-row justify-between lg:items-center mb-4 border-b pb-5 border-gray-100 gap-y-4">
                    {/* Left: Title */}
                    <h1 className="text-xl font-medium text-black">Requests</h1>

                    {/* Right: Actions */}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-x-4 ml-0 lg:ml-auto">
                      {/* Download Dropdown */}
                      <div
                        ref={DownloadRef}
                        className="relative w-full sm:w-auto"
                      >
                        <div
                          className="flex items-center p-3 border border-gray-200 h-11 w-full sm:w-60 rounded-xl cursor-pointer"
                          onClick={() =>
                            setIsOpenDownloadReport(!isOpenDownloadReport)
                          }
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span className="truncate">{selected}</span>
                          <img
                            src="/download-small-arrow.svg"
                            alt="Dropdown"
                            className="w-2 h-2 ml-auto"
                          />
                        </div>

                        {isOpenDownloadReport && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                            {reportOptions.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDFTable(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Add Transaction Button */}
                      <button
                        onClick={() => {
                          togglePopupAddTransaction();
                        }}
                        className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                      >
                        <img
                          src="/Plus.svg"
                          alt="Add Icon"
                          className="mr-2 ml-2"
                        />
                        <span className="inline">Add Transaction</span>
                      </button>
                    </div>
                  </div>

                  {isOpenEdit && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                        {/* Modal Header */}
                        <div className="flex flex-wrap items-center justify-between mb-6 text-sm md:text-base">
                          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 w-full">
                            {/* Left Tabs */}
                            <div className="flex items-center space-x-2 md:space-x-4">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  resetAllFiltersCashAccount();
                                  setTransactionTab("addTransaction");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addTransaction"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Account Number
                              </span>
                              <span className="hidden md:block text-[#B2B2B2]">
                                |
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearAllFieldsBank();
                                  setTransactionTab("addBank");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addBank"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add External Bank
                              </span>
                              <span className="hidden md:block text-[#B2B2B2]">
                                |
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearAllFieldsBank();
                                  setTransactionTab("addThirdPartyBank");
                                }}
                                className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                                  transactionTab === "addThirdPartyBank"
                                    ? "border-black text-black border-b-2"
                                    : "text-gray-500 hover:text-black"
                                }`}
                              >
                                Add Third Party Bank
                              </span>
                            </div>

                            {/* Right Add Button */}
                            <div className="flex justify-end">
                              <img
                                onClick={togglePopupAddTransaction}
                                src="/add.svg"
                                alt="Add"
                                className="w-10 h-10 cursor-pointer"
                              />
                            </div>
                          </div>

                          {/* <button onClick={togglePopupAddTransaction}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button> */}
                        </div>
                        {transactionTab === "addTransaction" && (
                          <div>
                            {summaryDetails === false && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Add New Transaction
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <div className="">
                                      <Dropdown
                                        label="Transaction Type"
                                        options={transactionTypeMore}
                                        preselectedValue={
                                          preselectedTransactionType
                                        }
                                        onSelect={handleTransactionType}
                                      />
                                    </div>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <Dropdown
                                          label="RTGS/International/Normal"
                                          options={transactionTypeSecond}
                                          preselectedValue={
                                            preselectedTransactionTypeSecond
                                          }
                                          onSelect={handleTransactionTypeSecond}
                                        />
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={nabFees}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                        <div className="flex items-center space-x-2 mt-4">
                                          <input
                                            type="checkbox"
                                            id="confirm-all"
                                            className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                                            checked={isCheckedSecond}
                                            onChange={(e) =>
                                              setIsCheckedSecond(
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor="confirm-all"
                                            className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                                          >
                                            I accept the applicable fees.
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <textarea
                                        type="text"
                                        name="documentId"
                                        value={commentsCashAccount}
                                        maxLength={18}
                                        onChange={(e) =>
                                          setCommentsCashAccount(e.target.value)
                                        }
                                        className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                        placeholder="Add your comments"
                                      />
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-xs text-labelColour whitespace-normal words-break"
                                      >
                                        You can enter only up to 18 characters.
                                      </label>{" "}
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>
                                      <input
                                        type="date"
                                        value={creationDate}
                                        onChange={(e) =>
                                          setCreationDate(e.target.value)
                                        }
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                        <input
                                          type="text"
                                          name="field2"
                                          value={
                                            isFocused
                                              ? transactionAmount
                                              : formatNumber(transactionAmount)
                                          }
                                          ref={inputRef}
                                          onChange={(e) => {
                                            if (!isFocused) return;
                                            handleChangeAmount(
                                              e,
                                              e.target.value
                                            );
                                          }}
                                          onFocus={() => setIsFocused(true)}
                                          onBlur={() => setIsFocused(false)}
                                          className="p-2 w-full text-black font-medium outline-none text-md"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div className="">
                                          <Dropdown
                                            label="Set Recurrence"
                                            options={recurringTypes}
                                            preselectedValue={
                                              preselectedRecurringType
                                            }
                                            onSelect={handleRecurringType}
                                          />
                                        </div>
                                        {recurringTypeValue != "never" && (
                                          <>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                Start Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recStartDate}
                                                onChange={(e) => {
                                                  const newStart =
                                                    e.target.value;
                                                  setRecStartDate(newStart);

                                                  // Auto-clear end date if it becomes invalid
                                                  if (
                                                    recEndDate &&
                                                    recEndDate < newStart
                                                  ) {
                                                    setRecEndDate("");
                                                  }
                                                }}
                                                min={getCurrentDate()}
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                            <div>
                                              <label className="block mb-1 w-full text-sm text-labelColour">
                                                End Date
                                              </label>
                                              <input
                                                type="date"
                                                value={recEndDate}
                                                onChange={(e) =>
                                                  setRecEndDate(e.target.value)
                                                }
                                                min={
                                                  recStartDate ||
                                                  getCurrentDate()
                                                }
                                                className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        <div>
                                          {(transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment") && (
                                            <Dropdown
                                              label="Select Account"
                                              options={fromCustomerAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}{" "}
                                          {transactionTypeValue == "credit" && (
                                            <Dropdown
                                              label="Select Bank Type"
                                              options={bankType}
                                              preselectedValue={
                                                preselectedBankType
                                              }
                                              onSelect={handleChangeBankType}
                                            />
                                          )}
                                          {transactionTypeValue == "credit" && (
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Currency
                                              </label>{" "}
                                              <input
                                                id="accbalance"
                                                type="text"
                                                value={fromCurrencyCashAccount}
                                                disabled={true}
                                                className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                                placeholder="CT0291288"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue == "credit" &&
                                          bankTypeValue == 1 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={bankAccountData}
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {transactionTypeValue == "credit" &&
                                          bankTypeValue == 2 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={
                                                thirdPartyBankAccountData
                                              }
                                              preselectedValue={
                                                preSelectedFromuserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleFromAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={1.0}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromCurrencyCashAccount}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-4">
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <div>
                                            {transactionTypeValue ==
                                              "transfer" && (
                                              <Dropdown
                                                label="Select Account"
                                                options={toCustomerAccountData}
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            )}
                                            {transactionTypeValue ==
                                              "credit" && (
                                              <Dropdown
                                                label="Select Account"
                                                options={
                                                  fromCustomerAccountData
                                                }
                                                preselectedValue={
                                                  preSelectedTouserAccount
                                                }
                                                search={true}
                                                onSelect={
                                                  handleToAccountHolderNumber
                                                }
                                              />
                                            )}

                                            {transactionTypeValue ==
                                              "debit" && (
                                              <>
                                                <Dropdown
                                                  label="Select Bank Type"
                                                  options={bankType}
                                                  preselectedValue={
                                                    preselectedBankType
                                                  }
                                                  onSelect={
                                                    handleChangeBankType
                                                  }
                                                />
                                                <label
                                                  htmlFor="accbalance"
                                                  className="mb-1 mt-4 text-sm text-labelColour"
                                                >
                                                  Currency
                                                </label>{" "}
                                                <input
                                                  id="accbalance"
                                                  type="text"
                                                  value={toCurrencyCashAccount}
                                                  disabled={true}
                                                  className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                                  placeholder="CT0291288"
                                                />
                                              </>
                                            )}
                                          </div>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerCode"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller Code
                                            </label>{" "}
                                            <input
                                              id="billerCode"
                                              type="text"
                                              value={billerCode}
                                              onChange={(e) =>
                                                setBillerCode(e.target.value)
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0 md:border-r  sm:border-l-0 border-r-0 md:border-l  border-gray-300 px-4">
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="billerRefnumber"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <input
                                              id="billerRefnumber"
                                              type="text"
                                              value={billerRefnumber}
                                              onChange={(e) =>
                                                setBillerRefnumber(
                                                  e.target.value
                                                )
                                              }
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {transactionTypeValue == "debit" &&
                                          bankTypeValue == 1 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={bankAccountData}
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {transactionTypeValue == "debit" &&
                                          bankTypeValue == 2 && (
                                            <Dropdown
                                              label="Select Account"
                                              options={
                                                thirdPartyBankAccountData
                                              }
                                              preselectedValue={
                                                preSelectedTouserAccount
                                              }
                                              search={true}
                                              onSelect={
                                                handleToAccountHolderNumber
                                              }
                                            />
                                          )}
                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            {" "}
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={finalConvertedRate}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" && (
                                          <>
                                            {" "}
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toAccountNumber}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toCurrencyCashAccount}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour mt-4"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={
                                                isFocusedFinal
                                                  ? finalConvertedAmount
                                                  : formatNumber(
                                                      finalConvertedAmount
                                                    )
                                              }
                                              ref={inputRefFinal}
                                              onChange={(e) => {
                                                if (!isFocusedFinal) return;
                                                handleChangeAmountFinal(
                                                  e,
                                                  e.target.value
                                                );
                                              }}
                                              onFocus={() =>
                                                setIsFocusedFinal(true)
                                              }
                                              onBlur={() =>
                                                setIsFocusedFinal(false)
                                              }
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          togglePopupAddTransaction();
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (!transactionAmount) {
                                            showToast(
                                              "Please Add valid amount",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromCustomerName) {
                                            showToast(
                                              "Please Select From Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toCustomerName
                                          ) {
                                            showToast(
                                              "Please Select To Customer",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue !=
                                              "billPayment" &&
                                            !toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "Please Select To Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!fromAccountIdCashAccount) {
                                            showToast(
                                              "Please Select From Account",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            fromAccountIdCashAccount ==
                                            toAccountIdCashAccount
                                          ) {
                                            showToast(
                                              "From and To account can't be same",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!creationDate) {
                                            showToast(
                                              "Please Select Transaction Date",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recStartDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence start date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            recurringTypeValue != "never" &&
                                            !recEndDate
                                          ) {
                                            showToast(
                                              "Please select a recurrence end date.",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (!commentsCashAccount) {
                                            showToast(
                                              "Please Add some description",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            (transactionTypeValue == "debit" ||
                                              transactionTypeValue ==
                                                "credit") &&
                                            isCheckedSecond == false
                                          ) {
                                            showToast(
                                              "Please confirm applicable fees",
                                              "error"
                                            ); // Success toast
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerCode
                                          ) {
                                            showToast(
                                              "Please enter biller code",
                                              "error"
                                            );
                                            return;
                                          }
                                          if (
                                            transactionTypeValue ==
                                              "billPayment" &&
                                            !billerRefnumber
                                          ) {
                                            showToast(
                                              "Please enter reference number",
                                              "error"
                                            );
                                            return;
                                          }
                                          setSummaryDetails(true);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Next
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                            {summaryDetails === true && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Transaction Summary
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Transaction Type
                                    </label>{" "}
                                    <span>{transactionTypeName}</span>
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          RTGS/International/Normal
                                        </label>{" "}
                                        <span>{transactionTypeNameSecond}</span>
                                      </div>
                                    )}
                                    {(transactionTypeValue == "debit" ||
                                      transactionTypeValue == "credit") && (
                                      <div className="">
                                        <label
                                          htmlFor="finInstituition"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Fees
                                        </label>{" "}
                                        <span>{nabFees}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <span>{commentsCashAccount}</span>
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>

                                      <span>
                                        {formatDateForFilterNew(creationDate)}
                                      </span>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center">
                                        <span>
                                          $
                                          {Number(transactionAmount)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue != "billPayment" && (
                                      <>
                                        <div>
                                          <label
                                            htmlFor="Recurring Frequency"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Recurring Frequency
                                          </label>{" "}
                                          <span>{recurringTypeLabel}</span>
                                        </div>

                                        <div>
                                          <label className="block mb-1 w-full text-sm text-labelColour">
                                            Start Date
                                          </label>
                                          <span>
                                            {formatDateForFilterNew(
                                              recStartDate
                                            )}
                                          </span>
                                        </div>
                                        <div>
                                          <label className="block mb-1 w-full text-sm text-labelColour">
                                            End Date
                                          </label>
                                          <span>
                                            {formatDateForFilterNew(recEndDate)}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "billPayment" ||
                                  transactionTypeValue == "transfer") && (
                                  <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                    <img
                                      src="/warning-circle.svg"
                                      alt="Info"
                                      className="w-4 h-4 mr-2"
                                    />
                                    <span>
                                      Your transaction will appear in the system
                                      within next <strong>24 hours</strong>.
                                    </span>
                                  </div>
                                )}
                                {transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  !RTGSAllowed && (
                                    <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                      <img
                                        src="/danger.svg"
                                        alt="Info"
                                        className="w-4 h-4 mr-2"
                                      />
                                      <span>
                                        <span>
                                          RTGS requests are accepted between{" "}
                                          <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                {((transactionTypeValue == "debit" &&
                                  transactionTypeValueSecond == "rtgs" &&
                                  RTGSAllowed) ||
                                  (transactionTypeValue == "debit" &&
                                    transactionTypeValueSecond != "rtgs") ||
                                  transactionTypeValue == "credit" ||
                                  transactionTypeValue == "transfer" ||
                                  transactionTypeValue == "billPayment") && (
                                  <>
                                    <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        From
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div className="space-y-4 pt-4 px-0">
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            {transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment"
                                              ? "Selected Account"
                                              : "Selected Bank Type"}
                                          </label>{" "}
                                          <span>
                                            {transactionTypeValue == "debit" ||
                                            transactionTypeValue ==
                                              "transfer" ||
                                            transactionTypeValue ==
                                              "billPayment"
                                              ? fromAccountIdCashAccountLabel
                                              : bankTypeLabel}
                                          </span>
                                        </div>
                                        {transactionTypeValue == "credit" && (
                                          <div className="">
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <span>
                                              {fromCurrencyCashAccount}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Selected Account
                                            </label>{" "}
                                            <span>
                                              {fromAccountIdCashAccountLabel}
                                            </span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <span>{fromAccountNumber}</span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>{1.0}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "credit" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Account Number
                                            </label>{" "}
                                            <span>{fromAccountNumber}</span>
                                          </div>
                                        )}
                                        {(transactionTypeValue == "debit" ||
                                          transactionTypeValue == "transfer" ||
                                          transactionTypeValue ==
                                            "billPayment") && (
                                          <div className="">
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <span>
                                              {fromCurrencyCashAccount}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                      <h1 className="text-md font-medium mb-2 text-center">
                                        To
                                      </h1>
                                    </div>{" "}
                                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                      {/* Left Column */}
                                      <div>
                                        {transactionTypeValue !=
                                          "billPayment" && (
                                          <>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              {transactionTypeValue ==
                                                "transfer" ||
                                              transactionTypeValue == "credit"
                                                ? "Selected Account "
                                                : "Selected Bank Type"}
                                            </label>{" "}
                                            <span>
                                              {transactionTypeValue ==
                                                "transfer" ||
                                              transactionTypeValue == "credit"
                                                ? toAccountIdCashAccountLabel
                                                : bankTypeLabel}
                                            </span>
                                          </>
                                        )}
                                        {transactionTypeValue == "debit" && (
                                          <div className="">
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <span>{toCurrencyCashAccount}</span>
                                          </div>
                                        )}
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Biller code
                                            </label>{" "}
                                            <span>{billerCode}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Center Column with Border */}
                                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                        {transactionTypeValue ==
                                          "billPayment" && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Reference Number
                                            </label>{" "}
                                            <span>{billerRefnumber}</span>
                                          </div>
                                        )}
                                        {transactionTypeValue == "debit" && (
                                          <>
                                            {" "}
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Selected Account
                                              </label>{" "}
                                              <span>
                                                {toAccountIdCashAccountLabel}
                                              </span>
                                            </div>
                                          </>
                                        )}

                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            {" "}
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Account Number
                                              </label>{" "}
                                              <span>{toAccountNumber}</span>
                                            </div>
                                          </>
                                        )}
                                        {(transactionTypeValue == "transfer" ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international")) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 text-sm text-labelColour"
                                            >
                                              Currency Rate
                                            </label>{" "}
                                            <span>{finalConvertedRate}</span>
                                          </div>
                                        )}
                                      </div>

                                      {/* Right Column */}
                                      <div className="space-y-4 px-4 md:pt-4">
                                        {transactionTypeValue == "debit" && (
                                          <>
                                            {" "}
                                            <div>
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Account Number
                                              </label>{" "}
                                              <span>{toAccountNumber}</span>
                                            </div>
                                          </>
                                        )}

                                        {(transactionTypeValue == "credit" ||
                                          transactionTypeValue ==
                                            "transfer") && (
                                          <>
                                            {" "}
                                            <div className="">
                                              <label
                                                htmlFor="accbalance"
                                                className="mb-1 text-sm text-labelColour"
                                              >
                                                Currency
                                              </label>{" "}
                                              <span>
                                                {toCurrencyCashAccount}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                        {((transactionTypeValue == "transfer" &&
                                          fromCurrencyCashAccount !=
                                            toCurrencyCashAccount) ||
                                          (transactionTypeValue == "debit" &&
                                            transactionTypeValueSecond ==
                                              "international" &&
                                            fromCurrencyCashAccount !=
                                              toCurrencyCashAccount)) && (
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              Final Converted Amount
                                            </label>{" "}
                                            <span>
                                              {Number(finalConvertedAmount)
                                                .toFixed(2)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ","
                                                )}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-center space-x-4 mt-10">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setSummaryDetails(false);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                      >
                                        Back
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setLoading(true);
                                          handleAddTransacionCashAccount(e);
                                        }}
                                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                      >
                                        Transfer Now
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {transactionTab === "payId" && (
                          <div>
                            {summaryDetailsPayID === false && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Pay Easily Using Pay ID{" "}
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <div>
                                      {" "}
                                      <label
                                        htmlFor="accbalance"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Pay ID
                                      </label>{" "}
                                      <input
                                        id="accbalance"
                                        type="text"
                                        value={userPayId}
                                        onChange={(e) =>
                                          setUserPayID(e.target.value)
                                        }
                                        className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="Enter Pay ID here"
                                      />
                                    </div>
                                    <div>
                                      <label className="block mb-1 mt-4 w-full text-sm text-labelColour">
                                        Transaction Date
                                      </label>
                                      <input
                                        type="date"
                                        value={creationDate}
                                        onChange={(e) =>
                                          setCreationDate(e.target.value)
                                        }
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="amount"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                        <span className="px-2 text-gray-500 font-medium">
                                          $
                                        </span>
                                        <input
                                          type="text"
                                          name="field2"
                                          value={
                                            isFocusedPayID
                                              ? transactionAmountPayID
                                              : formatNumber(
                                                  transactionAmountPayID
                                                )
                                          }
                                          ref={inputRefPayID}
                                          onChange={(e) => {
                                            if (!isFocusedPayID) return;
                                            handleChangeAmountPayID(
                                              e,
                                              e.target.value
                                            );
                                          }}
                                          onFocus={() =>
                                            setIsFocusedPayID(true)
                                          }
                                          onBlur={() =>
                                            setIsFocusedPayID(false)
                                          }
                                          className="p-2 w-full text-black font-medium outline-none text-md"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 md:pt-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <textarea
                                        type="text"
                                        name="documentId"
                                        value={commentsPayID}
                                        maxLength={18}
                                        onChange={(e) =>
                                          setCommentsPayID(e.target.value)
                                        }
                                        className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                        placeholder="Add your comments"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="flex justify-center space-x-4 mt-10">
                                  <button
                                    onClick={togglePopupAddTransaction}
                                    className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (!transactionAmountPayID) {
                                        showToast(
                                          "Please Add valid amount",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!userPayId) {
                                        showToast(
                                          "Please enter Pay ID",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!creationDate) {
                                        showToast(
                                          "Please Select Transaction Date",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!commentsPayID) {
                                        showToast(
                                          "Please Add some description",
                                          "error"
                                        );
                                        return;
                                      }
                                      setSummaryDetailsPayID(true);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            )}
                            {summaryDetailsPayID === true && (
                              <div>
                                <div className="flex items-center justify-between">
                                  <h2 className="text-lg font-medium text-center w-full">
                                    Transaction Summary
                                  </h2>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    Transaction Details
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-2">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Pay ID
                                    </label>{" "}
                                    <span>{userPayId}</span>
                                    <div className="">
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Date
                                      </label>{" "}
                                      <span>
                                        {" "}
                                        {formatDateForFilterNew(creationDate)}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    <div>
                                      <label
                                        htmlFor="Recurring Frequency"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Amount
                                      </label>{" "}
                                      <span>
                                        $
                                        {Number(transactionAmountPayID)
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transaction Description
                                      </label>{" "}
                                      <span>{commentsPayID}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex justify-center space-x-4 mt-10">
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSummaryDetailsPayID(false);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                  >
                                    Back
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      // setLoading(true);
                                      //handleAddTransacion(e);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                  >
                                    Transfer Now
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {transactionTab === "addBank" && (
                          <div>
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New External Bank
                              </h2>
                            </div>
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-4">
                                {/* Code */}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountName}
                                    onChange={(e) =>
                                      setToAccountName(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="John Doe"
                                  />
                                </div>
                                {countryCode != "AE" &&
                                  countryCode != "GB" &&
                                  !isEuropeanCountry(countryCode) && (
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Account Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={toAccountNumber}
                                        onChange={(e) =>
                                          setToAccountNumber(e.target.value)
                                        }
                                        className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="0291288"
                                      />
                                    </div>
                                  )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Bank Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toBank}
                                    onChange={(e) => setToBank(e.target.value)}
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Bank Name"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Select Country"
                                    options={countryCodeData}
                                    search={true}
                                    preselectedValue={preselectedCountryCode}
                                    onSelect={handleSelectCountryCode}
                                    colorLabel=""
                                  />
                                </div>
                                <div className="">
                                  <Dropdown
                                    label="Currency"
                                    options={currencyData}
                                    search={true}
                                    preselectedValue={preselectedcashCurrency}
                                    onSelect={handleSelectToCurrency}
                                    colorLabel=""
                                  />
                                </div>
                                {countryCode == "AU" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      BSB
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={toBsb}
                                      maxLength={6}
                                      onChange={(e) =>
                                        handleBsbChange(e.target.value)
                                      }
                                      className={`${
                                        bsbError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000"
                                    />
                                    {bsbError && (
                                      <p className="text-red-600 text-xs mt-1">
                                        {bsbError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Swift/BIC code
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={swiftCode}
                                    onChange={handleSwiftChange}
                                    className={`${
                                      swiftError && countryCode != "AU"
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="000000"
                                  />
                                  {swiftError && countryCode != "AU" && (
                                    <p className="text-red-500 text-xs mt-1">
                                      {swiftError}
                                    </p>
                                  )}
                                </div>
                                {countryCode == "US" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Routing Number (ABA)
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={routingNumber}
                                      maxLength={9}
                                      onChange={(e) =>
                                        handleRoutingChange(e.target.value)
                                      }
                                      className={`${
                                        routingError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000000"
                                    />
                                    {routingError && (
                                      <p className="text-red-600 text-sm mt-1">
                                        {routingError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {countryCode == "CA" && (
                                  <>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transit Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={transitNumber}
                                        maxLength={5}
                                        onChange={(e) =>
                                          handleTransitChange(e.target.value)
                                        }
                                        className={`${
                                          transitError
                                            ? "border-red-300 "
                                            : "border-gray-300 "
                                        }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                        placeholder="00000"
                                      />
                                      {transitError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          {transitError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Institution Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={institutionNumber}
                                        onChange={(e) =>
                                          setinstitutionNumber(e.target.value)
                                        }
                                        className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="000000"
                                      />
                                    </div>
                                  </>
                                )}
                                {(countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      IBAN
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={iban}
                                      onChange={handleChangeIban}
                                      className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                      placeholder="000000"
                                    />
                                    {error && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {error}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 1
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine1}
                                    onChange={(e) =>
                                      setAddressLine1(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Street address"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 2
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine2}
                                    onChange={(e) =>
                                      setAddressLine2(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Apartment, unit etc."
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 3
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine3}
                                    onChange={(e) =>
                                      setAddressLine3(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="City, Country etc."
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                              <button
                                onClick={togglePopupAddTransaction}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    countryCode == "AU" &&
                                    (!toBsb || bsbError)
                                  ) {
                                    showToast(
                                      "Please enter a valid BSB",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "US" &&
                                    (!routingNumber || routingError)
                                  ) {
                                    showToast(
                                      "Please enter a valid routing number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    (countryCode == "AE" ||
                                      countryCode == "GB" ||
                                      isEuropeanCountry(countryCode)) &&
                                    !iban
                                  ) {
                                    showToast("Please enter iban", "error");
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    (!transitNumber || transitError)
                                  ) {
                                    showToast(
                                      "Please enter a valid transit number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    !institutionNumber
                                  ) {
                                    showToast(
                                      "Please enter institution number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AU" &&
                                    (!swiftCode || swiftError)
                                  ) {
                                    showToast(
                                      "Please enter a valid swift code/BIC code",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (error) {
                                    showToast(
                                      "Please enter valid iban",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AE" &&
                                    countryCode != "GB" &&
                                    !isEuropeanCountry(countryCode) &&
                                    !toAccountNumber
                                  ) {
                                    showToast(
                                      "Please enter account number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    !toAccountName ||
                                    !toCurrency ||
                                    !addressLine1 ||
                                    !addressLine2 ||
                                    !addressLine3 ||
                                    !countryCode ||
                                    !toBank
                                  ) {
                                    showToast("Please Add all fields", "error");
                                    return;
                                  }
                                  setLoading(true);
                                  handleAddBank(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Add Bank
                              </button>
                            </div>
                          </div>
                        )}
                        {transactionTab === "addThirdPartyBank" && (
                          <div>
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New Third Party Bank
                              </h2>
                            </div>
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-4">
                                {/* Code */}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountName}
                                    onChange={(e) =>
                                      setToAccountName(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="John Doe"
                                  />
                                </div>
                                {countryCode != "AE" &&
                                  countryCode != "GB" &&
                                  !isEuropeanCountry(countryCode) && (
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Account Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={toAccountNumber}
                                        onChange={(e) =>
                                          setToAccountNumber(e.target.value)
                                        }
                                        className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="0291288"
                                      />
                                    </div>
                                  )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Bank Name
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toBank}
                                    onChange={(e) => setToBank(e.target.value)}
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Bank Name"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Select Country"
                                    options={countryCodeData}
                                    search={true}
                                    preselectedValue={preselectedCountryCode}
                                    onSelect={handleSelectCountryCode}
                                    colorLabel=""
                                  />
                                </div>
                                <div className="">
                                  <Dropdown
                                    label="Currency"
                                    options={currencyData}
                                    search={true}
                                    preselectedValue={preselectedcashCurrency}
                                    onSelect={handleSelectToCurrency}
                                    colorLabel=""
                                  />
                                </div>
                                {countryCode == "AU" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      BSB
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={toBsb}
                                      maxLength={6}
                                      onChange={(e) =>
                                        handleBsbChange(e.target.value)
                                      }
                                      className={`${
                                        bsbError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000"
                                    />
                                    {bsbError && (
                                      <p className="text-red-600 text-xs mt-1">
                                        {bsbError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Swift/BIC code
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={swiftCode}
                                    onChange={handleSwiftChange}
                                    className={`${
                                      swiftError && countryCode != "AU"
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="000000"
                                  />
                                  {swiftError && countryCode != "AU" && (
                                    <p className="text-red-500 text-xs mt-1">
                                      {swiftError}
                                    </p>
                                  )}
                                </div>
                                {countryCode == "US" && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      Routing Number (ABA)
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={routingNumber}
                                      maxLength={9}
                                      onChange={(e) =>
                                        handleRoutingChange(e.target.value)
                                      }
                                      className={`${
                                        routingError
                                          ? "border-red-300 "
                                          : "border-gray-300 "
                                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                      placeholder="000000000"
                                    />
                                    {routingError && (
                                      <p className="text-red-600 text-sm mt-1">
                                        {routingError}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {countryCode == "CA" && (
                                  <>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Transit Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={transitNumber}
                                        maxLength={5}
                                        onChange={(e) =>
                                          handleTransitChange(e.target.value)
                                        }
                                        className={`${
                                          transitError
                                            ? "border-red-300 "
                                            : "border-gray-300 "
                                        }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                        placeholder="00000"
                                      />
                                      {transitError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          {transitError}
                                        </p>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="finInstituition"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        Institution Number
                                      </label>{" "}
                                      <input
                                        id="finInstituition"
                                        type="text"
                                        value={institutionNumber}
                                        onChange={(e) =>
                                          setinstitutionNumber(e.target.value)
                                        }
                                        className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                        placeholder="000000"
                                      />
                                    </div>
                                  </>
                                )}
                                {(countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) && (
                                  <div>
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      IBAN
                                    </label>{" "}
                                    <input
                                      id="finInstituition"
                                      type="text"
                                      value={iban}
                                      onChange={handleChangeIban}
                                      className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                      placeholder="000000"
                                    />
                                    {error && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {error}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 1
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine1}
                                    onChange={(e) =>
                                      setAddressLine1(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Street address"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 2
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine2}
                                    onChange={(e) =>
                                      setAddressLine2(e.target.value)
                                    }
                                    className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Apartment, unit etc."
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Address Line 3
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={addressLine3}
                                    onChange={(e) =>
                                      setAddressLine3(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="City, Country etc."
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                              <button
                                onClick={togglePopupAddTransactionCashAccount}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    countryCode == "AU" &&
                                    (!toBsb || bsbError)
                                  ) {
                                    showToast(
                                      "Please enter a valid BSB",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "US" &&
                                    (!routingNumber || routingError)
                                  ) {
                                    showToast(
                                      "Please enter a valid routing number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    (countryCode == "AE" ||
                                      countryCode == "GB" ||
                                      isEuropeanCountry(countryCode)) &&
                                    !iban
                                  ) {
                                    showToast("Please enter iban", "error");
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    (!transitNumber || transitError)
                                  ) {
                                    showToast(
                                      "Please enter a valid transit number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode == "CA" &&
                                    !institutionNumber
                                  ) {
                                    showToast(
                                      "Please enter institution number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AU" &&
                                    (!swiftCode || swiftError)
                                  ) {
                                    showToast(
                                      "Please enter a valid swift code/BIC code",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (error) {
                                    showToast(
                                      "Please enter valid iban",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    countryCode != "AE" &&
                                    countryCode != "GB" &&
                                    !isEuropeanCountry(countryCode) &&
                                    !toAccountNumber
                                  ) {
                                    showToast(
                                      "Please enter account number",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    !toAccountName ||
                                    !toCurrency ||
                                    !addressLine1 ||
                                    !addressLine2 ||
                                    !addressLine3 ||
                                    !countryCode ||
                                    !toBank
                                  ) {
                                    showToast("Please Add all fields", "error");
                                    return;
                                  }
                                  setLoading(true);
                                  handleAddBank(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Add Bank
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="p-4">
                    {/* Filters Section */}
                    <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                      <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                        <div className="flex items-center space-x-2">
                          <span className="lg:text-md  text-sm text-[#8C8C8C]">
                            Show Records
                          </span>
                          <Dropdown
                            label=""
                            options={filterOptions}
                            preselectedValue={preSelectedFilter}
                            onSelect={handleshowRecord}
                          />
                        </div>
                        <div className="flex items-center">
                          <div className="relative">
                            <input
                              type="text"
                              className="p-2 pl-8 border rounded-xl"
                              placeholder="Search Requests"
                              value={searchQuery}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                setCurrentPage(1);
                              }}
                            />
                            <span className="absolute left-2 top-3 text-gray-500">
                              {" "}
                              <img
                                src="/search-normal.svg"
                                alt="Company Logo"
                                className="mr-2"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                        <div
                          ref={DateCalendarRef}
                          className="flex items-center  w-full space-x-4"
                        >
                          <div className="relative w-full">
                            {/* Dropdown Trigger */}
                            <div
                              className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              <span>{selectedRange}</span>
                              <img
                                src={
                                  isDropdownOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>

                            {/* Dropdown */}
                            {isDropdownOpen && (
                              <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] lg:w-[700px] max-h-[400px] overflow-auto">
                                <div className="flex  flex-col md:flex-row h-full">
                                  {/* Left: Quick Filters */}
                                  <div className="w-full md:w-1/3 border-r p-3 h-full">
                                    {quickFilters.map((filter) => (
                                      <div
                                        key={filter.value}
                                        className={`p-2 cursor-pointer rounded ${
                                          quickFilter === filter.value
                                            ? "bg-black text-white"
                                            : "hover:bg-gray-200 text-black"
                                        } transition-all duration-200 ease-in-out`}
                                        onClick={() =>
                                          handleQuickFilter(filter.value)
                                        }
                                      >
                                        {filter.label}
                                      </div>
                                    ))}
                                  </div>

                                  {/* Right: Calendar */}
                                  <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                    <Flatpickr
                                      key={selectedDates}
                                      options={{
                                        mode: "range",
                                        inline: true,
                                        dateFormat: "Y-m-d",
                                        showMonths: 2,
                                        defaultDate:
                                          selectedDates.length > 0
                                            ? selectedDates
                                            : [],
                                        shorthandCurrentMonth: true,
                                        locale: {
                                          firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                        },
                                        onChange: (dates) => {
                                          if (
                                            quickFilter === "custom" &&
                                            dates.length === 2
                                          ) {
                                            setSelectedDates(dates);
                                          }
                                        },
                                      }}
                                      className="w-full"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          ref={accountRef}
                          className="relative w-full mt-4 md:mt-0 md:w-full"
                        >
                          {/* Dropdown Button */}
                          <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="w-full  font-medium border-gray-300  rounded-xl text-sm  py-2 flex items-center justify-between focus:outline-none bg-white text-black"
                          >
                            <div
                              className="flex items-center justify-between p-2 w-full md:w-40 border rounded-xl bg-white cursor-pointer"
                              onClick={toggleDropdown}
                            >
                              {/* Dropdown Text */}
                              <span className="">
                                {selectedAccounts.length > 0 &&
                                selectedAccounts.includes("ALL")
                                  ? "ALL"
                                  : "Select Account"}
                              </span>
                              {/* Dropdown Icon */}
                              <img
                                src={
                                  isOpen
                                    ? "/open-dropdown.svg"
                                    : "/download-small-arrow.svg"
                                }
                                alt="Dropdown Icon"
                                className="h-2 w-2 transition-transform duration-300 transform"
                              />
                            </div>
                          </button>

                          {/* Dropdown List */}
                          {isOpen && (
                            <div
                              className="absolute text-xs left-0 mt-2 overflow-y-auto mb-5 md:w-60 w-full bg-white border rounded-md shadow-lg z-50"
                              style={{
                                maxHeight: "200px", // Optional: limit height
                              }}
                            >
                              <div className="p-2">
                                <input
                                  type="text"
                                  value={searchAccount}
                                  onChange={(e) =>
                                    setSearchAccount(e.target.value)
                                  }
                                  placeholder="Search..."
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                />
                              </div>
                              {AllAccount.filter((option) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchAccount.toLowerCase())
                              ).map((option) => (
                                <div
                                  key={option.value}
                                  className={`px-4 py-2 flex items-center cursor-pointer ${
                                    selectedAccounts.includes(option.value)
                                      ? "text-white bg-black"
                                      : "text-black bg-white"
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedAccounts.includes(
                                      option.value
                                    )}
                                    onChange={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="custom-checkbox"
                                  />
                                  <span
                                    onClick={() =>
                                      handleAccountListChange(option)
                                    }
                                    className="ml-2"
                                  >
                                    {option.label}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="relative w-full mt-4 md:mt-0 md:w-full">
                          {/* Dropdown Button */}
                          <button
                            onClick={() => {
                              resetAllFilters();
                            }}
                            className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                          >
                            <div className="flex items-center relative">
                              Clear All
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Table */}
                    {transactionTableData != null && (
                      <div className="overflow-x-auto">
                        <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                          <thead className="text-[#8C8C8C] text-sm">
                            <tr className="border border-[#EDEDED]">
                              {withOutheadersRequest.map((header, index) => (
                                <th
                                  key={header.label}
                                  className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 9
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                                >
                                  <div class="flex items-center">
                                    <span>{header.label}</span>
                                  </div>
                                </th>
                              ))}
                            </tr>
                          </thead>

                          {isLoading ? (
                            <tbody className="shimmer-container-list ">
                              {/* Creating 5 rows of shimmer effect */}
                              {[...Array(5)].map((_, rowIndex) => (
                                <tr key={rowIndex} className="shimmer-row-list">
                                  {/* Creating 7 cells in each row for shimmer */}
                                  {[...Array(7)].map((_, colIndex) => (
                                    <td
                                      key={colIndex}
                                      className="shimmer-cell-list"
                                    >
                                      <div className="shimmer-loader"></div>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody className="text-sm font-medium text-black">
                              {transactionTableData.length > 0 ? (
                                transactionTableData.map((row, index) => (
                                  <React.Fragment key={index}>
                                    <tr
                                      className={`cursor-pointer mb-2 ${
                                        expandedRow === row.id
                                          ? "bg-[#EBF3F8]"
                                          : "bg-[#F9F9F9]"
                                      }`}
                                    >
                                      <td className="px-4 py-2">
                                        <div className="flex items-center space-x-2">
                                          <img
                                            src="/clock.svg"
                                            alt="Time Icon"
                                            className="h-4 w-4"
                                          />
                                          <span className="rounded-xl">
                                            {`${formatDateTransaction(
                                              row.date
                                            )}`}
                                          </span>
                                        </div>
                                      </td>
                                      <td className="p-2">
                                        {row.reference_code}
                                      </td>
                                      <td className="p-2">
                                        {row.account_name}
                                      </td>
                                      <td className="p-2">
                                        {row.convert_rate.toFixed(2)}
                                      </td>
                                      <td className="p-2">
                                        {row.currency.name}
                                      </td>
                                      <td className="p-2  text-[#FF5050]">
                                        {row.currency.symbol}
                                        {row.debit
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>
                                      <td className="p-2  text-[#62D76E]">
                                        {row.currency.symbol}
                                        {row.credit
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )}
                                      </td>

                                      <td className="px-4 py-2 relative">
                                        <button
                                          ref={(el) =>
                                            (statusButtonRefs.current[
                                              `${row.id}`
                                            ] = el)
                                          }
                                          disabled={
                                            row.status == "pending"
                                              ? false
                                              : true
                                          }
                                          onClick={() =>
                                            handleDropdownToggle(row.id)
                                          }
                                          className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                            row.status == "pending"
                                              ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                              : ""
                                          }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "cancelled"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                        >
                                          <span className="mr-6">
                                            {" "}
                                            {row.status
                                              .charAt(0)
                                              .toUpperCase() +
                                              row.status.slice(1)}
                                          </span>
                                          {filter == "" &&
                                            row.status != "approved" && (
                                              <img
                                                src={`${
                                                  openDropdown === row.id
                                                    ? "/Vector.svg"
                                                    : "/down-grey.svg"
                                                }`}
                                                alt="Selected"
                                                className="w-3 h-3 ml-4"
                                              />
                                            )}
                                        </button>
                                      </td>
                                      <td
                                        onClick={() => toggleRowDetails(row.id)}
                                        className="text-center rounded-r"
                                      >
                                        {expandedRow === row.id && (
                                          <img
                                            src="/expanded-black.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                        {expandedRow !== row.id && (
                                          <img
                                            src="/down-grey-steps.svg"
                                            alt="Star Icon"
                                            className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                          />
                                        )}
                                      </td>
                                      <td className="text-center px-4 rounded-r">
                                        {/* Status and Button */}
                                        <div className="relative flex items-center justify-between w-full">
                                          {/* Status */}
                                          <span className="flex items-center">
                                            {/* Dropdown Button */}
                                            <button
                                              ref={(el) =>
                                                (statusButtonRefs.current[
                                                  `${row.id}`
                                                ] = el)
                                              }
                                              onClick={() => {
                                                setIsMenuOpen((prev) =>
                                                  prev === row.id
                                                    ? null
                                                    : row.id
                                                );
                                              }}
                                              className="flex items-center justify-center"
                                            >
                                              <img
                                                src="/three-dots.svg"
                                                alt="Actions"
                                                className="h-6 w-6 ml-4 object-contain"
                                              />
                                            </button>
                                          </span>
                                          <DropdownTest
                                            isOpen={
                                              dotMenuOpened &&
                                              isMenuOpen === row.id
                                            }
                                            buttonRef={
                                              statusButtonRefs.current[
                                                `${row.id}`
                                              ]
                                            } // Pass unique ref to the dropdown
                                          >
                                            <div className="absolute top-full right-0 text-xs mt-2 w-40 bg-white rounded-md shadow-lg z-50">
                                              <button
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setLoading(true);
                                                  handleStatusChangeCustomer(
                                                    e,
                                                    "rejected",
                                                    row.id
                                                  );
                                                }}
                                                className="block w-full text-left hover:bg-black hover:text-white px-4 py-2"
                                              >
                                                Reject Request
                                              </button>
                                              <button
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  handleStatusChangeCustomer(
                                                    e,
                                                    "approved",
                                                    row.id
                                                  );
                                                }}
                                                className="block w-full hover:bg-black hover:text-white text-left px-4 py-2"
                                              >
                                                Approve Request
                                              </button>
                                              <button className="block w-full hover:bg-black hover:text-white text-left px-4 py-2">
                                                Active Reject Request{" "}
                                              </button>
                                            </div>
                                          </DropdownTest>
                                        </div>
                                      </td>
                                    </tr>
                                    {expandedRow === row.id && (
                                      <tr>
                                        <td
                                          colSpan={10}
                                          className="bg-[#EEF7FD] w-full"
                                        >
                                          <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4  md:pt-6">
                                                <label
                                                  htmlFor="refId"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  From
                                                </label>
                                                <Tooltip
                                                  nametext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""
                                                  }
                                                  numbertext={
                                                    row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_number}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.unique_id}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.unique_id}`
                                                      : ""
                                                  }
                                                  currencytext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency.name
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.name}`
                                                      : `${row.currency.name}`
                                                  }
                                                  amounttext={
                                                    row.mode == "transfer"
                                                      ? row.from_account
                                                          .currency
                                                          .amount_in_currency
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.currency.amount_in_currency}`
                                                      : ``
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.mode == "deposit"
                                                      ? row.bank != null
                                                        ? `${row.bank.account_name}`
                                                        : ""
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode ==
                                                          "withdrawal" ||
                                                        row.mode == "bpay"
                                                      ? `${row.to_account.name}`
                                                      : row.mode == "transfer"
                                                      ? `${row.from_account.name}`
                                                      : ""}
                                                  </span>
                                                </Tooltip>

                                                <div className="mt-4"></div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Description
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.description}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      To
                                                    </span>
                                                  </label>
                                                  <Tooltip
                                                    nametext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : "Biller"
                                                    }
                                                    numbertext={
                                                      row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.unique_id}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_number}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""
                                                    }
                                                    currencytext={
                                                      row.mode == "transfer"
                                                        ? row.to_account
                                                            .currency.name
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.name}`
                                                        : `${row.currency.name}`
                                                    }
                                                    amounttext={
                                                      row.mode == "transfer" ||
                                                      row.mode == "bpay"
                                                        ? row.to_account
                                                            .currency
                                                            .amount_in_currency
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.currency.amount_in_currency}`
                                                        : ``
                                                    }
                                                  >
                                                    <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                      {row.mode == "deposit" ||
                                                      row.mode == "transfer"
                                                        ? `${row.to_account.name}`
                                                        : row.mode ==
                                                            "withdrawal_rtgs" ||
                                                          row.mode ==
                                                            "withdrawal_international" ||
                                                          row.mode ==
                                                            "withdrawal"
                                                        ? `${row.bank.account_name}`
                                                        : row.mode == "bpay"
                                                        ? `${row.bpay_details.biller_code} (${row.bpay_details.reference_number})`
                                                        : ""}
                                                    </span>
                                                  </Tooltip>
                                                </div>
                                              </div>
                                              <div className="flex flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 text-xs"
                                                  >
                                                    <span className="text-[#A6A6A6]">
                                                      Ip address
                                                    </span>
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.ip_address}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                            {/* Profile Details */}
                                            <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                              {/* Column 1 */}
                                              <div className="flex flex-col md:px-4 md:pt-6">
                                                <div className="mt-4">
                                                  <label
                                                    htmlFor="investmentType"
                                                    className="mb-1 text-xs text-[#A6A6A6]"
                                                  >
                                                    Initiated by
                                                  </label>
                                                  <div className="text-sm">
                                                    {row.created_by}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 2 */}
                                              <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                                <div className="md:border-l md:pl-4">
                                                  <label
                                                    htmlFor="investmentManagerFees"
                                                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                  >
                                                    Signatories
                                                  </label>
                                                  <div className="text-sm">
                                                    <span>
                                                      {row.approved_by} (
                                                      {formatDateTransaction(
                                                        row.date
                                                      )}
                                                      )
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Column 3 */}
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                              <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-4" colSpan="7">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>
                    )}
                    {transactionTableData != null && (
                      <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                        {/* Entries Info Section */}
                        <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                          Showing {showRecords * (currentPage - 1) + 1} to{" "}
                          {currentPage === totalPages || totalPages == 0
                            ? totalCount
                            : Math.max(
                                showRecords * currentPage,
                                transactionTableData.length
                              )}{" "}
                          of {totalCount} entries
                        </div>

                        {/* Pagination Section */}
                        <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                          {/* Previous Button */}
                          <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Prev
                          </button>

                          {/* Page Buttons */}
                          {Array.from({ length: Math.min(totalPages, 5) }).map(
                            (_, index) => {
                              const startPage = Math.max(
                                1,
                                Math.min(totalPages - 4, currentPage - 2)
                              );
                              const page = startPage + index;

                              return (
                                <button
                                  key={page}
                                  onClick={() => setCurrentPage(page)}
                                  className={`px-3 py-1 rounded ${
                                    currentPage === page
                                      ? "bg-black text-white"
                                      : "bg-white border border-gray-300 text-black"
                                  }`}
                                >
                                  {page}
                                </button>
                              );
                            }
                          )}

                          {/* Next Button */}
                          <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          {activeCard && activeCard.id == "2" && (
            <div>
              {loading && (
                <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
                  <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
              )}
              <div className={`p-4 shadow-md rounded-md ${activeCard.color}`}>
                <div className="flex justify-between items-center border-b border-colour-custom px-4 text-white">
                  {/* Left side: Icon and heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/cash-account.svg"
                      alt="User Avatar"
                      className="h-6 w-6 mb-2"
                    />
                    <h1 className="text-xl font-medium mb-2">
                      Private Wealth Portfolio
                    </h1>
                  </div>

                  {/* Right side: Add Stocks button */}
                  <button
                    onClick={togglePopupAddStocks}
                    className="text-sm mb-2 flex items-center text-black bg-white border-2 border-black py-2 px-3 rounded-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    <span className="font-medium text-sm">Add Stocks</span>
                  </button>
                </div>
                {isOpenStock && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 mb-4 h-[90vh] max-h-screen overflow-y-auto">
                      <div className="">
                        <div className="w-full max-w-4xl mx-auto px-2 ">
                          <div className="mb-6 relative px-4 sm:px-6">
                            {/* Add Button - stays in top-right on all devices */}
                            <button
                              onClick={togglePopupAddStocks}
                              className="absolute right-4 top-0 sm:right-0"
                            >
                              <img
                                src="/add.svg"
                                alt="Add"
                                className="w-10 h-10"
                              />
                            </button>

                            {/* Centered Heading and Info */}
                            <div className="flex flex-col items-center text-center gap-2 ">
                              <div className="flex flex-col sm:flex-row items-center gap-2">
                                <img
                                  src="/stock-black.svg"
                                  alt="Company Logo"
                                  className="w-6 h-6"
                                />
                                <h2 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 dark:text-gray-200">
                                  Add Trading Stocks
                                </h2>
                              </div>

                              <p className="text-sm text-gray-600 dark:text-gray-400 px-2 sm:px-4 break-words max-w-md">
                                Add stocks manually or using customer's HIN
                                number to upload them automatically.
                              </p>
                            </div>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Auto Fetch Section */}
                            <div className="bg-white dark:bg-[#1A1A1A] shadow-md rounded-xl p-6 border border-gray-200 dark:border-[#333]">
                              <label
                                htmlFor="hinNumber"
                                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                              >
                                Enter HIN Number to Auto-Fetch Stocks
                              </label>
                              <input
                                id="hinNumber"
                                name="hinNumber"
                                type="text"
                                value={hinNumber}
                                disabled={true}
                                placeholder="e.g. 1234567890"
                                onChange={(e) => {
                                  setHinNumber(e.target.value);
                                  setIsFetchExist(false);
                                  setManualEntryVisible(false);
                                  setIsFetchStrategyCheck(false);
                                }}
                                className="w-full rounded-md h-11 px-4 py-2 border border-gray-300 dark:border-[#4F4F4F] dark:bg-[#101010] dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-black"
                              />

                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  handleFetchStocks(e);
                                }}
                                // disabled={
                                //   !manualEntryVisible &&
                                //   hinNumber !== "" &&
                                //   !isfetchExist
                                //     ? false
                                //     : true
                                // }
                                disabled={true}
                                className={`mt-4 w-full text-sm font-medium py-2 px-4 rounded-full flex items-center justify-center gap-2 transition ${
                                  !manualEntryVisible &&
                                  hinNumber !== "" &&
                                  !isfetchExist
                                    ? "bg-black text-white"
                                    : "bg-gray-300 text-gray-600"
                                }`}
                              >
                                {/* SVG icon */}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-5 h-5"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M6 4v16m12-8v8m-6-12v12"
                                  />
                                </svg>
                                Fetch & Upload Stocks
                              </button>
                            </div>

                            {/* Manual Entry Section */}
                            <div className="bg-white dark:bg-[#1A1A1A] shadow-md rounded-xl p-6 border border-gray-200 dark:border-[#333]">
                              <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
                                Prefer to Add Manually?
                              </p>
                              <div className="flex flex-col gap-y-3">
                                {/* Add Manually Button */}
                                <button
                                  disabled={!!isfetchExist}
                                  onClick={() => {
                                    setManualEntryVisible((prev) => !prev);
                                    setManualStockList([]);
                                    setManualStockCode("");
                                    setManualQuantity("");
                                    setIsFetchExist(false);
                                  }}
                                  className={`w-full flex items-center justify-center gap-2 text-sm font-medium py-2 px-4 rounded-full transition-colors duration-300 ${
                                    hinNumber === "" && !isfetchExist
                                      ? "bg-black text-white"
                                      : "bg-gray-300 text-gray-600"
                                  }`}
                                >
                                  {manualEntryVisible ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-5 h-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={1.5}
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                      Cancel
                                    </>
                                  ) : (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-5 h-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={1.5}
                                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3l-8.5 8.5L10 14l.5-3.5 8-8z"
                                        />
                                      </svg>
                                      Add Manually
                                    </>
                                  )}
                                </button>

                                {/* Upload CSV Button */}
                                <label
                                  htmlFor="csvUpload"
                                  className="cursor-pointer w-full flex items-center justify-center gap-2 text-sm font-medium py-2 px-4 rounded-full bg-black text-white transition-colors duration-300"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-5 h-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={1.5}
                                      d="M4 4v16h16V4H4zm4 8h8M8 12v4m0-4V8"
                                    />
                                  </svg>
                                  Upload CSV
                                  <input
                                    id="csvUpload"
                                    type="file"
                                    accept=".csv"
                                    className="hidden"
                                    onChange={(e) => {
                                      const file = e.target.files?.[0];
                                      if (file) {
                                        setFile(file);
                                        setLoading(true);
                                        handleStockCSV(e, file);
                                        e.target.value = "";
                                      }
                                    }}
                                  />
                                </label>
                                {file && (
                                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                                    <span className="text-black">
                                      {file ? file.name : ""}
                                    </span>
                                    <button
                                      onClick={handleDeleteFile}
                                      className="text-red-500 flex-shrink-0 font-semibold"
                                    >
                                      <img
                                        src="/trash.svg"
                                        alt="Success Icon"
                                        className="h-4 w-4 flex-shrink-0"
                                      />
                                    </button>
                                  </div>
                                )}
                                <p
                                  onClick={() => {
                                    setLoading(true);
                                    handleSampleCSV();
                                  }}
                                  className="underline cursor-pointer text-sm font-medium text-gray-600 dark:text-gray-300 mb-4"
                                >
                                  Click to download a sample CSV file format
                                </p>
                              </div>
                            </div>
                          </div>
                          {manualEntryVisible && hinNumber == "" && (
                            <div className="mt-4 bg-white dark:bg-[#1e1e1e] shadow-md rounded-xl p-6 border border-gray-200">
                              <h3 className="text-base md:text-lg font-semibold text-black dark:text-white mb-3">
                                Stock Holdings
                              </h3>

                              <div className="overflow-x-auto max-h-[60vh] ">
                                <table className="min-w-full text-sm text-left border border-gray-200 dark:border-gray-700">
                                  <thead className="bg-[#ECFAFF] text-[#005A9C] text-xs md:text-sm">
                                    <tr>
                                      <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                                        Code
                                      </th>
                                      <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                                        Quantity
                                      </th>
                                      <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                                        Purchased Date
                                      </th>
                                      <th className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-center">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody className="text-black dark:text-gray-200">
                                    {/* Inline Input Row */}
                                    <tr className="bg-gray-50 dark:bg-[#2a2a2a]">
                                      <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                                        <input
                                          type="text"
                                          value={manualStockCode}
                                          onChange={(e) =>
                                            setManualStockCode(e.target.value)
                                          }
                                          placeholder="Stock Code"
                                          className="w-full px-2 py-1 text-sm rounded-md border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                                        />
                                      </td>
                                      <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                                        <input
                                          type="number"
                                          value={manualQuantity}
                                          onChange={(e) =>
                                            setManualQuantity(e.target.value)
                                          }
                                          placeholder="Qty"
                                          className="w-full rounded-md px-2 py-1 text-sm rounded border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                                        />
                                      </td>
                                      <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                                        <input
                                          type="date"
                                          value={manualPurchasedDate}
                                          onChange={(e) =>
                                            setManualPurchasedDate(
                                              e.target.value
                                            )
                                          }
                                          className="w-full rounded-md px-2 py-1 text-sm border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                                        />
                                      </td>
                                      <td className="w-40 px-4 py-2 border border-gray-300 dark:border-gray-700 text-center">
                                        <button
                                          onClick={handleAddManualStock}
                                          className="bg-[#005A9C] hover:bg-[#004b85] text-white text-xs font-medium py-1 px-3 rounded-full"
                                        >
                                          Add
                                        </button>
                                      </td>
                                    </tr>

                                    {/* Existing added manual rows */}
                                    {manualStockList.map((item, index) => (
                                      <tr
                                        key={index}
                                        className="hover:bg-[#f0faff] dark:hover:bg-[#2a2a2a] transition-colors"
                                      >
                                        {editIndex === index ? (
                                          <>
                                            {/* Code Input */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                                              <input
                                                type="text"
                                                value={editCode}
                                                onChange={(e) =>
                                                  setEditCode(e.target.value)
                                                }
                                                className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                                              />
                                            </td>

                                            {/* Quantity Input */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                                              <input
                                                type="number"
                                                value={editQuantity}
                                                onChange={(e) =>
                                                  setEditQuantity(
                                                    e.target.value
                                                  )
                                                }
                                                className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                                              />
                                            </td>

                                            {/* Purchased Date Input */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                                              <input
                                                type="date"
                                                value={editPurchasedDate}
                                                onChange={(e) =>
                                                  setEditPurchasedDate(
                                                    e.target.value
                                                  )
                                                }
                                                className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                                              />
                                            </td>

                                            {/* Action Buttons */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 text-center space-x-2">
                                              <button
                                                onClick={() =>
                                                  handleUpdateSave(index)
                                                }
                                                className="bg-green-500 hover:bg-green-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                                              >
                                                Save
                                              </button>
                                              <button
                                                onClick={() =>
                                                  setEditIndex(null)
                                                }
                                                className="bg-gray-500 hover:bg-gray-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                                              >
                                                Cancel
                                              </button>
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            {/* Code Text */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                                              {item.code}
                                            </td>

                                            {/* Quantity Text */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                                              {item.quantity.toLocaleString()}
                                            </td>

                                            {/* Purchased Date Text */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                                              {formatDateToDDMMYYYY(
                                                item.purcahsed_date
                                              ) || "—"}
                                            </td>

                                            {/* Action Buttons */}
                                            <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 text-center space-x-2">
                                              <button
                                                onClick={() =>
                                                  handleEdit(index)
                                                }
                                                className="bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                                              >
                                                Edit
                                              </button>
                                              <button
                                                onClick={() =>
                                                  handleDeleteManualStock(index)
                                                }
                                                className="bg-red-500 hover:bg-red-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                                              >
                                                Delete
                                              </button>
                                            </td>
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>

                              {/* Final Submit Button */}
                              {manualStockList.length > 0 && (
                                <div className="flex flex-col md:flex-row items-center justify-between mt-6 px-8 py-4 bg-[#FF5050] bg-opacity-20 shadow-md rounded-md space-y-4 md:space-y-0">
                                  {/* Text Section */}
                                  <div className="text-center md:text-left flex-1">
                                    <span className="block text-sm md:text-md font-medium text-black">
                                      Upload stock data
                                    </span>
                                  </div>

                                  {/* Button Section */}
                                  <div className="text-center md:text-right">
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setLoading(true);
                                        handleFetchStocks(e);
                                      }}
                                      disabled={
                                        !isFetchStrategyCheck ? false : true
                                      }
                                      className={`flex items-center justify-center space-x-2 font-medium py-2 px-4 rounded-full text-sm ${
                                        !isFetchStrategyCheck
                                          ? "bg-black text-white"
                                          : "bg-gray-300 text-gray-600"
                                      }`}
                                    >
                                      <span>Upload Now</span>
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="grid mt-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {activeCard.accounts.map((account) => (
                    <div
                      key={account.id}
                      className="border p-4 rounded-md shadow-md relative"
                    >
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="text-sm font-semibold text-white">
                            Account {account.id}
                          </h3>
                        </div>
                        <div className="relative  flex items-center space-x-2">
                          {/* Three-dot button */}
                          <button
                            ref={(el) =>
                              (buttonRefs.current[`${account.id}`] = el)
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleDropdownAccount(account.id);
                            }}
                            className="text-lg font-bold focus:outline-none"
                          >
                            ⋮
                          </button>

                          {/* Dropdown Menu */}
                          {activeDropdownId === account.id && (
                            <div className="absolute top-full right-0 mt-2 bg-white border border-gray-300 rounded-md shadow-lg text-sm z-50">
                              {options.map((option) => (
                                <button
                                  key={option}
                                  onClick={() =>
                                    handleOptionClick(option, account.id)
                                  }
                                  className="block w-full px-4 py-2 hover:bg-black hover:text-white text-left"
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-wrap md:flex-nowrap items-start justify-between gap-y-4 md:gap-4 w-full">
                        {/* Left Section */}
                        <div className="flex-1 pb-4 sm:border-b-0 sm:border-r pr-4 text-left">
                          <div className="font-medium">
                            <div className="flex flex-row items-center">
                              <p className="text-xs text-white mr-1">
                                Account Name
                              </p>
                              <img
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditClick(e, account);
                                }}
                                src="/edit-details.svg"
                                alt="Edit Icon"
                                className="w-3 h-3 cursor-pointer"
                              />
                            </div>
                            <p
                              onClick={() => {
                                dispatch(
                                  setInvestmentIDRedux(account.portfolio_id)
                                );
                                dispatch(setTabSelfRedux("view"));

                                let redirectState = {
                                  path: `/investment-details-customer/${activeCard.customerId}`,
                                  state: {
                                    from: location.pathname,
                                    historyStack: [
                                      ...(location.state?.historyStack || []),
                                      location.pathname,
                                    ],
                                  },
                                };
                                sessionStorage.setItem(
                                  "redirectAfterLogin",
                                  JSON.stringify(redirectState)
                                );
                                navigate(
                                  `/investment-details-customer/${activeCard.customerId}`,
                                  {
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  }
                                );
                              }}
                              className={`text-sm underline cursor-pointer`}
                            >
                              {account.account_name}
                            </p>
                          </div>
                          <div className="font-medium">
                            <div className="flex flex-row items-center">
                              <p className="text-xs text-white mr-1">
                                Portfolio Value
                              </p>
                            </div>
                            <p className={`text-sm`}>
                              $
                              {account.portfolio_value == 0
                                ? "0.00"
                                : account.portfolio_value
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </p>
                          </div>
                        </div>

                        {/* Right Section */}
                        <div className="flex-1 pb-4 mt-0 text-left">
                          <div className="font-medium">
                            <p className="text-xs text-white">Currency</p>
                            <p className="text-sm">{account.currency}</p>
                          </div>

                          <div className="mt-1 font-medium">
                            <p className="text-xs text-white">
                              Account Balance
                            </p>
                            <div className="flex flex-col md:items-start">
                              <p className="text-sm font-medium">
                                {account.balance
                                  .toFixed(2)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </p>
                            </div>
                          </div>
                          <div className="mt-1 font-medium">
                            <p className="text-xs text-white">Client ID</p>
                            <div className="flex flex-col md:items-start">
                              <span className="text-xs">
                                {!account.bd_client_id
                                  ? "Client ID not found"
                                  : account.bd_client_id}
                              </span>
                              {!account.bd_client_id && (
                                <button
                                  onClick={() => toggleClientPop(account.id)}
                                  className="text-xs mt-4 py-1 px-2 w-40 bg-black text-white text-sm rounded-xl"
                                >
                                  Add Client Id
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center justify-between mt-4">
                        {/* Left: Download Buttons */}
                        <div
                          ref={(el) =>
                            (buttonDownloadRefs.current[`${account.id}`] = el)
                          }
                          className="relative mt-4 sm:mt-0"
                        >
                          <button
                            onClick={() => toggleDownloadDropdown(account.id)}
                            className="flex items-center gap-2 font-medium bg-white text-black border border-gray-300 px-3 py-1.5 rounded-xl shadow-sm hover:bg-gray-100 text-sm"
                          >
                            Download Report
                            <svg
                              className="w-4 h-4 ml-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </button>

                          {isDownloadOpen === account.id && (
                            <div className="absolute left-0 mt-2 w-38 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
                              <button
                                onClick={() =>
                                  handleDownload(account.id, "pdf")
                                }
                                className="rounded-xl w-full text-left px-4 py-2 hover:bg-black hover:text-white text-sm text-black"
                              >
                                Download PDF
                              </button>
                              <button
                                onClick={() =>
                                  handleDownload(account.id, "excel")
                                }
                                className="rounded-xl w-full text-left px-4 py-2 hover:bg-black hover:text-white text-sm text-black"
                              >
                                Download Excel
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Right: Tooltip Icon */}
                        <div
                          className="relative flex items-center ml-auto"
                          onMouseEnter={() => setTooltipVisible(account.id)}
                          onMouseLeave={() => setTooltipVisible(null)}
                        >
                          <button>
                            <img
                              src={
                                tooltipVisible === account.id
                                  ? "/tooltip-white.svg"
                                  : "/tooltip-black.svg"
                              }
                              alt="Tooltip Icon"
                              className="h-4 w-4"
                            />
                          </button>

                          {tooltipVisible === account.id && (
                            <div className="font-medium absolute bottom-full right-0 mb-2 bg-white text-xs p-2 rounded shadow-lg z-50">
                              <div className="relative">
                                <span className="text-[#888888]">
                                  Type:{" "}
                                  <span className="text-[#595959]">
                                    Private Wealth Account
                                  </span>
                                </span>
                                <br />
                                <span className="text-[#888888]">
                                  Created:{" "}
                                  <span className="text-[#595959]">
                                    {formatDateList(account.created_at)}
                                  </span>
                                </span>
                                <div className="absolute -bottom-2 right-1 w-3 h-2 bg-white transform rotate-45"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isClientPopupOpen === account.id && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                          <div className="bg-white rounded-lg w-[90%] md:w-[500px] p-6">
                            {/* Modal Header */}
                            <div className="flex items-center justify-between mb-4">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add Client ID
                              </h2>
                              <button
                                onClick={() => toggleClientPop(account.id)}
                              >
                                <img
                                  src="/add.svg"
                                  alt="Close"
                                  className="w-10 h-10"
                                />
                              </button>
                            </div>

                            {/* Modal Body */}
                            <div className="grid grid-cols-1 gap-6 items-center">
                              <div className="space-y-4 mx-auto ">
                                <div className="mb-4 relative">
                                  <label
                                    htmlFor="password"
                                    className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                                  >
                                    Enter Client ID
                                  </label>
                                  <input
                                    type="text"
                                    value={hinClientId}
                                    required={true}
                                    id="currentpassword"
                                    onChange={(e) =>
                                      sethinClientId(e.target.value)
                                    }
                                    className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="Client Id"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="flex justify-center space-x-4 mt-6">
                              <button
                                onClick={() => toggleClientPop(account.id)}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!hinClientId) {
                                    showToast(
                                      "Please enter client ID",
                                      "error"
                                    );
                                    return;
                                  }
                                  setLoading(true);
                                  handleUpdateHinNumber(e, account.id);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* uncomment tooltip fund account */}
                      {/* <div
                        className="relative flex justify-end"
                        onMouseEnter={() => setTooltipVisible(account.id)}
                        onMouseLeave={() => setTooltipVisible(null)}
                      >
                        {tooltipVisible === account.id && (
                          <button className="">
                            <img
                              src="/tooltip-white.svg"
                              alt="Success Icon"
                              className="h-4 w-4"
                            />
                          </button>
                        )}
                        {tooltipVisible !== account.id && (
                          <button className="">
                            <img
                              src="/tooltip-black.svg"
                              alt="Success Icon"
                              className="h-4 w-4"
                            />
                          </button>
                        )}
                        {tooltipVisible === account.id && (
                          <div className="font-medium absolute bottom-full right-[-10px] mb-2 bg-white text-xs p-2 rounded shadow-lg z-50">
                            <div className="relative">
                              <span className="text-[#888888]">
                                Type:{" "}
                                <span className="text-[#595959]">
                                  {account.type}
                                </span>
                              </span>
                              <br />
                              <span className="text-[#888888]">
                                Created:{" "}
                                <span className="text-[#595959]">
                                  {formatDateList(account.created_at)}
                                </span>
                              </span>
                              <div className="absolute -bottom-2 right-1 w-3 h-2 bg-white transform rotate-45"></div>
                            </div>
                          </div>
                        )}
                      </div> */}
                    </div>
                  ))}
                </div>
              </div>
              {isModalOpenAccountEdit && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Edit Account Details
                        </h2>
                        <div className="flex justify-end">
                          <img
                            onClick={() => {
                              setcurrentAccount(null);
                              setIsModalOpenAccountEdit(false);
                            }}
                            src="/add.svg"
                            alt="Add"
                            className="w-10 h-10 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 pt-4 px-4">
                          {/* Code */}
                          <div>
                            <label
                              htmlFor="acccountName"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Account Name
                            </label>{" "}
                            <input
                              id="acccountName"
                              type="text"
                              value={acccountName}
                              onChange={(e) => setAccountName(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="John Doe"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Description
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={accountDescription}
                              onChange={(e) =>
                                setAccountDescription(e.target.value)
                              }
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Add text.."
                            />
                          </div>
                        </div>

                        {/* Center Column with Border */}
                        <div className="space-y- lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Fees
                            </label>
                            <input
                              type="text"
                              name="field2"
                              value={
                                isFocusedAccountFee
                                  ? minimumInvestment
                                  : formatNumber(minimumInvestment)
                              }
                              ref={inputRefAccountFee}
                              onChange={(e) => {
                                if (!isFocusedAccountFee) return;
                                handleChangeAmountFee(e, e.target.value);
                              }}
                              onFocus={() => setIsFocusedAccountFee(true)}
                              onBlur={() => setIsFocusedAccountFee(false)}
                              className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                            />
                          </div>
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 px-4 pt-4">
                          <div>
                            {" "}
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Fee Buffer Amount
                            </label>
                            <input
                              type="text"
                              name="field2"
                              value={
                                isFocusedAccountFeeBuffer
                                  ? bufferAmount
                                  : formatNumber(bufferAmount)
                              }
                              ref={inputRefAccountFeeBuffer}
                              onChange={(e) => {
                                if (!isFocusedAccountFeeBuffer) return;
                                handleChangeAmountFeeBuffer(e, e.target.value);
                              }}
                              onFocus={() => setIsFocusedFeeBuffer(true)}
                              onBlur={() => setIsFocusedFeeBuffer(false)}
                              className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                        <button
                          onClick={() => {
                            setcurrentAccount(null);
                            setIsModalOpenAccountEdit(false);
                          }}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (!acccountName) {
                              showToast("Account name is required", "error");
                              return;
                            }
                            setLoading(true);
                            handleEditAccount(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Update Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="w-full mt-4 p-4 bg-white rounded-lg shadow-lg  relative">
                <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
                  <div className="flex items-center">
                    <img
                      src="/profile-black.svg"
                      alt="Company Logo"
                      className="mr-3"
                    />
                    <span className="font-medium lg:text-xl text-sm">
                      Uploaded stock list
                    </span>
                  </div>
                  <div className="mt-1 font-medium">
                    <div className="flex flex-col md:flex-row md:items-center gap-1">
                      <p className="text-sm text-black min-w-[40px]">
                        Client ID:
                      </p>

                      <div className="flex flex-col md:flex-row md:items-center gap-2">
                        <span className="text-sm text-labelColour">
                          {!bdClientId ? "Client ID not found" : bdClientId}
                        </span>

                        {!bdClientId && (
                          <button
                            onClick={() => toggleClientPopupUA()}
                            className="text-xs py-1 px-2 bg-black text-white rounded-xl w-fit"
                          >
                            Add Client ID
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {isClientPopupOpenUA && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[500px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Add Client ID
                        </h2>
                        <button onClick={() => toggleClientPopupUA()}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Enter Client ID
                            </label>
                            <input
                              type="text"
                              value={hinOverallClientId}
                              required={true}
                              id="currentpassword"
                              onChange={(e) =>
                                setHinOverallClientId(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Client Id"
                            />
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-xs mt-2 text-labelColour"
                            >
                              The ID must contain more than 5 digits.
                            </label>{" "}
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={() => toggleClientPopupUA()}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (!hinOverallClientId) {
                              showToast("Please enter client ID", "error");
                              return;
                            }
                            if (hinOverallClientId.length <= 5) {
                              showToast(
                                "Please enter a valid ID with more than 5 digits.",
                                "error"
                              );
                              return;
                            }
                            setLoading(true);
                            handleUpdateHinNumberOverall(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                  <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                    <div className="flex items-center space-x-2">
                      <span className="lg:text-md  text-sm text-[#8C8C8C]">
                        Show Records
                      </span>
                      <Dropdown
                        label=""
                        options={filterOptions}
                        preselectedValue={preSelectedFilterUnallocated}
                        onSelect={handleFilterChange}
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-4 items-center">
                    {/* Remove Button */}
                    <div className="w-full sm:w-auto">
                      <button
                        onClick={(e) => {
                          if (selectedCustomers.length == 0) {
                            return;
                          }
                          if (!bdClientId) {
                            showToast(
                              "Please add client id before any action",
                              "error"
                            );
                            return;
                          }
                          setLoading(true);
                          handleUpdateAccept(e, "approve");
                        }}
                        className="bg-[#34C046] border-[#34C046] border-2 bg-opacity-100 text-white w-full sm:w-auto  font-semibold h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                      >
                        <div className="flex items-center">
                          <img
                            src="/green-selected.svg"
                            alt="Remove Icon"
                            className="h-5 w-5 mr-2"
                          />
                          Approve
                        </div>
                      </button>
                    </div>
                    <div className="w-full sm:w-auto">
                      <button
                        onClick={(e) => {
                          if (selectedCustomers.length == 0) {
                            return;
                          }
                          if (!bdClientId) {
                            showToast(
                              "Please add client id before any action",
                              "error"
                            );
                            return;
                          }
                          setLoading(true);
                          handleUpdateAccept(e, "reject");
                        }}
                        className="bg-opacity-100 text-white bg-[#FF5050] border-[#FF5050] border-2  bg-opacity-100 text-white w-full sm:w-auto font-semibold h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                      >
                        <div className="flex items-center">
                          <img
                            src="/red-selected.svg"
                            alt="Remove Icon"
                            className="h-5 w-5 mr-2"
                          />
                          Reject
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  {/* Table */}
                  <div className="overflow-x-auto">
                    <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                      {/* Table Header */}
                      <thead className="text-labelColour bg-[#F9F9F9] text-sm">
                        <tr className="mb-4">
                          <th
                            key="1"
                            className="cursor-pointer font-medium px-4 py-2 border rounded-l text-left"
                          >
                            <div className="flex items-center">
                              <input
                                type="checkbox"
                                id="selectUser"
                                checked={selectAll} // Bind to Select All state
                                onChange={toggleSelectAll} // Handle toggle
                                className="custom-checkbox h-3 w-3 mr-2"
                              />{" "}
                              <span>All</span>
                            </div>
                          </th>

                          {/* Dynamic Headers */}
                          {unallocatedHeaders.map((header) => (
                            <th
                              onClick={() => handleSort(header.key)}
                              key={header.label}
                              className="cursor-pointer font-medium px-4 py-2  border text-left"
                            >
                              <div className="flex items-center justify-between w-full">
                                <span>{header.label}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(10)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm mt-4 font-medium text-black">
                          {unAllocatedList.map((account) => (
                            <tr className="px-6 py-2 bg-white">
                              <td className="px-6 rounded-l border-r-0 border py-2">
                                {/* <input
                                  type="checkbox"
                                  id="selectUser"
                                  checked={selectedCustomers.some(
                                    (c) => c.id === account.id
                                  )} 
                                  onChange={() => toggleTableSelection(account)}
                                  disabled={account.status !== "PENDING"}
                                  className="custom-checkbox h-4 w-4 rounded"
                                /> */}
                                <div className="relative group inline-block">
                                  <input
                                    type="checkbox"
                                    id="selectUser"
                                    checked={selectedCustomers.some(
                                      (c) => c.id === account.id
                                    )}
                                    onChange={() =>
                                      toggleTableSelection(account)
                                    }
                                    disabled={account.status !== "PENDING"}
                                    className={`custom-checkbox h-4 w-4 rounded 
      ${
        account.status !== "PENDING"
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer"
      }`}
                                  />

                                  {/* Tooltip */}
                                  {account.status !== "PENDING" && (
                                    <div className="absolute left-1/2 top-7 -translate-x-[10%] z-[999] hidden group-hover:block w-max max-w-[200px] bg-gray-300 text-black text-xs px-3 py-1 rounded-md shadow-md border text-center">
                                      Selection allowed only for pending stocks
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="px-4 py-2 w-40 border-b border-t relative">
                                {account.stock_asx}
                              </td>
                              <td className=" cursor-pointer px-4 py-6 border-b border-t text-left min-w-[200px] max-w-[600px] font-medium flex items-center space-x-2">
                                {account.stock_name}
                              </td>

                              <td className="px-4 py-2 w-40 border-b border-t relative">
                                {account.quantity
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>

                              {/* Dropdown Button */}

                              <td className="px-4 py-2 border-b border-t  text-ellipsis overflow-hidden whitespace-nowrap">
                                <div className="flex items-center space-x-2">
                                  <img
                                    src="/clock.svg"
                                    alt="Time Icon"
                                    className="h-4 w-4"
                                  />
                                  <span className="rounded-xl">
                                    {formatDateTime(account.purchase_date)}
                                  </span>
                                </div>
                              </td>
                              <td className="px-4 py-2 w-40 border-b border-t relative rounded-r border-l-0 border">
                                {account.status}
                              </td>
                            </tr>
                          ))}{" "}
                        </tbody>
                      )}
                    </table>
                  </div>

                  <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                    {/* Entries Info Section */}
                    <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                      Showing{" "}
                      {showRecordsUnallocated * (currentPageUnallocated - 1) +
                        1}{" "}
                      to{" "}
                      {currentPageUnallocated === totalPagesUnallocated ||
                      totalPagesUnallocated == 0
                        ? totalCountUnallocated
                        : Math.max(
                            showRecordsUnallocated * currentPageUnallocated,
                            unAllocatedList.length
                          )}{" "}
                      of {totalCountUnallocated} entries
                    </div>

                    {/* Pagination Section */}
                    <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                      {/* Previous Button */}
                      <button
                        disabled={currentPageUnallocated === 1}
                        onClick={() =>
                          setCurrentPageUnallocated((prev) => prev - 1)
                        }
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Prev
                      </button>

                      {/* Page Buttons */}
                      {Array.from({
                        length: Math.min(totalPagesUnallocated, 5),
                      }).map((_, index) => {
                        const startPage = Math.max(
                          1,
                          Math.min(
                            totalPagesUnallocated - 4,
                            currentPageUnallocated - 2
                          )
                        );
                        const page = startPage + index;

                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPageUnallocated(page)}
                            className={`px-3 py-1 rounded ${
                              currentPageUnallocated === page
                                ? "bg-black text-white"
                                : "bg-white border border-gray-300 text-black"
                            }`}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {/* Next Button */}
                      <button
                        disabled={
                          currentPageUnallocated === totalPagesUnallocated
                        }
                        onClick={() =>
                          setCurrentPageUnallocated((prev) => prev + 1)
                        }
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
                <div className="py-6 px-4 bg-white">
                  <div className="mb-4 flex flex-wrap justify-between items-center"></div>
                  <div className="mb-4 flex flex-wrap items-center justify-between">
                    <div className="flex text-sm md:text-md">
                      {["1M", "3M", "6M", "1Y", "All"].map((filter, index) => (
                        <button
                          key={filter}
                          className={`px-3 py-2 shadow-md ${
                            filter === "All" ? "rounded-r-xl" : ""
                          } ${filter === "1M" ? "rounded-l-xl" : ""} ${
                            selectedFilter === filter
                              ? "bg-black text-white"
                              : "bg-white text-black"
                          }`}
                          onClick={() => setSelectedFilter(filter)}
                        >
                          {filter}
                        </button>
                      ))}
                    </div>

                    <div className="mt-2 md:mt-0">
                      <button className="bg-white text-black pl-2 pr-6 py-1 h-10 whitespace-nowrap border-gray-300 border rounded-lg flex items-center">
                        <img
                          src="/presention-chart.svg" // Replace with the actual path to your image
                          alt="Graph Icon"
                          className="h-5 w-5 mr-2" // Adjust size and spacing as needed
                        />
                        Generate Graph
                      </button>
                    </div>
                  </div>

                  <div style={{ width: "100%", height: "400px" }}>
                    <Line data={dataLine} options={optionsLine} />
                  </div>
                </div>
              </div>

              <div className="bg-white mt-2 p-4 px-4 shadow-md rounded-md">
                <div className="flex justify-between items-center border-b border-colour-custom px-4 py-2 flex-wrap">
                  {/* Left: Title */}
                  <h1 className="text-xl font-medium text-black mb-2">
                    Transaction History
                  </h1>

                  {/* Right: Download Dropdown */}
                  <div
                    ref={DownloadRef}
                    className="relative inline-block mt-2 sm:mt-0"
                  >
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() =>
                        setIsOpenDownloadReport(!isOpenDownloadReport)
                      }
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2 ml-auto"
                      />
                    </div>

                    {isOpenDownloadReport && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-[99]">
                        {reportOptions.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDFTable(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="p-4">
                  {/* Filters Section */}
                  <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleshowRecord}
                        />
                      </div>
                      <div className="flex items-center">
                        <div className="relative">
                          <input
                            type="text"
                            className="p-2 pl-8 border rounded-xl"
                            placeholder="Search Here"
                            value={searchQuery}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setCurrentPage(1);
                            }}
                          />
                          <span className="absolute left-2 top-3 text-gray-500">
                            {" "}
                            <img
                              src="/search-normal.svg"
                              alt="Company Logo"
                              className="mr-2"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                      <div
                        ref={DateCalendarRef}
                        className="flex items-center  w-full space-x-4"
                      >
                        <div className="relative w-full">
                          {/* Dropdown Trigger */}
                          <div
                            className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                            onClick={toggleDropdown}
                          >
                            <span>{selectedRange}</span>
                            <img
                              src={
                                isDropdownOpen
                                  ? "/open-dropdown.svg"
                                  : "/download-small-arrow.svg"
                              }
                              alt="Dropdown Icon"
                              className="h-2 w-2 transition-transform duration-300 transform"
                            />
                          </div>

                          {/* Dropdown */}
                          {isDropdownOpen && (
                            <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] lg:w-[700px] max-h-[400px] overflow-auto">
                              <div className="flex  flex-col md:flex-row h-full">
                                {/* Left: Quick Filters */}
                                <div className="w-full md:w-1/3 border-r p-3 h-full">
                                  {quickFilters.map((filter) => (
                                    <div
                                      key={filter.value}
                                      className={`p-2 cursor-pointer rounded ${
                                        quickFilter === filter.value
                                          ? "bg-black text-white"
                                          : "hover:bg-gray-200 text-black"
                                      } transition-all duration-200 ease-in-out`}
                                      onClick={() =>
                                        handleQuickFilter(filter.value)
                                      }
                                    >
                                      {filter.label}
                                    </div>
                                  ))}
                                </div>

                                {/* Right: Calendar */}
                                <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                  <Flatpickr
                                    key={selectedDates}
                                    options={{
                                      mode: "range",
                                      inline: true,
                                      dateFormat: "Y-m-d",
                                      showMonths: 2,
                                      defaultDate:
                                        selectedDates.length > 0
                                          ? selectedDates
                                          : [],
                                      shorthandCurrentMonth: true,
                                      locale: {
                                        firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                      },
                                      onChange: (dates) => {
                                        if (
                                          quickFilter === "custom" &&
                                          dates.length === 2
                                        ) {
                                          setSelectedDates(dates);
                                        }
                                      },
                                    }}
                                    className="w-full"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        ref={accountRef}
                        className="relative w-full mt-4 md:mt-0 md:w-full"
                      >
                        {/* Dropdown Button */}
                        <button
                          onClick={() => setIsOpen(!isOpen)}
                          className="w-full  font-medium border-gray-300  rounded-xl text-sm  py-2 flex items-center justify-between focus:outline-none bg-white text-black"
                        >
                          <div
                            className="flex items-center justify-between p-2 w-full md:w-40 border rounded-xl bg-white cursor-pointer"
                            onClick={toggleDropdown}
                          >
                            {/* Dropdown Text */}
                            <span className="">
                              {selectedAccounts.length > 0 &&
                              selectedAccounts.includes("ALL")
                                ? "ALL"
                                : "Select Account"}
                            </span>
                            {/* Dropdown Icon */}
                            <img
                              src={
                                isOpen
                                  ? "/open-dropdown.svg"
                                  : "/download-small-arrow.svg"
                              }
                              alt="Dropdown Icon"
                              className="h-2 w-2 transition-transform duration-300 transform"
                            />
                          </div>
                        </button>

                        {/* Dropdown List */}
                        {isOpen && (
                          <div
                            className="absolute text-xs left-0 mt-2 overflow-y-auto mb-5 md:w-60 w-full bg-white border rounded-md shadow-lg z-50"
                            style={{
                              maxHeight: "200px", // Optional: limit height
                            }}
                          >
                            <div className="p-2">
                              <input
                                type="text"
                                value={searchAccount}
                                onChange={(e) =>
                                  setSearchAccount(e.target.value)
                                }
                                placeholder="Search..."
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                              />
                            </div>
                            {AllAccount.filter((option) =>
                              option.label
                                .toLowerCase()
                                .includes(searchAccount.toLowerCase())
                            ).map((option) => (
                              <div
                                key={option.value}
                                className={`px-4 py-2 flex items-center cursor-pointer ${
                                  selectedAccounts.includes(option.value)
                                    ? "text-white bg-black"
                                    : "text-black bg-white"
                                }`}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedAccounts.includes(
                                    option.value
                                  )}
                                  onChange={() =>
                                    handleAccountListChange(option)
                                  }
                                  className="custom-checkbox"
                                />
                                <span
                                  onClick={() =>
                                    handleAccountListChange(option)
                                  }
                                  className="ml-2"
                                >
                                  {option.label}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className="relative w-full mt-4 md:mt-0 md:w-full">
                        {/* Dropdown Button */}
                        <button
                          onClick={() => {
                            resetAllFilters();
                          }}
                          className={`w-full md:w-full font-medium h-10 rounded-xl text-xs flex justify-between items-center focus:outline-none underline text-[#FF5050] `}
                        >
                          <div className="flex items-center relative">
                            Clear All
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  {transactionTableData != null && (
                    <div className="overflow-x-auto">
                      <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                        <thead className="text-[#8C8C8C] text-sm">
                          <tr className="border border-[#EDEDED]">
                            {headers.map((header, index) => (
                              <th
                                key={header.label}
                                className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 8
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                              >
                                <div class="flex items-center">
                                  <span>{header.label}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        </thead>

                        {isLoading ? (
                          <tbody className="shimmer-container-list ">
                            {/* Creating 5 rows of shimmer effect */}
                            {[...Array(5)].map((_, rowIndex) => (
                              <tr key={rowIndex} className="shimmer-row-list">
                                {/* Creating 7 cells in each row for shimmer */}
                                {[...Array(7)].map((_, colIndex) => (
                                  <td
                                    key={colIndex}
                                    className="shimmer-cell-list"
                                  >
                                    <div className="shimmer-loader"></div>
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <tbody className="text-sm font-medium text-black">
                            {transactionTableData.length > 0 ? (
                              transactionTableData.map((row, index) => (
                                <React.Fragment key={index}>
                                  <tr
                                    className={`cursor-pointer mb-2 ${
                                      expandedRow === row.id
                                        ? "bg-[#EBF3F8]"
                                        : "bg-[#F9F9F9]"
                                    }`}
                                  >
                                    <td className="px-4 py-2">
                                      <div className="flex items-center space-x-2">
                                        <img
                                          src="/clock.svg"
                                          alt="Time Icon"
                                          className="h-4 w-4"
                                        />
                                        <span className="rounded-xl">
                                          {`${formatDateTransaction(row.date)}`}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      {row.reference_code}
                                    </td>
                                    <td className="p-2">{row.account_name}</td>
                                    <td className="p-2">
                                      {row.convert_rate.toFixed(2)}
                                    </td>
                                    <td className="p-2">{row.currency.name}</td>
                                    <td className="p-2  text-[#FF5050]">
                                      {row.currency.symbol}
                                      {row.currency.symbol}{" "}
                                      {row.debit
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2  text-[#62D76E]">
                                      {row.currency.symbol}
                                      {row.currency.symbol}
                                      {row.credit
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2">
                                      {row.balance
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>

                                    <td className="px-4 py-2 relative">
                                      <button
                                        ref={(el) =>
                                          (statusButtonRefs.current[
                                            `${row.id}`
                                          ] = el)
                                        }
                                        disabled={
                                          row.status == "pending" ? false : true
                                        }
                                        onClick={() =>
                                          handleDropdownToggle(row.id)
                                        }
                                        className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                          row.status == "pending"
                                            ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                            : ""
                                        }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "cancelled"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                      >
                                        <span className="mr-6">
                                          {" "}
                                          {row.status.charAt(0).toUpperCase() +
                                            row.status.slice(1)}
                                        </span>
                                        {filter == "" &&
                                          row.status != "approved" && (
                                            <img
                                              src={`${
                                                openDropdown === row.id
                                                  ? "/Vector.svg"
                                                  : "/down-grey.svg"
                                              }`}
                                              alt="Selected"
                                              className="w-3 h-3 ml-4"
                                            />
                                          )}
                                      </button>
                                    </td>
                                    <td
                                      onClick={() => toggleRowDetails(row.id)}
                                      className="text-center rounded-r"
                                    >
                                      {expandedRow === row.id && (
                                        <img
                                          src="/expanded-black.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                      {expandedRow !== row.id && (
                                        <img
                                          src="/down-grey-steps.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  {expandedRow === row.id && (
                                    <tr>
                                      <td
                                        colSpan={10}
                                        className="bg-[#EEF7FD] w-full"
                                      >
                                        <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4  md:pt-6">
                                              <label
                                                htmlFor="refId"
                                                className="mb-1 text-xs text-[#A6A6A6]"
                                              >
                                                From
                                              </label>
                                              <Tooltip
                                                nametext={row.from_account.name}
                                                numbertext={
                                                  row.from_account.unique_id
                                                }
                                                currencytext={row.currency.name}
                                              >
                                                <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                  {row.from_account.name}
                                                </span>
                                              </Tooltip>

                                              <div className="mt-4"></div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Description
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.description}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    To
                                                  </span>
                                                </label>
                                                <Tooltip
                                                  nametext={row.to_account.name}
                                                  numbertext={
                                                    row.to_account.unique_id
                                                  }
                                                  currencytext={
                                                    row.currency.name
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.to_account.name}
                                                  </span>
                                                </Tooltip>
                                              </div>
                                            </div>
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Ip address
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.ip_address}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4 md:pt-6">
                                              <div className="mt-4">
                                                <label
                                                  htmlFor="investmentType"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  Initiated by
                                                </label>
                                                <div className="text-sm">
                                                  {row.created_by}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                >
                                                  Signatories
                                                </label>
                                                <div className="text-sm">
                                                  <span>
                                                    {row.approved_by} (
                                                    {formatDateTransaction(
                                                      row.date
                                                    )}
                                                    )
                                                  </span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center py-4" colSpan="7">
                                  No results found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  )}
                  {transactionTableData != null && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing {showRecords * (currentPage - 1) + 1} to{" "}
                        {currentPage === totalPages || totalPages == 0
                          ? totalCount
                          : Math.max(
                              showRecords * currentPage,
                              transactionTableData.length
                            )}{" "}
                        of {totalCount} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({ length: Math.min(totalPages, 5) }).map(
                          (_, index) => {
                            const startPage = Math.max(
                              1,
                              Math.min(totalPages - 4, currentPage - 2)
                            );
                            const page = startPage + index;

                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${
                                  currentPage === page
                                    ? "bg-black text-white"
                                    : "bg-white border border-gray-300 text-black"
                                }`}
                              >
                                {page}
                              </button>
                            );
                          }
                        )}

                        {/* Next Button */}
                        <button
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomCardSlider;
